/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: string;
  AWSDateTime: string;
  AWSEmail: string;
  AWSIPAddress: string;
  AWSJSON: string;
  AWSPhone: string;
  AWSTime: string;
  AWSTimestamp: number;
  AWSURL: string;
  /** The Circle scalar type represents a circle, defined by the coordinates of its center and a radius. The Circle type is used to represent a searchable area together with the '_within_circle' filter. */
  Circle: any;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  DateTime: any;
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  Dimension: any;
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  HexColor: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  Quality: any;
  /** The Rectangle scalar type represents a rectangle, defined by the coordinates of its top left and bottom right corners. The Rectangle type is used to represent a searchable area together with the '_within_rectangle' filter. */
  Rectangle: any;
};

export type AwsDateTimeFilter = {
  distinctFrom?: InputMaybe<Scalars['AWSDateTime']>;
  equalTo?: InputMaybe<Scalars['AWSDateTime']>;
  greaterThan?: InputMaybe<Scalars['AWSDateTime']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['AWSDateTime']>;
  in?: InputMaybe<Array<Scalars['AWSDateTime']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['AWSDateTime']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['AWSDateTime']>;
  notDistinctFrom?: InputMaybe<Scalars['AWSDateTime']>;
  notEqualTo?: InputMaybe<Scalars['AWSDateTime']>;
  notIn?: InputMaybe<Array<Scalars['AWSDateTime']>>;
};

export type AwsjsonFilter = {
  containedBy?: InputMaybe<Scalars['AWSJSON']>;
  contains?: InputMaybe<Scalars['AWSJSON']>;
  containsAllKeys?: InputMaybe<Array<Scalars['String']>>;
  containsAnyKeys?: InputMaybe<Array<Scalars['String']>>;
  containsAsInsensitiveText?: InputMaybe<Scalars['String']>;
  containsInInsensitiveValue?: InputMaybe<Scalars['String']>;
  containsKey?: InputMaybe<Scalars['String']>;
  distinctFrom?: InputMaybe<Scalars['AWSJSON']>;
  equalTo?: InputMaybe<Scalars['AWSJSON']>;
  greaterThan?: InputMaybe<Scalars['AWSJSON']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['AWSJSON']>;
  in?: InputMaybe<Array<Scalars['AWSJSON']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['AWSJSON']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['AWSJSON']>;
  notDistinctFrom?: InputMaybe<Scalars['AWSJSON']>;
  notEqualTo?: InputMaybe<Scalars['AWSJSON']>;
  notIn?: InputMaybe<Array<Scalars['AWSJSON']>>;
};

/** Creates a tenant, which is a subdivision with its own content and landing pages. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/academy) */
export type Academy = Entry & {
  __typename?: 'Academy';
  academyId?: Maybe<Scalars['String']>;
  academyTag?: Maybe<TopicTag>;
  academyTitle?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  footerLinksCollection?: Maybe<AcademyFooterLinksCollection>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  linkedFrom?: Maybe<AcademyLinkingCollections>;
  sys: Sys;
};


/** Creates a tenant, which is a subdivision with its own content and landing pages. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/academy) */
export type AcademyAcademyIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a tenant, which is a subdivision with its own content and landing pages. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/academy) */
export type AcademyAcademyTagArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Creates a tenant, which is a subdivision with its own content and landing pages. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/academy) */
export type AcademyAcademyTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a tenant, which is a subdivision with its own content and landing pages. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/academy) */
export type AcademyFooterLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Creates a tenant, which is a subdivision with its own content and landing pages. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/academy) */
export type AcademyIsPrimaryArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a tenant, which is a subdivision with its own content and landing pages. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/academy) */
export type AcademyLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AcademyCollection = {
  __typename?: 'AcademyCollection';
  items: Array<Maybe<Academy>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AcademyFilter = {
  AND?: InputMaybe<Array<InputMaybe<AcademyFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AcademyFilter>>>;
  academyId?: InputMaybe<Scalars['String']>;
  academyId_contains?: InputMaybe<Scalars['String']>;
  academyId_exists?: InputMaybe<Scalars['Boolean']>;
  academyId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  academyId_not?: InputMaybe<Scalars['String']>;
  academyId_not_contains?: InputMaybe<Scalars['String']>;
  academyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  academyTag?: InputMaybe<CfTopicTagNestedFilter>;
  academyTag_exists?: InputMaybe<Scalars['Boolean']>;
  academyTitle?: InputMaybe<Scalars['String']>;
  academyTitle_contains?: InputMaybe<Scalars['String']>;
  academyTitle_exists?: InputMaybe<Scalars['Boolean']>;
  academyTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  academyTitle_not?: InputMaybe<Scalars['String']>;
  academyTitle_not_contains?: InputMaybe<Scalars['String']>;
  academyTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  footerLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  isPrimary_exists?: InputMaybe<Scalars['Boolean']>;
  isPrimary_not?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type AcademyFooterLinksCollection = {
  __typename?: 'AcademyFooterLinksCollection';
  items: Array<Maybe<ElementText>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AcademyLinkingCollections = {
  __typename?: 'AcademyLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  eventCollection?: Maybe<EventCollection>;
  homeCollection?: Maybe<HomeCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
  learningConceptCollection?: Maybe<LearningConceptCollection>;
  opportunityCollection?: Maybe<OpportunityCollection>;
};


export type AcademyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AcademyLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AcademyLinkingCollectionsHomeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AcademyLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AcademyLinkingCollectionsLearningConceptCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AcademyLinkingCollectionsOpportunityCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AcademyOrder {
  AcademyIdAsc = 'academyId_ASC',
  AcademyIdDesc = 'academyId_DESC',
  AcademyTitleAsc = 'academyTitle_ASC',
  AcademyTitleDesc = 'academyTitle_DESC',
  IsPrimaryAsc = 'isPrimary_ASC',
  IsPrimaryDesc = 'isPrimary_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  contentType?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
  transform?: InputMaybe<ImageTransformOptions>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']>;
  contentType_contains?: InputMaybe<Scalars['String']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentType_not?: InputMaybe<Scalars['String']>;
  contentType_not_contains?: InputMaybe<Scalars['String']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName?: InputMaybe<Scalars['String']>;
  fileName_contains?: InputMaybe<Scalars['String']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName_not?: InputMaybe<Scalars['String']>;
  fileName_not_contains?: InputMaybe<Scalars['String']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  height?: InputMaybe<Scalars['Int']>;
  height_exists?: InputMaybe<Scalars['Boolean']>;
  height_gt?: InputMaybe<Scalars['Int']>;
  height_gte?: InputMaybe<Scalars['Int']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  height_lt?: InputMaybe<Scalars['Int']>;
  height_lte?: InputMaybe<Scalars['Int']>;
  height_not?: InputMaybe<Scalars['Int']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Int']>;
  size_exists?: InputMaybe<Scalars['Boolean']>;
  size_gt?: InputMaybe<Scalars['Int']>;
  size_gte?: InputMaybe<Scalars['Int']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size_lt?: InputMaybe<Scalars['Int']>;
  size_lte?: InputMaybe<Scalars['Int']>;
  size_not?: InputMaybe<Scalars['Int']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  url_contains?: InputMaybe<Scalars['String']>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_not?: InputMaybe<Scalars['String']>;
  url_not_contains?: InputMaybe<Scalars['String']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  width?: InputMaybe<Scalars['Int']>;
  width_exists?: InputMaybe<Scalars['Boolean']>;
  width_gt?: InputMaybe<Scalars['Int']>;
  width_gte?: InputMaybe<Scalars['Int']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  width_lt?: InputMaybe<Scalars['Int']>;
  width_lte?: InputMaybe<Scalars['Int']>;
  width_not?: InputMaybe<Scalars['Int']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  contentOwnerCollection?: Maybe<ContentOwnerCollection>;
  elementTextCollection?: Maybe<ElementTextCollection>;
  entryCollection?: Maybe<EntryCollection>;
  eventCollection?: Maybe<EventCollection>;
  externalLinkEmbedCollection?: Maybe<ExternalLinkEmbedCollection>;
  homeCollection?: Maybe<HomeCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
  learningConceptCollection?: Maybe<LearningConceptCollection>;
  opportunityCollection?: Maybe<OpportunityCollection>;
  templateBreakMCollection?: Maybe<TemplateBreakMCollection>;
  templateCoberqCollection?: Maybe<TemplateCoberqCollection>;
  templateHarmonicaCollection?: Maybe<TemplateHarmonicaCollection>;
  templateMpcCardsCollection?: Maybe<TemplateMpcCardsCollection>;
  templateMpcMultipleCorrectCollection?: Maybe<TemplateMpcMultipleCorrectCollection>;
  templateMpcOneCorrectCollection?: Maybe<TemplateMpcOneCorrectCollection>;
  templateOpenQuestionCollection?: Maybe<TemplateOpenQuestionCollection>;
  templatePollCollection?: Maybe<TemplatePollCollection>;
  templateSliderCollection?: Maybe<TemplateSliderCollection>;
  templateTextImageCollection?: Maybe<TemplateTextImageCollection>;
  templateTextVideoImageCollection?: Maybe<TemplateTextVideoImageCollection>;
  templateTrueFalseCardsCollection?: Maybe<TemplateTrueFalseCardsCollection>;
};


export type AssetLinkingCollectionsContentOwnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsElementTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsExternalLinkEmbedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsHomeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsLearningConceptCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsOpportunityCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTemplateBreakMCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTemplateCoberqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTemplateHarmonicaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTemplateMpcCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTemplateMpcMultipleCorrectCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTemplateMpcOneCorrectCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTemplateOpenQuestionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTemplatePollCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTemplateSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTemplateTextImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTemplateTextVideoImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTemplateTrueFalseCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

export type Attribute = Node & {
  __typename?: 'Attribute';
  cognitoName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  key: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  nodeId: Scalars['ID'];
  requiredImport: Scalars['Boolean'];
};

export type AttributeCondition = {
  cognitoName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  requiredImport?: InputMaybe<Scalars['Boolean']>;
};

export type AttributeFilter = {
  and?: InputMaybe<Array<AttributeFilter>>;
  cognitoName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<AwsDateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IdFilter>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<AttributeFilter>;
  or?: InputMaybe<Array<AttributeFilter>>;
  requiredImport?: InputMaybe<BooleanFilter>;
};

export type AttributeInput = {
  cognitoName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  key: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  requiredImport?: InputMaybe<Scalars['Boolean']>;
};

export type AttributePatch = {
  cognitoName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  requiredImport?: InputMaybe<Scalars['Boolean']>;
};

export type AttributesConnection = {
  __typename?: 'AttributesConnection';
  edges: Array<AttributesEdge>;
  nodes: Array<Maybe<Attribute>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AttributesEdge = {
  __typename?: 'AttributesEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Attribute>;
};

export enum AttributesOrderBy {
  CognitoNameAsc = 'COGNITO_NAME_ASC',
  CognitoNameDesc = 'COGNITO_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RequiredImportAsc = 'REQUIRED_IMPORT_ASC',
  RequiredImportDesc = 'REQUIRED_IMPORT_DESC'
}

export type BooleanFilter = {
  distinctFrom?: InputMaybe<Scalars['Boolean']>;
  equalTo?: InputMaybe<Scalars['Boolean']>;
  greaterThan?: InputMaybe<Scalars['Boolean']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['Boolean']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  notDistinctFrom?: InputMaybe<Scalars['Boolean']>;
  notEqualTo?: InputMaybe<Scalars['Boolean']>;
  notIn?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** A (named) grouping of episodes for use in learning concepts [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/bundle) */
export type Bundle = Entry & {
  __typename?: 'Bundle';
  contentfulMetadata: ContentfulMetadata;
  episodesCollection?: Maybe<BundleEpisodesCollection>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<BundleLinkingCollections>;
  optionalEpisodesCollection?: Maybe<BundleOptionalEpisodesCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** A (named) grouping of episodes for use in learning concepts [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/bundle) */
export type BundleEpisodesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** A (named) grouping of episodes for use in learning concepts [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/bundle) */
export type BundleExternalIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A (named) grouping of episodes for use in learning concepts [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/bundle) */
export type BundleIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A (named) grouping of episodes for use in learning concepts [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/bundle) */
export type BundleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A (named) grouping of episodes for use in learning concepts [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/bundle) */
export type BundleOptionalEpisodesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** A (named) grouping of episodes for use in learning concepts [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/bundle) */
export type BundleTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type BundleCollection = {
  __typename?: 'BundleCollection';
  items: Array<Maybe<Bundle>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BundleEpisodesCollection = {
  __typename?: 'BundleEpisodesCollection';
  items: Array<Maybe<BundleEpisodesItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BundleEpisodesItem = Event | ExternalLinkEmbed | Intervention | Opportunity | Story;

export type BundleFilter = {
  AND?: InputMaybe<Array<InputMaybe<BundleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BundleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  episodesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalId_contains?: InputMaybe<Scalars['String']>;
  externalId_exists?: InputMaybe<Scalars['Boolean']>;
  externalId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalId_not?: InputMaybe<Scalars['String']>;
  externalId_not_contains?: InputMaybe<Scalars['String']>;
  externalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  optionalEpisodesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BundleLinkingCollections = {
  __typename?: 'BundleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  sectionCollection?: Maybe<SectionCollection>;
};


export type BundleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BundleLinkingCollectionsSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type BundleOptionalEpisodesCollection = {
  __typename?: 'BundleOptionalEpisodesCollection';
  items: Array<Maybe<BundleOptionalEpisodesItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BundleOptionalEpisodesItem = Event | ExternalLinkEmbed | Intervention | Opportunity;

export enum BundleOrder {
  ExternalIdAsc = 'externalId_ASC',
  ExternalIdDesc = 'externalId_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CatalogueItem = {
  __typename?: 'CatalogueItem';
  catalogueItemId?: Maybe<Scalars['String']>;
  groupCount?: Maybe<Scalars['Int']>;
};

export type CatalogueItemCondition = {
  catalogueItemId?: InputMaybe<Scalars['String']>;
  groupCount?: InputMaybe<Scalars['Int']>;
};

export type CatalogueItemFilter = {
  and?: InputMaybe<Array<CatalogueItemFilter>>;
  catalogueItemId?: InputMaybe<StringFilter>;
  groupCount?: InputMaybe<IntFilter>;
  not?: InputMaybe<CatalogueItemFilter>;
  or?: InputMaybe<Array<CatalogueItemFilter>>;
};

export type CatalogueItemsConnection = {
  __typename?: 'CatalogueItemsConnection';
  edges: Array<CatalogueItemsEdge>;
  nodes: Array<Maybe<CatalogueItem>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CatalogueItemsEdge = {
  __typename?: 'CatalogueItemsEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CatalogueItem>;
};

export type CatalogueItemsGroup = {
  __typename?: 'CatalogueItemsGroup';
  catalogueItemId?: Maybe<Scalars['String']>;
  course?: Maybe<CourseType>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  group?: Maybe<Group>;
  groupId: Scalars['String'];
};

export type CatalogueItemsGroupCondition = {
  catalogueItemId?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<CourseType>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  groupId?: InputMaybe<Scalars['String']>;
};

export type CatalogueItemsGroupFilter = {
  and?: InputMaybe<Array<CatalogueItemsGroupFilter>>;
  catalogueItemId?: InputMaybe<StringFilter>;
  course?: InputMaybe<CourseTypeFilter>;
  createdAt?: InputMaybe<AwsDateTimeFilter>;
  groupId?: InputMaybe<StringFilter>;
  not?: InputMaybe<CatalogueItemsGroupFilter>;
  or?: InputMaybe<Array<CatalogueItemsGroupFilter>>;
};

export type CatalogueItemsGroupInput = {
  catalogueItemId?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<CourseType>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  groupId: Scalars['String'];
};

export type CatalogueItemsGroupsConnection = {
  __typename?: 'CatalogueItemsGroupsConnection';
  edges: Array<CatalogueItemsGroupsEdge>;
  nodes: Array<Maybe<CatalogueItemsGroup>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CatalogueItemsGroupsEdge = {
  __typename?: 'CatalogueItemsGroupsEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CatalogueItemsGroup>;
};

export enum CatalogueItemsGroupsOrderBy {
  CatalogueItemIdAsc = 'CATALOGUE_ITEM_ID_ASC',
  CatalogueItemIdDesc = 'CATALOGUE_ITEM_ID_DESC',
  CourseAsc = 'COURSE_ASC',
  CourseDesc = 'COURSE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GroupByGroupIdCreatedAtAsc = 'GROUP_BY_GROUP_ID__CREATED_AT_ASC',
  GroupByGroupIdCreatedAtDesc = 'GROUP_BY_GROUP_ID__CREATED_AT_DESC',
  GroupByGroupIdDescriptionAsc = 'GROUP_BY_GROUP_ID__DESCRIPTION_ASC',
  GroupByGroupIdDescriptionDesc = 'GROUP_BY_GROUP_ID__DESCRIPTION_DESC',
  GroupByGroupIdNameAsc = 'GROUP_BY_GROUP_ID__NAME_ASC',
  GroupByGroupIdNameDesc = 'GROUP_BY_GROUP_ID__NAME_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  Natural = 'NATURAL'
}

export enum CatalogueItemsOrderBy {
  CatalogueItemIdAsc = 'CATALOGUE_ITEM_ID_ASC',
  CatalogueItemIdDesc = 'CATALOGUE_ITEM_ID_DESC',
  GroupCountAsc = 'GROUP_COUNT_ASC',
  GroupCountDesc = 'GROUP_COUNT_DESC',
  Natural = 'NATURAL'
}

/** Creates a content owner that can be connected to an episode. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/contentOwner) */
export type ContentOwner = Entry & {
  __typename?: 'ContentOwner';
  contentfulMetadata: ContentfulMetadata;
  contentownerImage?: Maybe<Asset>;
  contentownerJobtitle?: Maybe<Scalars['String']>;
  contentownerName?: Maybe<Scalars['String']>;
  contentownerUrl?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ContentOwnerLinkingCollections>;
  sys: Sys;
  telephone?: Maybe<Scalars['String']>;
};


/** Creates a content owner that can be connected to an episode. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/contentOwner) */
export type ContentOwnerContentownerImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Creates a content owner that can be connected to an episode. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/contentOwner) */
export type ContentOwnerContentownerJobtitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a content owner that can be connected to an episode. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/contentOwner) */
export type ContentOwnerContentownerNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a content owner that can be connected to an episode. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/contentOwner) */
export type ContentOwnerContentownerUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a content owner that can be connected to an episode. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/contentOwner) */
export type ContentOwnerEmailArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a content owner that can be connected to an episode. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/contentOwner) */
export type ContentOwnerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Creates a content owner that can be connected to an episode. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/contentOwner) */
export type ContentOwnerTelephoneArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ContentOwnerCollection = {
  __typename?: 'ContentOwnerCollection';
  items: Array<Maybe<ContentOwner>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ContentOwnerFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentOwnerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentOwnerFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contentownerImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentownerJobtitle?: InputMaybe<Scalars['String']>;
  contentownerJobtitle_contains?: InputMaybe<Scalars['String']>;
  contentownerJobtitle_exists?: InputMaybe<Scalars['Boolean']>;
  contentownerJobtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentownerJobtitle_not?: InputMaybe<Scalars['String']>;
  contentownerJobtitle_not_contains?: InputMaybe<Scalars['String']>;
  contentownerJobtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentownerName?: InputMaybe<Scalars['String']>;
  contentownerName_contains?: InputMaybe<Scalars['String']>;
  contentownerName_exists?: InputMaybe<Scalars['Boolean']>;
  contentownerName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentownerName_not?: InputMaybe<Scalars['String']>;
  contentownerName_not_contains?: InputMaybe<Scalars['String']>;
  contentownerName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentownerUrl?: InputMaybe<Scalars['String']>;
  contentownerUrl_contains?: InputMaybe<Scalars['String']>;
  contentownerUrl_exists?: InputMaybe<Scalars['Boolean']>;
  contentownerUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentownerUrl_not?: InputMaybe<Scalars['String']>;
  contentownerUrl_not_contains?: InputMaybe<Scalars['String']>;
  contentownerUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Scalars['String']>;
  email_contains?: InputMaybe<Scalars['String']>;
  email_exists?: InputMaybe<Scalars['Boolean']>;
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email_not?: InputMaybe<Scalars['String']>;
  email_not_contains?: InputMaybe<Scalars['String']>;
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  telephone?: InputMaybe<Scalars['String']>;
  telephone_contains?: InputMaybe<Scalars['String']>;
  telephone_exists?: InputMaybe<Scalars['Boolean']>;
  telephone_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  telephone_not?: InputMaybe<Scalars['String']>;
  telephone_not_contains?: InputMaybe<Scalars['String']>;
  telephone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ContentOwnerLinkingCollections = {
  __typename?: 'ContentOwnerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  eventCollection?: Maybe<EventCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
  opportunityCollection?: Maybe<OpportunityCollection>;
  rowCollection?: Maybe<RowCollection>;
};


export type ContentOwnerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContentOwnerLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContentOwnerLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContentOwnerLinkingCollectionsOpportunityCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContentOwnerLinkingCollectionsRowCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ContentOwnerOrder {
  ContentownerJobtitleAsc = 'contentownerJobtitle_ASC',
  ContentownerJobtitleDesc = 'contentownerJobtitle_DESC',
  ContentownerNameAsc = 'contentownerName_ASC',
  ContentownerNameDesc = 'contentownerName_DESC',
  ContentownerUrlAsc = 'contentownerUrl_ASC',
  ContentownerUrlDesc = 'contentownerUrl_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneAsc = 'telephone_ASC',
  TelephoneDesc = 'telephone_DESC'
}

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataFilter = {
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *     Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum CourseType {
  Accessible = 'ACCESSIBLE',
  Mandatory = 'MANDATORY'
}

export type CourseTypeFilter = {
  distinctFrom?: InputMaybe<CourseType>;
  equalTo?: InputMaybe<CourseType>;
  greaterThan?: InputMaybe<CourseType>;
  greaterThanOrEqualTo?: InputMaybe<CourseType>;
  in?: InputMaybe<Array<CourseType>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<CourseType>;
  lessThanOrEqualTo?: InputMaybe<CourseType>;
  notDistinctFrom?: InputMaybe<CourseType>;
  notEqualTo?: InputMaybe<CourseType>;
  notIn?: InputMaybe<Array<CourseType>>;
};

export type CreateAttributeInput = {
  attribute: AttributeInput;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateAttributePayload = {
  __typename?: 'CreateAttributePayload';
  attribute?: Maybe<Attribute>;
  attributeEdge?: Maybe<AttributesEdge>;
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};


export type CreateAttributePayloadAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<AttributesOrderBy>>;
};

export type CreateCatalogueItemsGroupInput = {
  catalogueItemsGroup: CatalogueItemsGroupInput;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateCatalogueItemsGroupPayload = {
  __typename?: 'CreateCatalogueItemsGroupPayload';
  catalogueItemsGroup?: Maybe<CatalogueItemsGroup>;
  catalogueItemsGroupEdge?: Maybe<CatalogueItemsGroupsEdge>;
  clientMutationId?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  query?: Maybe<Query>;
};


export type CreateCatalogueItemsGroupPayloadCatalogueItemsGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<CatalogueItemsGroupsOrderBy>>;
};

export type CreateGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  group: GroupInput;
};

export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  groupEdge?: Maybe<GroupsEdge>;
  query?: Maybe<Query>;
};


export type CreateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

export type CreateGroupsUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupsUser: GroupsUserInput;
};

export type CreateGroupsUserPayload = {
  __typename?: 'CreateGroupsUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  groupsUser?: Maybe<GroupsUser>;
  groupsUserEdge?: Maybe<GroupsUsersEdge>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
};


export type CreateGroupsUserPayloadGroupsUserEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsUsersOrderBy>>;
};

export type CreateTenantsGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  tenantsGroup: TenantsGroupInput;
};

export type CreateTenantsGroupPayload = {
  __typename?: 'CreateTenantsGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  query?: Maybe<Query>;
  tenantsGroup?: Maybe<TenantsGroup>;
  tenantsGroupEdge?: Maybe<TenantsGroupsEdge>;
};


export type CreateTenantsGroupPayloadTenantsGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantsGroupsOrderBy>>;
};

export type CreateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  user: UserInput;
};

export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
  userEdge?: Maybe<UsersEdge>;
};


export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type DeleteAttributeByCognitoNameInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  cognitoName: Scalars['String'];
};

export type DeleteAttributeByKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DeleteAttributeByNodeIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['ID'];
};

export type DeleteAttributeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteAttributePayload = {
  __typename?: 'DeleteAttributePayload';
  attribute?: Maybe<Attribute>;
  attributeEdge?: Maybe<AttributesEdge>;
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAttributeNodeId?: Maybe<Scalars['ID']>;
  query?: Maybe<Query>;
};


export type DeleteAttributePayloadAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<AttributesOrderBy>>;
};

export type DeleteGroupByNodeIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['ID'];
};

export type DeleteGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DeleteGroupPayload = {
  __typename?: 'DeleteGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deletedGroupNodeId?: Maybe<Scalars['ID']>;
  group?: Maybe<Group>;
  groupEdge?: Maybe<GroupsEdge>;
  query?: Maybe<Query>;
};


export type DeleteGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

export type DeleteUserByNodeIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['ID'];
};

export type DeleteUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserNodeId?: Maybe<Scalars['ID']>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
  userEdge?: Maybe<UsersEdge>;
};


export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** Adds a template for text only [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/elementText) */
export type ElementText = Entry & {
  __typename?: 'ElementText';
  contentfulMetadata: ContentfulMetadata;
  downloadFile?: Maybe<Asset>;
  downloadTitle?: Maybe<Scalars['String']>;
  elementId?: Maybe<Scalars['String']>;
  elementText?: Maybe<ElementTextElementText>;
  externalEmbedLink?: Maybe<ExternalLinkEmbed>;
  linkedFrom?: Maybe<ElementTextLinkingCollections>;
  sys: Sys;
};


/** Adds a template for text only [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/elementText) */
export type ElementTextDownloadFileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for text only [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/elementText) */
export type ElementTextDownloadTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text only [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/elementText) */
export type ElementTextElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text only [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/elementText) */
export type ElementTextElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text only [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/elementText) */
export type ElementTextExternalEmbedLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for text only [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/elementText) */
export type ElementTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ElementTextCollection = {
  __typename?: 'ElementTextCollection';
  items: Array<Maybe<ElementText>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ElementTextElementText = {
  __typename?: 'ElementTextElementText';
  json: Scalars['JSON'];
  links: ElementTextElementTextLinks;
};

export type ElementTextElementTextAssets = {
  __typename?: 'ElementTextElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ElementTextElementTextEntries = {
  __typename?: 'ElementTextElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ElementTextElementTextLinks = {
  __typename?: 'ElementTextElementTextLinks';
  assets: ElementTextElementTextAssets;
  entries: ElementTextElementTextEntries;
};

export type ElementTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<ElementTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ElementTextFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  downloadFile_exists?: InputMaybe<Scalars['Boolean']>;
  downloadTitle?: InputMaybe<Scalars['String']>;
  downloadTitle_contains?: InputMaybe<Scalars['String']>;
  downloadTitle_exists?: InputMaybe<Scalars['Boolean']>;
  downloadTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  downloadTitle_not?: InputMaybe<Scalars['String']>;
  downloadTitle_not_contains?: InputMaybe<Scalars['String']>;
  downloadTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  externalEmbedLink?: InputMaybe<CfExternalLinkEmbedNestedFilter>;
  externalEmbedLink_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type ElementTextLinkingCollections = {
  __typename?: 'ElementTextLinkingCollections';
  academyCollection?: Maybe<AcademyCollection>;
  entryCollection?: Maybe<EntryCollection>;
  eventCollection?: Maybe<EventCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
  opportunityCollection?: Maybe<OpportunityCollection>;
};


export type ElementTextLinkingCollectionsAcademyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ElementTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ElementTextLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ElementTextLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ElementTextLinkingCollectionsOpportunityCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ElementTextOrder {
  DownloadTitleAsc = 'downloadTitle_ASC',
  DownloadTitleDesc = 'downloadTitle_DESC',
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type Event = Entry & {
  __typename?: 'Event';
  contentOwner?: Maybe<ContentOwner>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  elementId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Asset>;
  imageOnCard?: Maybe<Asset>;
  linkedFrom?: Maybe<EventLinkingCollections>;
  locationAddress?: Maybe<Location>;
  locationName?: Maybe<Scalars['String']>;
  maxAttendees?: Maybe<Scalars['Float']>;
  meetingUrl?: Maybe<Scalars['String']>;
  recordingUrl?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  statusEndDate?: Maybe<Scalars['DateTime']>;
  statusLabel?: Maybe<Scalars['String']>;
  sys: Sys;
  tenantCollection?: Maybe<EventTenantCollection>;
  text?: Maybe<ElementText>;
  title?: Maybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventContentOwnerArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventEndDateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventEventTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventExternalIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventHeaderImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventImageOnCardArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventLocationAddressArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventLocationNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventMaxAttendeesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventMeetingUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventRecordingUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventStartDateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventStatusEndDateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventStatusLabelArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventTenantCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/event) */
export type EventTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type EventCollection = {
  __typename?: 'EventCollection';
  items: Array<Maybe<Event>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type EventFilter = {
  AND?: InputMaybe<Array<InputMaybe<EventFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EventFilter>>>;
  contentOwner?: InputMaybe<CfContentOwnerNestedFilter>;
  contentOwner_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  endDate_exists?: InputMaybe<Scalars['Boolean']>;
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  endDate_not?: InputMaybe<Scalars['DateTime']>;
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  eventType?: InputMaybe<Scalars['String']>;
  eventType_contains?: InputMaybe<Scalars['String']>;
  eventType_exists?: InputMaybe<Scalars['Boolean']>;
  eventType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventType_not?: InputMaybe<Scalars['String']>;
  eventType_not_contains?: InputMaybe<Scalars['String']>;
  eventType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalId?: InputMaybe<Scalars['String']>;
  externalId_contains?: InputMaybe<Scalars['String']>;
  externalId_exists?: InputMaybe<Scalars['Boolean']>;
  externalId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalId_not?: InputMaybe<Scalars['String']>;
  externalId_not_contains?: InputMaybe<Scalars['String']>;
  externalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headerImage_exists?: InputMaybe<Scalars['Boolean']>;
  imageOnCard_exists?: InputMaybe<Scalars['Boolean']>;
  locationAddress_exists?: InputMaybe<Scalars['Boolean']>;
  locationAddress_within_circle?: InputMaybe<Scalars['Circle']>;
  locationAddress_within_rectangle?: InputMaybe<Scalars['Rectangle']>;
  locationName?: InputMaybe<Scalars['String']>;
  locationName_contains?: InputMaybe<Scalars['String']>;
  locationName_exists?: InputMaybe<Scalars['Boolean']>;
  locationName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationName_not?: InputMaybe<Scalars['String']>;
  locationName_not_contains?: InputMaybe<Scalars['String']>;
  locationName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxAttendees?: InputMaybe<Scalars['Float']>;
  maxAttendees_exists?: InputMaybe<Scalars['Boolean']>;
  maxAttendees_gt?: InputMaybe<Scalars['Float']>;
  maxAttendees_gte?: InputMaybe<Scalars['Float']>;
  maxAttendees_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  maxAttendees_lt?: InputMaybe<Scalars['Float']>;
  maxAttendees_lte?: InputMaybe<Scalars['Float']>;
  maxAttendees_not?: InputMaybe<Scalars['Float']>;
  maxAttendees_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  meetingUrl?: InputMaybe<Scalars['String']>;
  meetingUrl_contains?: InputMaybe<Scalars['String']>;
  meetingUrl_exists?: InputMaybe<Scalars['Boolean']>;
  meetingUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  meetingUrl_not?: InputMaybe<Scalars['String']>;
  meetingUrl_not_contains?: InputMaybe<Scalars['String']>;
  meetingUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  recordingUrl?: InputMaybe<Scalars['String']>;
  recordingUrl_contains?: InputMaybe<Scalars['String']>;
  recordingUrl_exists?: InputMaybe<Scalars['Boolean']>;
  recordingUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  recordingUrl_not?: InputMaybe<Scalars['String']>;
  recordingUrl_not_contains?: InputMaybe<Scalars['String']>;
  recordingUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startDate_exists?: InputMaybe<Scalars['Boolean']>;
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  startDate_not?: InputMaybe<Scalars['DateTime']>;
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  statusEndDate?: InputMaybe<Scalars['DateTime']>;
  statusEndDate_exists?: InputMaybe<Scalars['Boolean']>;
  statusEndDate_gt?: InputMaybe<Scalars['DateTime']>;
  statusEndDate_gte?: InputMaybe<Scalars['DateTime']>;
  statusEndDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  statusEndDate_lt?: InputMaybe<Scalars['DateTime']>;
  statusEndDate_lte?: InputMaybe<Scalars['DateTime']>;
  statusEndDate_not?: InputMaybe<Scalars['DateTime']>;
  statusEndDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  statusLabel?: InputMaybe<Scalars['String']>;
  statusLabel_contains?: InputMaybe<Scalars['String']>;
  statusLabel_exists?: InputMaybe<Scalars['Boolean']>;
  statusLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusLabel_not?: InputMaybe<Scalars['String']>;
  statusLabel_not_contains?: InputMaybe<Scalars['String']>;
  statusLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  tenantCollection_exists?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<CfElementTextNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EventLinkingCollections = {
  __typename?: 'EventLinkingCollections';
  bundleCollection?: Maybe<BundleCollection>;
  entryCollection?: Maybe<EntryCollection>;
  rowCollection?: Maybe<RowCollection>;
};


export type EventLinkingCollectionsBundleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type EventLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type EventLinkingCollectionsRowCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum EventOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  EventTypeAsc = 'eventType_ASC',
  EventTypeDesc = 'eventType_DESC',
  ExternalIdAsc = 'externalId_ASC',
  ExternalIdDesc = 'externalId_DESC',
  LocationNameAsc = 'locationName_ASC',
  LocationNameDesc = 'locationName_DESC',
  MaxAttendeesAsc = 'maxAttendees_ASC',
  MaxAttendeesDesc = 'maxAttendees_DESC',
  MeetingUrlAsc = 'meetingUrl_ASC',
  MeetingUrlDesc = 'meetingUrl_DESC',
  RecordingUrlAsc = 'recordingUrl_ASC',
  RecordingUrlDesc = 'recordingUrl_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  StatusEndDateAsc = 'statusEndDate_ASC',
  StatusEndDateDesc = 'statusEndDate_DESC',
  StatusLabelAsc = 'statusLabel_ASC',
  StatusLabelDesc = 'statusLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type EventTenantCollection = {
  __typename?: 'EventTenantCollection';
  items: Array<Maybe<Academy>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

/** This content type can be added to link to external content from other sources. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/externalLinkEmbed) */
export type ExternalLinkEmbed = Entry & {
  __typename?: 'ExternalLinkEmbed';
  contentfulMetadata: ContentfulMetadata;
  coverImage?: Maybe<Scalars['Boolean']>;
  elementId?: Maybe<Scalars['String']>;
  embedDuration?: Maybe<Scalars['Int']>;
  embedImage?: Maybe<Asset>;
  embedTitle?: Maybe<Scalars['String']>;
  embedType?: Maybe<Scalars['String']>;
  embedUrl?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ExternalLinkEmbedLinkingCollections>;
  registerCompletion?: Maybe<Scalars['Boolean']>;
  sys: Sys;
};


/** This content type can be added to link to external content from other sources. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/externalLinkEmbed) */
export type ExternalLinkEmbedCoverImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This content type can be added to link to external content from other sources. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/externalLinkEmbed) */
export type ExternalLinkEmbedElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This content type can be added to link to external content from other sources. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/externalLinkEmbed) */
export type ExternalLinkEmbedEmbedDurationArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This content type can be added to link to external content from other sources. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/externalLinkEmbed) */
export type ExternalLinkEmbedEmbedImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** This content type can be added to link to external content from other sources. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/externalLinkEmbed) */
export type ExternalLinkEmbedEmbedTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This content type can be added to link to external content from other sources. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/externalLinkEmbed) */
export type ExternalLinkEmbedEmbedTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This content type can be added to link to external content from other sources. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/externalLinkEmbed) */
export type ExternalLinkEmbedEmbedUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** This content type can be added to link to external content from other sources. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/externalLinkEmbed) */
export type ExternalLinkEmbedLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** This content type can be added to link to external content from other sources. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/externalLinkEmbed) */
export type ExternalLinkEmbedRegisterCompletionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ExternalLinkEmbedCollection = {
  __typename?: 'ExternalLinkEmbedCollection';
  items: Array<Maybe<ExternalLinkEmbed>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ExternalLinkEmbedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ExternalLinkEmbedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ExternalLinkEmbedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  coverImage?: InputMaybe<Scalars['Boolean']>;
  coverImage_exists?: InputMaybe<Scalars['Boolean']>;
  coverImage_not?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  embedDuration?: InputMaybe<Scalars['Int']>;
  embedDuration_exists?: InputMaybe<Scalars['Boolean']>;
  embedDuration_gt?: InputMaybe<Scalars['Int']>;
  embedDuration_gte?: InputMaybe<Scalars['Int']>;
  embedDuration_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  embedDuration_lt?: InputMaybe<Scalars['Int']>;
  embedDuration_lte?: InputMaybe<Scalars['Int']>;
  embedDuration_not?: InputMaybe<Scalars['Int']>;
  embedDuration_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  embedImage_exists?: InputMaybe<Scalars['Boolean']>;
  embedTitle?: InputMaybe<Scalars['String']>;
  embedTitle_contains?: InputMaybe<Scalars['String']>;
  embedTitle_exists?: InputMaybe<Scalars['Boolean']>;
  embedTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  embedTitle_not?: InputMaybe<Scalars['String']>;
  embedTitle_not_contains?: InputMaybe<Scalars['String']>;
  embedTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  embedType?: InputMaybe<Scalars['String']>;
  embedType_contains?: InputMaybe<Scalars['String']>;
  embedType_exists?: InputMaybe<Scalars['Boolean']>;
  embedType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  embedType_not?: InputMaybe<Scalars['String']>;
  embedType_not_contains?: InputMaybe<Scalars['String']>;
  embedType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  embedUrl?: InputMaybe<Scalars['String']>;
  embedUrl_contains?: InputMaybe<Scalars['String']>;
  embedUrl_exists?: InputMaybe<Scalars['Boolean']>;
  embedUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  embedUrl_not?: InputMaybe<Scalars['String']>;
  embedUrl_not_contains?: InputMaybe<Scalars['String']>;
  embedUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  registerCompletion?: InputMaybe<Scalars['Boolean']>;
  registerCompletion_exists?: InputMaybe<Scalars['Boolean']>;
  registerCompletion_not?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type ExternalLinkEmbedLinkingCollections = {
  __typename?: 'ExternalLinkEmbedLinkingCollections';
  bundleCollection?: Maybe<BundleCollection>;
  elementTextCollection?: Maybe<ElementTextCollection>;
  entryCollection?: Maybe<EntryCollection>;
  homeCollection?: Maybe<HomeCollection>;
  rowCollection?: Maybe<RowCollection>;
};


export type ExternalLinkEmbedLinkingCollectionsBundleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ExternalLinkEmbedLinkingCollectionsElementTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ExternalLinkEmbedLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ExternalLinkEmbedLinkingCollectionsHomeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ExternalLinkEmbedLinkingCollectionsRowCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ExternalLinkEmbedOrder {
  CoverImageAsc = 'coverImage_ASC',
  CoverImageDesc = 'coverImage_DESC',
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  EmbedDurationAsc = 'embedDuration_ASC',
  EmbedDurationDesc = 'embedDuration_DESC',
  EmbedTitleAsc = 'embedTitle_ASC',
  EmbedTitleDesc = 'embedTitle_DESC',
  EmbedTypeAsc = 'embedType_ASC',
  EmbedTypeDesc = 'embedType_DESC',
  EmbedUrlAsc = 'embedUrl_ASC',
  EmbedUrlDesc = 'embedUrl_DESC',
  RegisterCompletionAsc = 'registerCompletion_ASC',
  RegisterCompletionDesc = 'registerCompletion_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Creates a fact for the facts & figures template. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/fact) */
export type Fact = Entry & {
  __typename?: 'Fact';
  contentfulMetadata: ContentfulMetadata;
  elementNumber?: Maybe<Scalars['String']>;
  elementText?: Maybe<Scalars['String']>;
  elementUnitSymbol?: Maybe<Scalars['String']>;
  elementUnitText?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<FactLinkingCollections>;
  sys: Sys;
};


/** Creates a fact for the facts & figures template. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/fact) */
export type FactElementNumberArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a fact for the facts & figures template. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/fact) */
export type FactElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a fact for the facts & figures template. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/fact) */
export type FactElementUnitSymbolArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a fact for the facts & figures template. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/fact) */
export type FactElementUnitTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a fact for the facts & figures template. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/fact) */
export type FactLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FactCollection = {
  __typename?: 'FactCollection';
  items: Array<Maybe<Fact>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type FactFilter = {
  AND?: InputMaybe<Array<InputMaybe<FactFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FactFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementNumber?: InputMaybe<Scalars['String']>;
  elementNumber_contains?: InputMaybe<Scalars['String']>;
  elementNumber_exists?: InputMaybe<Scalars['Boolean']>;
  elementNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementNumber_not?: InputMaybe<Scalars['String']>;
  elementNumber_not_contains?: InputMaybe<Scalars['String']>;
  elementNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText?: InputMaybe<Scalars['String']>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_not?: InputMaybe<Scalars['String']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementUnitSymbol?: InputMaybe<Scalars['String']>;
  elementUnitSymbol_contains?: InputMaybe<Scalars['String']>;
  elementUnitSymbol_exists?: InputMaybe<Scalars['Boolean']>;
  elementUnitSymbol_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementUnitSymbol_not?: InputMaybe<Scalars['String']>;
  elementUnitSymbol_not_contains?: InputMaybe<Scalars['String']>;
  elementUnitSymbol_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementUnitText?: InputMaybe<Scalars['String']>;
  elementUnitText_contains?: InputMaybe<Scalars['String']>;
  elementUnitText_exists?: InputMaybe<Scalars['Boolean']>;
  elementUnitText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementUnitText_not?: InputMaybe<Scalars['String']>;
  elementUnitText_not_contains?: InputMaybe<Scalars['String']>;
  elementUnitText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type FactLinkingCollections = {
  __typename?: 'FactLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  templateFactsFiguresCollection?: Maybe<TemplateFactsFiguresCollection>;
};


export type FactLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FactLinkingCollectionsTemplateFactsFiguresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum FactOrder {
  ElementNumberAsc = 'elementNumber_ASC',
  ElementNumberDesc = 'elementNumber_DESC',
  ElementTextAsc = 'elementText_ASC',
  ElementTextDesc = 'elementText_DESC',
  ElementUnitSymbolAsc = 'elementUnitSymbol_ASC',
  ElementUnitSymbolDesc = 'elementUnitSymbol_DESC',
  ElementUnitTextAsc = 'elementUnitText_ASC',
  ElementUnitTextDesc = 'elementUnitText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Creates a glossary term to insert into the body text of certain templates. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/glossaryItem) */
export type GlossaryItem = Entry & {
  __typename?: 'GlossaryItem';
  contentfulMetadata: ContentfulMetadata;
  glossaryDefinition?: Maybe<Scalars['String']>;
  glossaryTerm?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<GlossaryItemLinkingCollections>;
  sys: Sys;
};


/** Creates a glossary term to insert into the body text of certain templates. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/glossaryItem) */
export type GlossaryItemGlossaryDefinitionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a glossary term to insert into the body text of certain templates. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/glossaryItem) */
export type GlossaryItemGlossaryTermArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a glossary term to insert into the body text of certain templates. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/glossaryItem) */
export type GlossaryItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GlossaryItemCollection = {
  __typename?: 'GlossaryItemCollection';
  items: Array<Maybe<GlossaryItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type GlossaryItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<GlossaryItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<GlossaryItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  glossaryDefinition?: InputMaybe<Scalars['String']>;
  glossaryDefinition_contains?: InputMaybe<Scalars['String']>;
  glossaryDefinition_exists?: InputMaybe<Scalars['Boolean']>;
  glossaryDefinition_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  glossaryDefinition_not?: InputMaybe<Scalars['String']>;
  glossaryDefinition_not_contains?: InputMaybe<Scalars['String']>;
  glossaryDefinition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  glossaryTerm?: InputMaybe<Scalars['String']>;
  glossaryTerm_contains?: InputMaybe<Scalars['String']>;
  glossaryTerm_exists?: InputMaybe<Scalars['Boolean']>;
  glossaryTerm_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  glossaryTerm_not?: InputMaybe<Scalars['String']>;
  glossaryTerm_not_contains?: InputMaybe<Scalars['String']>;
  glossaryTerm_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type GlossaryItemLinkingCollections = {
  __typename?: 'GlossaryItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type GlossaryItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum GlossaryItemOrder {
  GlossaryTermAsc = 'glossaryTerm_ASC',
  GlossaryTermDesc = 'glossaryTerm_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Group = Node & {
  __typename?: 'Group';
  catalogueItemsGroups: CatalogueItemsGroupsConnection;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  description?: Maybe<Scalars['String']>;
  groupsUsers: GroupsUsersConnection;
  name: Scalars['String'];
  nodeId: Scalars['ID'];
  tenantsGroups: TenantsGroupsConnection;
};


export type GroupCatalogueItemsGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<CatalogueItemsGroupCondition>;
  filter?: InputMaybe<CatalogueItemsGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CatalogueItemsGroupsOrderBy>>;
};


export type GroupGroupsUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<GroupsUserCondition>;
  filter?: InputMaybe<GroupsUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsUsersOrderBy>>;
};


export type GroupTenantsGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<TenantsGroupCondition>;
  filter?: InputMaybe<TenantsGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TenantsGroupsOrderBy>>;
};

export type GroupCondition = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type GroupFilter = {
  and?: InputMaybe<Array<GroupFilter>>;
  createdAt?: InputMaybe<AwsDateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<GroupFilter>;
  or?: InputMaybe<Array<GroupFilter>>;
};

export type GroupInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type GroupPatch = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  edges: Array<GroupsEdge>;
  nodes: Array<Maybe<Group>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type GroupsEdge = {
  __typename?: 'GroupsEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Group>;
};

export enum GroupsOrderBy {
  CatalogueItemsGroupsByGroupIdCountAsc = 'CATALOGUE_ITEMS_GROUPS_BY_GROUP_ID__COUNT_ASC',
  CatalogueItemsGroupsByGroupIdCountDesc = 'CATALOGUE_ITEMS_GROUPS_BY_GROUP_ID__COUNT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  GroupsUsersByGroupIdCountAsc = 'GROUPS_USERS_BY_GROUP_ID__COUNT_ASC',
  GroupsUsersByGroupIdCountDesc = 'GROUPS_USERS_BY_GROUP_ID__COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantsGroupsByGroupIdCountAsc = 'TENANTS_GROUPS_BY_GROUP_ID__COUNT_ASC',
  TenantsGroupsByGroupIdCountDesc = 'TENANTS_GROUPS_BY_GROUP_ID__COUNT_DESC'
}

export type GroupsUser = {
  __typename?: 'GroupsUser';
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  group?: Maybe<Group>;
  groupId: Scalars['String'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
};

export type GroupsUserCondition = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  groupId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type GroupsUserFilter = {
  and?: InputMaybe<Array<GroupsUserFilter>>;
  createdAt?: InputMaybe<AwsDateTimeFilter>;
  groupId?: InputMaybe<StringFilter>;
  not?: InputMaybe<GroupsUserFilter>;
  or?: InputMaybe<Array<GroupsUserFilter>>;
  userId?: InputMaybe<IdFilter>;
};

export type GroupsUserInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  groupId: Scalars['String'];
  userId: Scalars['ID'];
};

export type GroupsUsersConnection = {
  __typename?: 'GroupsUsersConnection';
  edges: Array<GroupsUsersEdge>;
  nodes: Array<Maybe<GroupsUser>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type GroupsUsersEdge = {
  __typename?: 'GroupsUsersEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<GroupsUser>;
};

export enum GroupsUsersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GroupByGroupIdCreatedAtAsc = 'GROUP_BY_GROUP_ID__CREATED_AT_ASC',
  GroupByGroupIdCreatedAtDesc = 'GROUP_BY_GROUP_ID__CREATED_AT_DESC',
  GroupByGroupIdDescriptionAsc = 'GROUP_BY_GROUP_ID__DESCRIPTION_ASC',
  GroupByGroupIdDescriptionDesc = 'GROUP_BY_GROUP_ID__DESCRIPTION_DESC',
  GroupByGroupIdNameAsc = 'GROUP_BY_GROUP_ID__NAME_ASC',
  GroupByGroupIdNameDesc = 'GROUP_BY_GROUP_ID__NAME_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  Natural = 'NATURAL',
  UserByUserIdAttributesAsc = 'USER_BY_USER_ID__ATTRIBUTES_ASC',
  UserByUserIdAttributesDesc = 'USER_BY_USER_ID__ATTRIBUTES_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFamilyNameAsc = 'USER_BY_USER_ID__FAMILY_NAME_ASC',
  UserByUserIdFamilyNameDesc = 'USER_BY_USER_ID__FAMILY_NAME_DESC',
  UserByUserIdGivenNameAsc = 'USER_BY_USER_ID__GIVEN_NAME_ASC',
  UserByUserIdGivenNameDesc = 'USER_BY_USER_ID__GIVEN_NAME_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type Home = Entry & {
  __typename?: 'Home';
  contentfulMetadata: ContentfulMetadata;
  defaultForTenantCollection?: Maybe<HomeDefaultForTenantCollection>;
  externalLinksCollection?: Maybe<HomeExternalLinksCollection>;
  extraRowsCollection?: Maybe<HomeExtraRowsCollection>;
  followButton?: Maybe<Scalars['Boolean']>;
  homeTopbannerImage?: Maybe<Asset>;
  homeTopbannerReference?: Maybe<Intervention>;
  homeTopbannerSurtitle?: Maybe<Scalars['String']>;
  homeTopbannerTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<HomeLinkingCollections>;
  path?: Maybe<Scalars['String']>;
  rowsCollection?: Maybe<HomeRowsCollection>;
  shortDescription?: Maybe<Scalars['String']>;
  sys: Sys;
  tenantCollection?: Maybe<HomeTenantCollection>;
  title?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeDefaultForTenantCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeExternalLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeExtraRowsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeFollowButtonArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeHomeTopbannerImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeHomeTopbannerReferenceArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeHomeTopbannerSurtitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeHomeTopbannerTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomePathArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeRowsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeShortDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeTenantCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a landing page. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/home) */
export type HomeVideoUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type HomeCollection = {
  __typename?: 'HomeCollection';
  items: Array<Maybe<Home>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HomeDefaultForTenantCollection = {
  __typename?: 'HomeDefaultForTenantCollection';
  items: Array<Maybe<Academy>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HomeExternalLinksCollection = {
  __typename?: 'HomeExternalLinksCollection';
  items: Array<Maybe<ExternalLinkEmbed>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HomeExtraRowsCollection = {
  __typename?: 'HomeExtraRowsCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HomeFilter = {
  AND?: InputMaybe<Array<InputMaybe<HomeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HomeFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultForTenantCollection_exists?: InputMaybe<Scalars['Boolean']>;
  externalLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  extraRowsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  followButton?: InputMaybe<Scalars['Boolean']>;
  followButton_exists?: InputMaybe<Scalars['Boolean']>;
  followButton_not?: InputMaybe<Scalars['Boolean']>;
  homeTopbannerImage_exists?: InputMaybe<Scalars['Boolean']>;
  homeTopbannerReference?: InputMaybe<CfInterventionNestedFilter>;
  homeTopbannerReference_exists?: InputMaybe<Scalars['Boolean']>;
  homeTopbannerSurtitle?: InputMaybe<Scalars['String']>;
  homeTopbannerSurtitle_contains?: InputMaybe<Scalars['String']>;
  homeTopbannerSurtitle_exists?: InputMaybe<Scalars['Boolean']>;
  homeTopbannerSurtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  homeTopbannerSurtitle_not?: InputMaybe<Scalars['String']>;
  homeTopbannerSurtitle_not_contains?: InputMaybe<Scalars['String']>;
  homeTopbannerSurtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  homeTopbannerTitle?: InputMaybe<Scalars['String']>;
  homeTopbannerTitle_contains?: InputMaybe<Scalars['String']>;
  homeTopbannerTitle_exists?: InputMaybe<Scalars['Boolean']>;
  homeTopbannerTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  homeTopbannerTitle_not?: InputMaybe<Scalars['String']>;
  homeTopbannerTitle_not_contains?: InputMaybe<Scalars['String']>;
  homeTopbannerTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path?: InputMaybe<Scalars['String']>;
  path_contains?: InputMaybe<Scalars['String']>;
  path_exists?: InputMaybe<Scalars['Boolean']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  path_not?: InputMaybe<Scalars['String']>;
  path_not_contains?: InputMaybe<Scalars['String']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rowsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  shortDescription_exists?: InputMaybe<Scalars['Boolean']>;
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shortDescription_not?: InputMaybe<Scalars['String']>;
  shortDescription_not_contains?: InputMaybe<Scalars['String']>;
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  tenantCollection_exists?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoUrl?: InputMaybe<Scalars['String']>;
  videoUrl_contains?: InputMaybe<Scalars['String']>;
  videoUrl_exists?: InputMaybe<Scalars['Boolean']>;
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoUrl_not?: InputMaybe<Scalars['String']>;
  videoUrl_not_contains?: InputMaybe<Scalars['String']>;
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type HomeLinkingCollections = {
  __typename?: 'HomeLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type HomeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum HomeOrder {
  FollowButtonAsc = 'followButton_ASC',
  FollowButtonDesc = 'followButton_DESC',
  HomeTopbannerSurtitleAsc = 'homeTopbannerSurtitle_ASC',
  HomeTopbannerSurtitleDesc = 'homeTopbannerSurtitle_DESC',
  HomeTopbannerTitleAsc = 'homeTopbannerTitle_ASC',
  HomeTopbannerTitleDesc = 'homeTopbannerTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type HomeRowsCollection = {
  __typename?: 'HomeRowsCollection';
  items: Array<Maybe<Row>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HomeTenantCollection = {
  __typename?: 'HomeTenantCollection';
  items: Array<Maybe<Academy>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type IdFilter = {
  distinctFrom?: InputMaybe<Scalars['ID']>;
  equalTo?: InputMaybe<Scalars['ID']>;
  greaterThan?: InputMaybe<Scalars['ID']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['ID']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['ID']>;
  notDistinctFrom?: InputMaybe<Scalars['ID']>;
  notEqualTo?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<Scalars['ID']>>;
};

export enum ImageFormat {
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']>;
};

export type IntFilter = {
  distinctFrom?: InputMaybe<Scalars['Int']>;
  equalTo?: InputMaybe<Scalars['Int']>;
  greaterThan?: InputMaybe<Scalars['Int']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['Int']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  notDistinctFrom?: InputMaybe<Scalars['Int']>;
  notEqualTo?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type Intervention = Entry & {
  __typename?: 'Intervention';
  contentfulMetadata: ContentfulMetadata;
  coverImage?: Maybe<Scalars['Boolean']>;
  externalId?: Maybe<Scalars['String']>;
  interventionContentowner?: Maybe<ContentOwner>;
  interventionDuration?: Maybe<Scalars['Int']>;
  interventionId?: Maybe<Scalars['String']>;
  interventionImage?: Maybe<Asset>;
  interventionLevel?: Maybe<Scalars['String']>;
  interventionStatusEnddate?: Maybe<Scalars['DateTime']>;
  interventionStatusLabel?: Maybe<Scalars['String']>;
  interventionSurtitle?: Maybe<Scalars['String']>;
  interventionTemplatesCollection?: Maybe<InterventionInterventionTemplatesCollection>;
  interventionText?: Maybe<Scalars['String']>;
  interventionTitle?: Maybe<Scalars['String']>;
  interventionTopicsCollection?: Maybe<InterventionInterventionTopicsCollection>;
  interventionType?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<InterventionLinkingCollections>;
  skillTagsCollection?: Maybe<InterventionSkillTagsCollection>;
  sys: Sys;
  tenantCollection?: Maybe<InterventionTenantCollection>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionCoverImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionExternalIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionContentownerArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionDurationArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionLevelArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionStatusEnddateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionStatusLabelArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionSurtitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionTemplatesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionInterventionTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionSkillTagsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Creates a new episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/intervention) */
export type InterventionTenantCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type InterventionCollection = {
  __typename?: 'InterventionCollection';
  items: Array<Maybe<Intervention>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type InterventionFilter = {
  AND?: InputMaybe<Array<InputMaybe<InterventionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<InterventionFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  coverImage?: InputMaybe<Scalars['Boolean']>;
  coverImage_exists?: InputMaybe<Scalars['Boolean']>;
  coverImage_not?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalId_contains?: InputMaybe<Scalars['String']>;
  externalId_exists?: InputMaybe<Scalars['Boolean']>;
  externalId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalId_not?: InputMaybe<Scalars['String']>;
  externalId_not_contains?: InputMaybe<Scalars['String']>;
  externalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionContentowner?: InputMaybe<CfContentOwnerNestedFilter>;
  interventionContentowner_exists?: InputMaybe<Scalars['Boolean']>;
  interventionDuration?: InputMaybe<Scalars['Int']>;
  interventionDuration_exists?: InputMaybe<Scalars['Boolean']>;
  interventionDuration_gt?: InputMaybe<Scalars['Int']>;
  interventionDuration_gte?: InputMaybe<Scalars['Int']>;
  interventionDuration_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  interventionDuration_lt?: InputMaybe<Scalars['Int']>;
  interventionDuration_lte?: InputMaybe<Scalars['Int']>;
  interventionDuration_not?: InputMaybe<Scalars['Int']>;
  interventionDuration_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  interventionId?: InputMaybe<Scalars['String']>;
  interventionId_contains?: InputMaybe<Scalars['String']>;
  interventionId_exists?: InputMaybe<Scalars['Boolean']>;
  interventionId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionId_not?: InputMaybe<Scalars['String']>;
  interventionId_not_contains?: InputMaybe<Scalars['String']>;
  interventionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionImage_exists?: InputMaybe<Scalars['Boolean']>;
  interventionLevel?: InputMaybe<Scalars['String']>;
  interventionLevel_contains?: InputMaybe<Scalars['String']>;
  interventionLevel_exists?: InputMaybe<Scalars['Boolean']>;
  interventionLevel_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionLevel_not?: InputMaybe<Scalars['String']>;
  interventionLevel_not_contains?: InputMaybe<Scalars['String']>;
  interventionLevel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionStatusEnddate?: InputMaybe<Scalars['DateTime']>;
  interventionStatusEnddate_exists?: InputMaybe<Scalars['Boolean']>;
  interventionStatusEnddate_gt?: InputMaybe<Scalars['DateTime']>;
  interventionStatusEnddate_gte?: InputMaybe<Scalars['DateTime']>;
  interventionStatusEnddate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  interventionStatusEnddate_lt?: InputMaybe<Scalars['DateTime']>;
  interventionStatusEnddate_lte?: InputMaybe<Scalars['DateTime']>;
  interventionStatusEnddate_not?: InputMaybe<Scalars['DateTime']>;
  interventionStatusEnddate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  interventionStatusLabel?: InputMaybe<Scalars['String']>;
  interventionStatusLabel_contains?: InputMaybe<Scalars['String']>;
  interventionStatusLabel_exists?: InputMaybe<Scalars['Boolean']>;
  interventionStatusLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionStatusLabel_not?: InputMaybe<Scalars['String']>;
  interventionStatusLabel_not_contains?: InputMaybe<Scalars['String']>;
  interventionStatusLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionSurtitle?: InputMaybe<Scalars['String']>;
  interventionSurtitle_contains?: InputMaybe<Scalars['String']>;
  interventionSurtitle_exists?: InputMaybe<Scalars['Boolean']>;
  interventionSurtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionSurtitle_not?: InputMaybe<Scalars['String']>;
  interventionSurtitle_not_contains?: InputMaybe<Scalars['String']>;
  interventionSurtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionTemplatesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  interventionText?: InputMaybe<Scalars['String']>;
  interventionText_contains?: InputMaybe<Scalars['String']>;
  interventionText_exists?: InputMaybe<Scalars['Boolean']>;
  interventionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionText_not?: InputMaybe<Scalars['String']>;
  interventionText_not_contains?: InputMaybe<Scalars['String']>;
  interventionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionTitle?: InputMaybe<Scalars['String']>;
  interventionTitle_contains?: InputMaybe<Scalars['String']>;
  interventionTitle_exists?: InputMaybe<Scalars['Boolean']>;
  interventionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionTitle_not?: InputMaybe<Scalars['String']>;
  interventionTitle_not_contains?: InputMaybe<Scalars['String']>;
  interventionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionTopicsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  interventionType?: InputMaybe<Scalars['String']>;
  interventionType_contains?: InputMaybe<Scalars['String']>;
  interventionType_exists?: InputMaybe<Scalars['Boolean']>;
  interventionType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionType_not?: InputMaybe<Scalars['String']>;
  interventionType_not_contains?: InputMaybe<Scalars['String']>;
  interventionType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skillTagsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  tenantCollection_exists?: InputMaybe<Scalars['Boolean']>;
};

export type InterventionInterventionTemplatesCollection = {
  __typename?: 'InterventionInterventionTemplatesCollection';
  items: Array<Maybe<InterventionInterventionTemplatesItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type InterventionInterventionTemplatesItem = ElementText | TemplateAssessment | TemplateBreakM | TemplateCarousel | TemplateCoberq | TemplateFactsFigures | TemplateFileShare | TemplateHarmonica | TemplateHotspot | TemplateMpcCards | TemplateMpcMultipleCorrect | TemplateMpcOneCorrect | TemplateOpenQuestion | TemplatePoll | TemplateScrollingAnalysis | TemplateSlider | TemplateTextImage | TemplateTextVideoImage | TemplateTrueFalseCards | TemplateVideo;

export type InterventionInterventionTopicsCollection = {
  __typename?: 'InterventionInterventionTopicsCollection';
  items: Array<Maybe<TopicTag>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type InterventionLinkingCollections = {
  __typename?: 'InterventionLinkingCollections';
  bundleCollection?: Maybe<BundleCollection>;
  entryCollection?: Maybe<EntryCollection>;
  homeCollection?: Maybe<HomeCollection>;
  notificationCollection?: Maybe<NotificationCollection>;
  rowCollection?: Maybe<RowCollection>;
};


export type InterventionLinkingCollectionsBundleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type InterventionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type InterventionLinkingCollectionsHomeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type InterventionLinkingCollectionsNotificationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type InterventionLinkingCollectionsRowCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum InterventionOrder {
  CoverImageAsc = 'coverImage_ASC',
  CoverImageDesc = 'coverImage_DESC',
  ExternalIdAsc = 'externalId_ASC',
  ExternalIdDesc = 'externalId_DESC',
  InterventionDurationAsc = 'interventionDuration_ASC',
  InterventionDurationDesc = 'interventionDuration_DESC',
  InterventionIdAsc = 'interventionId_ASC',
  InterventionIdDesc = 'interventionId_DESC',
  InterventionLevelAsc = 'interventionLevel_ASC',
  InterventionLevelDesc = 'interventionLevel_DESC',
  InterventionStatusEnddateAsc = 'interventionStatusEnddate_ASC',
  InterventionStatusEnddateDesc = 'interventionStatusEnddate_DESC',
  InterventionStatusLabelAsc = 'interventionStatusLabel_ASC',
  InterventionStatusLabelDesc = 'interventionStatusLabel_DESC',
  InterventionSurtitleAsc = 'interventionSurtitle_ASC',
  InterventionSurtitleDesc = 'interventionSurtitle_DESC',
  InterventionTitleAsc = 'interventionTitle_ASC',
  InterventionTitleDesc = 'interventionTitle_DESC',
  InterventionTypeAsc = 'interventionType_ASC',
  InterventionTypeDesc = 'interventionType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type InterventionSkillTagsCollection = {
  __typename?: 'InterventionSkillTagsCollection';
  items: Array<Maybe<Skill>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type InterventionTenantCollection = {
  __typename?: 'InterventionTenantCollection';
  items: Array<Maybe<Academy>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConcept = Entry & {
  __typename?: 'LearningConcept';
  collectionId?: Maybe<Array<Maybe<Scalars['String']>>>;
  conceptColour?: Maybe<Scalars['String']>;
  conceptImage?: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  headerGradient?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  learningConceptEndDate?: Maybe<Scalars['DateTime']>;
  learningConceptStatusLabel?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<LearningConceptLinkingCollections>;
  sectionsCollection?: Maybe<LearningConceptSectionsCollection>;
  sys: Sys;
  tenantCollection?: Maybe<LearningConceptTenantCollection>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptCollectionIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptConceptColourArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptConceptImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptExternalIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptHeaderGradientArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptLearningConceptEndDateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptLearningConceptStatusLabelArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptSectionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptTenantCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/learningConcept) */
export type LearningConceptTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type LearningConceptCollection = {
  __typename?: 'LearningConceptCollection';
  items: Array<Maybe<LearningConcept>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type LearningConceptFilter = {
  AND?: InputMaybe<Array<InputMaybe<LearningConceptFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LearningConceptFilter>>>;
  collectionId_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectionId_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectionId_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectionId_exists?: InputMaybe<Scalars['Boolean']>;
  conceptColour?: InputMaybe<Scalars['String']>;
  conceptColour_contains?: InputMaybe<Scalars['String']>;
  conceptColour_exists?: InputMaybe<Scalars['Boolean']>;
  conceptColour_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  conceptColour_not?: InputMaybe<Scalars['String']>;
  conceptColour_not_contains?: InputMaybe<Scalars['String']>;
  conceptColour_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  conceptImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalId?: InputMaybe<Scalars['String']>;
  externalId_contains?: InputMaybe<Scalars['String']>;
  externalId_exists?: InputMaybe<Scalars['Boolean']>;
  externalId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalId_not?: InputMaybe<Scalars['String']>;
  externalId_not_contains?: InputMaybe<Scalars['String']>;
  externalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headerGradient?: InputMaybe<Scalars['Boolean']>;
  headerGradient_exists?: InputMaybe<Scalars['Boolean']>;
  headerGradient_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  learningConceptEndDate?: InputMaybe<Scalars['DateTime']>;
  learningConceptEndDate_exists?: InputMaybe<Scalars['Boolean']>;
  learningConceptEndDate_gt?: InputMaybe<Scalars['DateTime']>;
  learningConceptEndDate_gte?: InputMaybe<Scalars['DateTime']>;
  learningConceptEndDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  learningConceptEndDate_lt?: InputMaybe<Scalars['DateTime']>;
  learningConceptEndDate_lte?: InputMaybe<Scalars['DateTime']>;
  learningConceptEndDate_not?: InputMaybe<Scalars['DateTime']>;
  learningConceptEndDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  learningConceptStatusLabel?: InputMaybe<Scalars['String']>;
  learningConceptStatusLabel_contains?: InputMaybe<Scalars['String']>;
  learningConceptStatusLabel_exists?: InputMaybe<Scalars['Boolean']>;
  learningConceptStatusLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  learningConceptStatusLabel_not?: InputMaybe<Scalars['String']>;
  learningConceptStatusLabel_not_contains?: InputMaybe<Scalars['String']>;
  learningConceptStatusLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  tenantCollection_exists?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LearningConceptLinkingCollections = {
  __typename?: 'LearningConceptLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  rowCollection?: Maybe<RowCollection>;
};


export type LearningConceptLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type LearningConceptLinkingCollectionsRowCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum LearningConceptOrder {
  ConceptColourAsc = 'conceptColour_ASC',
  ConceptColourDesc = 'conceptColour_DESC',
  ExternalIdAsc = 'externalId_ASC',
  ExternalIdDesc = 'externalId_DESC',
  HeaderGradientAsc = 'headerGradient_ASC',
  HeaderGradientDesc = 'headerGradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LearningConceptEndDateAsc = 'learningConceptEndDate_ASC',
  LearningConceptEndDateDesc = 'learningConceptEndDate_DESC',
  LearningConceptStatusLabelAsc = 'learningConceptStatusLabel_ASC',
  LearningConceptStatusLabelDesc = 'learningConceptStatusLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type LearningConceptSectionsCollection = {
  __typename?: 'LearningConceptSectionsCollection';
  items: Array<Maybe<Section>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type LearningConceptTenantCollection = {
  __typename?: 'LearningConceptTenantCollection';
  items: Array<Maybe<Academy>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type Location = {
  __typename?: 'Location';
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createAttribute?: Maybe<CreateAttributePayload>;
  createCatalogueItemsGroup?: Maybe<CreateCatalogueItemsGroupPayload>;
  createGroup?: Maybe<CreateGroupPayload>;
  createGroupsUser?: Maybe<CreateGroupsUserPayload>;
  createTenantsGroup?: Maybe<CreateTenantsGroupPayload>;
  createUser?: Maybe<CreateUserPayload>;
  deleteAttribute?: Maybe<DeleteAttributePayload>;
  deleteAttributeByCognitoName?: Maybe<DeleteAttributePayload>;
  deleteAttributeByKey?: Maybe<DeleteAttributePayload>;
  deleteAttributeByNodeId?: Maybe<DeleteAttributePayload>;
  deleteGroup?: Maybe<DeleteGroupPayload>;
  deleteGroupByNodeId?: Maybe<DeleteGroupPayload>;
  deleteUser?: Maybe<DeleteUserPayload>;
  deleteUserByNodeId?: Maybe<DeleteUserPayload>;
  removeGroupFromCatalogueItem?: Maybe<RemoveGroupFromCatalogueItemPayload>;
  removeGroupFromTenant?: Maybe<RemoveGroupFromTenantPayload>;
  removeUserFromGroup?: Maybe<RemoveUserFromGroupPayload>;
  sendReminderEmail?: Maybe<SendReminderEmailPayload>;
  updateAttribute?: Maybe<UpdateAttributePayload>;
  updateAttributeByCognitoName?: Maybe<UpdateAttributePayload>;
  updateAttributeByKey?: Maybe<UpdateAttributePayload>;
  updateAttributeByNodeId?: Maybe<UpdateAttributePayload>;
  updateGroup?: Maybe<UpdateGroupPayload>;
  updateGroupByNodeId?: Maybe<UpdateGroupPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateUserByNodeId?: Maybe<UpdateUserPayload>;
};


export type MutationCreateAttributeArgs = {
  input: CreateAttributeInput;
};


export type MutationCreateCatalogueItemsGroupArgs = {
  input: CreateCatalogueItemsGroupInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateGroupsUserArgs = {
  input: CreateGroupsUserInput;
};


export type MutationCreateTenantsGroupArgs = {
  input: CreateTenantsGroupInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteAttributeArgs = {
  input: DeleteAttributeInput;
};


export type MutationDeleteAttributeByCognitoNameArgs = {
  input: DeleteAttributeByCognitoNameInput;
};


export type MutationDeleteAttributeByKeyArgs = {
  input: DeleteAttributeByKeyInput;
};


export type MutationDeleteAttributeByNodeIdArgs = {
  input: DeleteAttributeByNodeIdInput;
};


export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


export type MutationDeleteGroupByNodeIdArgs = {
  input: DeleteGroupByNodeIdInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteUserByNodeIdArgs = {
  input: DeleteUserByNodeIdInput;
};


export type MutationRemoveGroupFromCatalogueItemArgs = {
  input: RemoveGroupFromCatalogueItemInput;
};


export type MutationRemoveGroupFromTenantArgs = {
  input: RemoveGroupFromTenantInput;
};


export type MutationRemoveUserFromGroupArgs = {
  input: RemoveUserFromGroupInput;
};


export type MutationSendReminderEmailArgs = {
  input: SendReminderEmailInput;
};


export type MutationUpdateAttributeArgs = {
  input: UpdateAttributeInput;
};


export type MutationUpdateAttributeByCognitoNameArgs = {
  input: UpdateAttributeByCognitoNameInput;
};


export type MutationUpdateAttributeByKeyArgs = {
  input: UpdateAttributeByKeyInput;
};


export type MutationUpdateAttributeByNodeIdArgs = {
  input: UpdateAttributeByNodeIdInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateGroupByNodeIdArgs = {
  input: UpdateGroupByNodeIdInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserByNodeIdArgs = {
  input: UpdateUserByNodeIdInput;
};

export type Node = {
  nodeId: Scalars['ID'];
};

/** Creates a notification that is displayed in the notification list. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/notification) */
export type Notification = Entry & {
  __typename?: 'Notification';
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<NotificationLinkingCollections>;
  notificationId?: Maybe<Scalars['String']>;
  notificationReference?: Maybe<NotificationNotificationReference>;
  sys: Sys;
};


/** Creates a notification that is displayed in the notification list. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/notification) */
export type NotificationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Creates a notification that is displayed in the notification list. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/notification) */
export type NotificationNotificationIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a notification that is displayed in the notification list. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/notification) */
export type NotificationNotificationReferenceArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationCollection = {
  __typename?: 'NotificationCollection';
  items: Array<Maybe<Notification>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type NotificationFilter = {
  AND?: InputMaybe<Array<InputMaybe<NotificationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NotificationFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  notificationId?: InputMaybe<Scalars['String']>;
  notificationId_contains?: InputMaybe<Scalars['String']>;
  notificationId_exists?: InputMaybe<Scalars['Boolean']>;
  notificationId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notificationId_not?: InputMaybe<Scalars['String']>;
  notificationId_not_contains?: InputMaybe<Scalars['String']>;
  notificationId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notificationReference_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type NotificationLinkingCollections = {
  __typename?: 'NotificationLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type NotificationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type NotificationNotificationReference = Intervention;

export enum NotificationOrder {
  NotificationIdAsc = 'notificationId_ASC',
  NotificationIdDesc = 'notificationId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type Opportunity = Entry & {
  __typename?: 'Opportunity';
  additionalCompensationInfo?: Maybe<Scalars['String']>;
  additionalExpiryDateInfo?: Maybe<Scalars['String']>;
  additionalInformationOnJob?: Maybe<Scalars['String']>;
  additionalLocationInfo?: Maybe<Scalars['String']>;
  additionalStartDateInfo?: Maybe<Scalars['String']>;
  companyImage?: Maybe<Asset>;
  compensation?: Maybe<Scalars['String']>;
  contentOwner?: Maybe<ContentOwner>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  elementId?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  headerImage?: Maybe<Asset>;
  imageOnCard?: Maybe<Asset>;
  linkedFrom?: Maybe<OpportunityLinkingCollections>;
  location?: Maybe<Scalars['String']>;
  opportunityType?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  statusEndDate?: Maybe<Scalars['DateTime']>;
  statusLabel?: Maybe<Scalars['String']>;
  surtitle?: Maybe<Scalars['String']>;
  sys: Sys;
  tenantCollection?: Maybe<OpportunityTenantCollection>;
  text?: Maybe<ElementText>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityAdditionalCompensationInfoArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityAdditionalExpiryDateInfoArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityAdditionalInformationOnJobArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityAdditionalLocationInfoArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityAdditionalStartDateInfoArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityCompanyImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityCompensationArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityContentOwnerArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityExpiryDateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityHeaderImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityImageOnCardArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityLocationArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityOpportunityTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityStartDateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityStatusEndDateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityStatusLabelArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunitySurtitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityTenantCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Add the content type opportunity [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/opportunity) */
export type OpportunityUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type OpportunityCollection = {
  __typename?: 'OpportunityCollection';
  items: Array<Maybe<Opportunity>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type OpportunityFilter = {
  AND?: InputMaybe<Array<InputMaybe<OpportunityFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<OpportunityFilter>>>;
  additionalCompensationInfo?: InputMaybe<Scalars['String']>;
  additionalCompensationInfo_contains?: InputMaybe<Scalars['String']>;
  additionalCompensationInfo_exists?: InputMaybe<Scalars['Boolean']>;
  additionalCompensationInfo_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  additionalCompensationInfo_not?: InputMaybe<Scalars['String']>;
  additionalCompensationInfo_not_contains?: InputMaybe<Scalars['String']>;
  additionalCompensationInfo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  additionalExpiryDateInfo?: InputMaybe<Scalars['String']>;
  additionalExpiryDateInfo_contains?: InputMaybe<Scalars['String']>;
  additionalExpiryDateInfo_exists?: InputMaybe<Scalars['Boolean']>;
  additionalExpiryDateInfo_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  additionalExpiryDateInfo_not?: InputMaybe<Scalars['String']>;
  additionalExpiryDateInfo_not_contains?: InputMaybe<Scalars['String']>;
  additionalExpiryDateInfo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  additionalInformationOnJob?: InputMaybe<Scalars['String']>;
  additionalInformationOnJob_contains?: InputMaybe<Scalars['String']>;
  additionalInformationOnJob_exists?: InputMaybe<Scalars['Boolean']>;
  additionalInformationOnJob_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  additionalInformationOnJob_not?: InputMaybe<Scalars['String']>;
  additionalInformationOnJob_not_contains?: InputMaybe<Scalars['String']>;
  additionalInformationOnJob_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  additionalLocationInfo?: InputMaybe<Scalars['String']>;
  additionalLocationInfo_contains?: InputMaybe<Scalars['String']>;
  additionalLocationInfo_exists?: InputMaybe<Scalars['Boolean']>;
  additionalLocationInfo_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  additionalLocationInfo_not?: InputMaybe<Scalars['String']>;
  additionalLocationInfo_not_contains?: InputMaybe<Scalars['String']>;
  additionalLocationInfo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  additionalStartDateInfo?: InputMaybe<Scalars['String']>;
  additionalStartDateInfo_contains?: InputMaybe<Scalars['String']>;
  additionalStartDateInfo_exists?: InputMaybe<Scalars['Boolean']>;
  additionalStartDateInfo_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  additionalStartDateInfo_not?: InputMaybe<Scalars['String']>;
  additionalStartDateInfo_not_contains?: InputMaybe<Scalars['String']>;
  additionalStartDateInfo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyImage_exists?: InputMaybe<Scalars['Boolean']>;
  compensation?: InputMaybe<Scalars['String']>;
  compensation_contains?: InputMaybe<Scalars['String']>;
  compensation_exists?: InputMaybe<Scalars['Boolean']>;
  compensation_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  compensation_not?: InputMaybe<Scalars['String']>;
  compensation_not_contains?: InputMaybe<Scalars['String']>;
  compensation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentOwner?: InputMaybe<CfContentOwnerNestedFilter>;
  contentOwner_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  expiryDate_exists?: InputMaybe<Scalars['Boolean']>;
  expiryDate_gt?: InputMaybe<Scalars['DateTime']>;
  expiryDate_gte?: InputMaybe<Scalars['DateTime']>;
  expiryDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  expiryDate_lt?: InputMaybe<Scalars['DateTime']>;
  expiryDate_lte?: InputMaybe<Scalars['DateTime']>;
  expiryDate_not?: InputMaybe<Scalars['DateTime']>;
  expiryDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  headerImage_exists?: InputMaybe<Scalars['Boolean']>;
  imageOnCard_exists?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  location_contains?: InputMaybe<Scalars['String']>;
  location_exists?: InputMaybe<Scalars['Boolean']>;
  location_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  location_not?: InputMaybe<Scalars['String']>;
  location_not_contains?: InputMaybe<Scalars['String']>;
  location_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  opportunityType?: InputMaybe<Scalars['String']>;
  opportunityType_contains?: InputMaybe<Scalars['String']>;
  opportunityType_exists?: InputMaybe<Scalars['Boolean']>;
  opportunityType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  opportunityType_not?: InputMaybe<Scalars['String']>;
  opportunityType_not_contains?: InputMaybe<Scalars['String']>;
  opportunityType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startDate_exists?: InputMaybe<Scalars['Boolean']>;
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  startDate_not?: InputMaybe<Scalars['DateTime']>;
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  statusEndDate?: InputMaybe<Scalars['DateTime']>;
  statusEndDate_exists?: InputMaybe<Scalars['Boolean']>;
  statusEndDate_gt?: InputMaybe<Scalars['DateTime']>;
  statusEndDate_gte?: InputMaybe<Scalars['DateTime']>;
  statusEndDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  statusEndDate_lt?: InputMaybe<Scalars['DateTime']>;
  statusEndDate_lte?: InputMaybe<Scalars['DateTime']>;
  statusEndDate_not?: InputMaybe<Scalars['DateTime']>;
  statusEndDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  statusLabel?: InputMaybe<Scalars['String']>;
  statusLabel_contains?: InputMaybe<Scalars['String']>;
  statusLabel_exists?: InputMaybe<Scalars['Boolean']>;
  statusLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusLabel_not?: InputMaybe<Scalars['String']>;
  statusLabel_not_contains?: InputMaybe<Scalars['String']>;
  statusLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  surtitle?: InputMaybe<Scalars['String']>;
  surtitle_contains?: InputMaybe<Scalars['String']>;
  surtitle_exists?: InputMaybe<Scalars['Boolean']>;
  surtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  surtitle_not?: InputMaybe<Scalars['String']>;
  surtitle_not_contains?: InputMaybe<Scalars['String']>;
  surtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  tenantCollection_exists?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<CfElementTextNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  url_contains?: InputMaybe<Scalars['String']>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_not?: InputMaybe<Scalars['String']>;
  url_not_contains?: InputMaybe<Scalars['String']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpportunityLinkingCollections = {
  __typename?: 'OpportunityLinkingCollections';
  bundleCollection?: Maybe<BundleCollection>;
  entryCollection?: Maybe<EntryCollection>;
  rowCollection?: Maybe<RowCollection>;
};


export type OpportunityLinkingCollectionsBundleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type OpportunityLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type OpportunityLinkingCollectionsRowCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum OpportunityOrder {
  AdditionalCompensationInfoAsc = 'additionalCompensationInfo_ASC',
  AdditionalCompensationInfoDesc = 'additionalCompensationInfo_DESC',
  AdditionalExpiryDateInfoAsc = 'additionalExpiryDateInfo_ASC',
  AdditionalExpiryDateInfoDesc = 'additionalExpiryDateInfo_DESC',
  AdditionalInformationOnJobAsc = 'additionalInformationOnJob_ASC',
  AdditionalInformationOnJobDesc = 'additionalInformationOnJob_DESC',
  AdditionalLocationInfoAsc = 'additionalLocationInfo_ASC',
  AdditionalLocationInfoDesc = 'additionalLocationInfo_DESC',
  AdditionalStartDateInfoAsc = 'additionalStartDateInfo_ASC',
  AdditionalStartDateInfoDesc = 'additionalStartDateInfo_DESC',
  CompensationAsc = 'compensation_ASC',
  CompensationDesc = 'compensation_DESC',
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ExpiryDateAsc = 'expiryDate_ASC',
  ExpiryDateDesc = 'expiryDate_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  OpportunityTypeAsc = 'opportunityType_ASC',
  OpportunityTypeDesc = 'opportunityType_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  StatusEndDateAsc = 'statusEndDate_ASC',
  StatusEndDateDesc = 'statusEndDate_DESC',
  StatusLabelAsc = 'statusLabel_ASC',
  StatusLabelDesc = 'statusLabel_DESC',
  SurtitleAsc = 'surtitle_ASC',
  SurtitleDesc = 'surtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type OpportunityTenantCollection = {
  __typename?: 'OpportunityTenantCollection';
  items: Array<Maybe<Academy>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Query = Node & {
  __typename?: 'Query';
  academy?: Maybe<Academy>;
  academyCollection?: Maybe<AcademyCollection>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  attribute?: Maybe<Attribute>;
  attributeByCognitoName?: Maybe<Attribute>;
  attributeByKey?: Maybe<Attribute>;
  attributeByNodeId?: Maybe<Attribute>;
  attributes?: Maybe<AttributesConnection>;
  bundle?: Maybe<Bundle>;
  bundleCollection?: Maybe<BundleCollection>;
  catalogueItems?: Maybe<CatalogueItemsConnection>;
  catalogueItemsGroups?: Maybe<CatalogueItemsGroupsConnection>;
  contentOwner?: Maybe<ContentOwner>;
  contentOwnerCollection?: Maybe<ContentOwnerCollection>;
  elementText?: Maybe<ElementText>;
  elementTextCollection?: Maybe<ElementTextCollection>;
  entryCollection?: Maybe<EntryCollection>;
  event?: Maybe<Event>;
  eventCollection?: Maybe<EventCollection>;
  externalLinkEmbed?: Maybe<ExternalLinkEmbed>;
  externalLinkEmbedCollection?: Maybe<ExternalLinkEmbedCollection>;
  fact?: Maybe<Fact>;
  factCollection?: Maybe<FactCollection>;
  glossaryItem?: Maybe<GlossaryItem>;
  glossaryItemCollection?: Maybe<GlossaryItemCollection>;
  group?: Maybe<Group>;
  groupByNodeId?: Maybe<Group>;
  groups?: Maybe<GroupsConnection>;
  groupsUsers?: Maybe<GroupsUsersConnection>;
  home?: Maybe<Home>;
  homeCollection?: Maybe<HomeCollection>;
  intervention?: Maybe<Intervention>;
  interventionCollection?: Maybe<InterventionCollection>;
  learningConcept?: Maybe<LearningConcept>;
  learningConceptCollection?: Maybe<LearningConceptCollection>;
  node?: Maybe<Node>;
  nodeId: Scalars['ID'];
  notification?: Maybe<Notification>;
  notificationCollection?: Maybe<NotificationCollection>;
  opportunity?: Maybe<Opportunity>;
  opportunityCollection?: Maybe<OpportunityCollection>;
  query: Query;
  row?: Maybe<Row>;
  rowCollection?: Maybe<RowCollection>;
  section?: Maybe<Section>;
  sectionCollection?: Maybe<SectionCollection>;
  skill?: Maybe<Skill>;
  skillCollection?: Maybe<SkillCollection>;
  story?: Maybe<Story>;
  storyCollection?: Maybe<StoryCollection>;
  systemText?: Maybe<SystemText>;
  systemTextCollection?: Maybe<SystemTextCollection>;
  temp?: Maybe<Scalars['String']>;
  templateAssessment?: Maybe<TemplateAssessment>;
  templateAssessmentCollection?: Maybe<TemplateAssessmentCollection>;
  templateBreakM?: Maybe<TemplateBreakM>;
  templateBreakMCollection?: Maybe<TemplateBreakMCollection>;
  templateCarousel?: Maybe<TemplateCarousel>;
  templateCarouselCollection?: Maybe<TemplateCarouselCollection>;
  templateCoberq?: Maybe<TemplateCoberq>;
  templateCoberqCollection?: Maybe<TemplateCoberqCollection>;
  templateFactsFigures?: Maybe<TemplateFactsFigures>;
  templateFactsFiguresCollection?: Maybe<TemplateFactsFiguresCollection>;
  templateFileShare?: Maybe<TemplateFileShare>;
  templateFileShareCollection?: Maybe<TemplateFileShareCollection>;
  templateHarmonica?: Maybe<TemplateHarmonica>;
  templateHarmonicaCollection?: Maybe<TemplateHarmonicaCollection>;
  templateHotspot?: Maybe<TemplateHotspot>;
  templateHotspotCollection?: Maybe<TemplateHotspotCollection>;
  templateMpcCards?: Maybe<TemplateMpcCards>;
  templateMpcCardsCollection?: Maybe<TemplateMpcCardsCollection>;
  templateMpcMultipleCorrect?: Maybe<TemplateMpcMultipleCorrect>;
  templateMpcMultipleCorrectCollection?: Maybe<TemplateMpcMultipleCorrectCollection>;
  templateMpcOneCorrect?: Maybe<TemplateMpcOneCorrect>;
  templateMpcOneCorrectCollection?: Maybe<TemplateMpcOneCorrectCollection>;
  templateOpenQuestion?: Maybe<TemplateOpenQuestion>;
  templateOpenQuestionCollection?: Maybe<TemplateOpenQuestionCollection>;
  templatePoll?: Maybe<TemplatePoll>;
  templatePollCollection?: Maybe<TemplatePollCollection>;
  templateScrollingAnalysis?: Maybe<TemplateScrollingAnalysis>;
  templateScrollingAnalysisCollection?: Maybe<TemplateScrollingAnalysisCollection>;
  templateSlider?: Maybe<TemplateSlider>;
  templateSliderCollection?: Maybe<TemplateSliderCollection>;
  templateTextImage?: Maybe<TemplateTextImage>;
  templateTextImageCollection?: Maybe<TemplateTextImageCollection>;
  templateTextVideoImage?: Maybe<TemplateTextVideoImage>;
  templateTextVideoImageCollection?: Maybe<TemplateTextVideoImageCollection>;
  templateTrueFalseCards?: Maybe<TemplateTrueFalseCards>;
  templateTrueFalseCardsCollection?: Maybe<TemplateTrueFalseCardsCollection>;
  templateVideo?: Maybe<TemplateVideo>;
  templateVideoCollection?: Maybe<TemplateVideoCollection>;
  tenants?: Maybe<TenantsConnection>;
  tenantsGroups?: Maybe<TenantsGroupsConnection>;
  testingMpcOneCorrect?: Maybe<TestingMpcOneCorrect>;
  testingMpcOneCorrectCollection?: Maybe<TestingMpcOneCorrectCollection>;
  topicTag?: Maybe<TopicTag>;
  topicTagCollection?: Maybe<TopicTagCollection>;
  user?: Maybe<User>;
  userByNodeId?: Maybe<User>;
  users?: Maybe<UsersConnection>;
};


export type QueryAcademyArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAcademyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AcademyOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AcademyFilter>;
};


export type QueryAssetArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryAttributeArgs = {
  id: Scalars['ID'];
};


export type QueryAttributeByCognitoNameArgs = {
  cognitoName: Scalars['String'];
};


export type QueryAttributeByKeyArgs = {
  key: Scalars['String'];
};


export type QueryAttributeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


export type QueryAttributesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<AttributeCondition>;
  filter?: InputMaybe<AttributeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AttributesOrderBy>>;
};


export type QueryBundleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBundleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BundleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BundleFilter>;
};


export type QueryCatalogueItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<CatalogueItemCondition>;
  filter?: InputMaybe<CatalogueItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CatalogueItemsOrderBy>>;
};


export type QueryCatalogueItemsGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<CatalogueItemsGroupCondition>;
  filter?: InputMaybe<CatalogueItemsGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CatalogueItemsGroupsOrderBy>>;
};


export type QueryContentOwnerArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryContentOwnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ContentOwnerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentOwnerFilter>;
};


export type QueryElementTextArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryElementTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ElementTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ElementTextFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryEventArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<EventOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventFilter>;
};


export type QueryExternalLinkEmbedArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryExternalLinkEmbedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ExternalLinkEmbedOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ExternalLinkEmbedFilter>;
};


export type QueryFactArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFactCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FactOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FactFilter>;
};


export type QueryGlossaryItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGlossaryItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<GlossaryItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GlossaryItemFilter>;
};


export type QueryGroupArgs = {
  name: Scalars['String'];
};


export type QueryGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type QueryGroupsUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<GroupsUserCondition>;
  filter?: InputMaybe<GroupsUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsUsersOrderBy>>;
};


export type QueryHomeArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHomeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HomeOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HomeFilter>;
};


export type QueryInterventionArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<InterventionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InterventionFilter>;
};


export type QueryLearningConceptArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLearningConceptCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<LearningConceptOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LearningConceptFilter>;
};


export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


export type QueryNotificationArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNotificationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NotificationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationFilter>;
};


export type QueryOpportunityArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOpportunityCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<OpportunityOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OpportunityFilter>;
};


export type QueryRowArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRowCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<RowOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RowFilter>;
};


export type QuerySectionArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionFilter>;
};


export type QuerySkillArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySkillCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SkillOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SkillFilter>;
};


export type QueryStoryArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryStoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<StoryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StoryFilter>;
};


export type QuerySystemTextArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySystemTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SystemTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SystemTextFilter>;
};


export type QueryTemplateAssessmentArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateAssessmentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateAssessmentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateAssessmentFilter>;
};


export type QueryTemplateBreakMArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateBreakMCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateBreakMOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateBreakMFilter>;
};


export type QueryTemplateCarouselArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateCarouselOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateCarouselFilter>;
};


export type QueryTemplateCoberqArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateCoberqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateCoberqOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateCoberqFilter>;
};


export type QueryTemplateFactsFiguresArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateFactsFiguresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateFactsFiguresOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateFactsFiguresFilter>;
};


export type QueryTemplateFileShareArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateFileShareCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateFileShareOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateFileShareFilter>;
};


export type QueryTemplateHarmonicaArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateHarmonicaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateHarmonicaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateHarmonicaFilter>;
};


export type QueryTemplateHotspotArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateHotspotCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateHotspotOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateHotspotFilter>;
};


export type QueryTemplateMpcCardsArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateMpcCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateMpcCardsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateMpcCardsFilter>;
};


export type QueryTemplateMpcMultipleCorrectArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateMpcMultipleCorrectCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateMpcMultipleCorrectOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateMpcMultipleCorrectFilter>;
};


export type QueryTemplateMpcOneCorrectArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateMpcOneCorrectCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateMpcOneCorrectOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateMpcOneCorrectFilter>;
};


export type QueryTemplateOpenQuestionArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateOpenQuestionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateOpenQuestionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateOpenQuestionFilter>;
};


export type QueryTemplatePollArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplatePollCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplatePollOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplatePollFilter>;
};


export type QueryTemplateScrollingAnalysisArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateScrollingAnalysisCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateScrollingAnalysisOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateScrollingAnalysisFilter>;
};


export type QueryTemplateSliderArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateSliderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateSliderFilter>;
};


export type QueryTemplateTextImageArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateTextImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateTextImageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateTextImageFilter>;
};


export type QueryTemplateTextVideoImageArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateTextVideoImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateTextVideoImageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateTextVideoImageFilter>;
};


export type QueryTemplateTrueFalseCardsArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateTrueFalseCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateTrueFalseCardsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateTrueFalseCardsFilter>;
};


export type QueryTemplateVideoArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTemplateVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TemplateVideoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateVideoFilter>;
};


export type QueryTenantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<TenantCondition>;
  filter?: InputMaybe<TenantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};


export type QueryTenantsGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<TenantsGroupCondition>;
  filter?: InputMaybe<TenantsGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TenantsGroupsOrderBy>>;
};


export type QueryTestingMpcOneCorrectArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTestingMpcOneCorrectCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TestingMpcOneCorrectOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TestingMpcOneCorrectFilter>;
};


export type QueryTopicTagArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTopicTagCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TopicTagOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TopicTagFilter>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type RemoveGroupFromCatalogueItemInput = {
  catalogueItemId?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
};

export type RemoveGroupFromCatalogueItemPayload = {
  __typename?: 'RemoveGroupFromCatalogueItemPayload';
  catalogueItemsGroup?: Maybe<CatalogueItemsGroup>;
  catalogueItemsGroupEdge?: Maybe<CatalogueItemsGroupsEdge>;
  clientMutationId?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  query?: Maybe<Query>;
};


export type RemoveGroupFromCatalogueItemPayloadCatalogueItemsGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<CatalogueItemsGroupsOrderBy>>;
};

export type RemoveGroupFromTenantInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  tenantInternalId?: InputMaybe<Scalars['String']>;
};

export type RemoveGroupFromTenantPayload = {
  __typename?: 'RemoveGroupFromTenantPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  query?: Maybe<Query>;
  tenantsGroup?: Maybe<TenantsGroup>;
  tenantsGroupEdge?: Maybe<TenantsGroupsEdge>;
};


export type RemoveGroupFromTenantPayloadTenantsGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantsGroupsOrderBy>>;
};

export type RemoveUserFromGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type RemoveUserFromGroupPayload = {
  __typename?: 'RemoveUserFromGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  groupsUser?: Maybe<GroupsUser>;
  groupsUserEdge?: Maybe<GroupsUsersEdge>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
};


export type RemoveUserFromGroupPayloadGroupsUserEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsUsersOrderBy>>;
};

/** Configure row displayed on homepage [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/row) */
export type Row = Entry & {
  __typename?: 'Row';
  configuration?: Maybe<Scalars['JSON']>;
  contentfulMetadata: ContentfulMetadata;
  elementId?: Maybe<Scalars['String']>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<RowLinkingCollections>;
  relatedEntriesCollection?: Maybe<RowRelatedEntriesCollection>;
  rowType?: Maybe<Scalars['String']>;
  surTitle?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** Configure row displayed on homepage [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/row) */
export type RowConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Configure row displayed on homepage [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/row) */
export type RowElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Configure row displayed on homepage [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/row) */
export type RowElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Configure row displayed on homepage [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/row) */
export type RowLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Configure row displayed on homepage [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/row) */
export type RowRelatedEntriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Configure row displayed on homepage [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/row) */
export type RowRowTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Configure row displayed on homepage [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/row) */
export type RowSurTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type RowCollection = {
  __typename?: 'RowCollection';
  items: Array<Maybe<Row>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type RowFilter = {
  AND?: InputMaybe<Array<InputMaybe<RowFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<RowFilter>>>;
  configuration_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedEntriesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  rowType?: InputMaybe<Scalars['String']>;
  rowType_contains?: InputMaybe<Scalars['String']>;
  rowType_exists?: InputMaybe<Scalars['Boolean']>;
  rowType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rowType_not?: InputMaybe<Scalars['String']>;
  rowType_not_contains?: InputMaybe<Scalars['String']>;
  rowType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  surTitle?: InputMaybe<Scalars['String']>;
  surTitle_contains?: InputMaybe<Scalars['String']>;
  surTitle_exists?: InputMaybe<Scalars['Boolean']>;
  surTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  surTitle_not?: InputMaybe<Scalars['String']>;
  surTitle_not_contains?: InputMaybe<Scalars['String']>;
  surTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type RowLinkingCollections = {
  __typename?: 'RowLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  homeCollection?: Maybe<HomeCollection>;
};


export type RowLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type RowLinkingCollectionsHomeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum RowOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  RowTypeAsc = 'rowType_ASC',
  RowTypeDesc = 'rowType_DESC',
  SurTitleAsc = 'surTitle_ASC',
  SurTitleDesc = 'surTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type RowRelatedEntriesCollection = {
  __typename?: 'RowRelatedEntriesCollection';
  items: Array<Maybe<RowRelatedEntriesItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type RowRelatedEntriesItem = ContentOwner | Event | ExternalLinkEmbed | Intervention | LearningConcept | Opportunity;

/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/section) */
export type Section = Entry & {
  __typename?: 'Section';
  bundlesCollection?: Maybe<SectionBundlesCollection>;
  contentfulMetadata: ContentfulMetadata;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<SectionLinkingCollections>;
  richDescription?: Maybe<SectionRichDescription>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/section) */
export type SectionBundlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/section) */
export type SectionExternalIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/section) */
export type SectionIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/section) */
export type SectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/section) */
export type SectionRichDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/section) */
export type SectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type SectionBundlesCollection = {
  __typename?: 'SectionBundlesCollection';
  items: Array<Maybe<Bundle>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SectionCollection = {
  __typename?: 'SectionCollection';
  items: Array<Maybe<Section>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionFilter>>>;
  bundlesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  externalId?: InputMaybe<Scalars['String']>;
  externalId_contains?: InputMaybe<Scalars['String']>;
  externalId_exists?: InputMaybe<Scalars['Boolean']>;
  externalId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalId_not?: InputMaybe<Scalars['String']>;
  externalId_not_contains?: InputMaybe<Scalars['String']>;
  externalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  richDescription_contains?: InputMaybe<Scalars['String']>;
  richDescription_exists?: InputMaybe<Scalars['Boolean']>;
  richDescription_not_contains?: InputMaybe<Scalars['String']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SectionLinkingCollections = {
  __typename?: 'SectionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  learningConceptCollection?: Maybe<LearningConceptCollection>;
};


export type SectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SectionLinkingCollectionsLearningConceptCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SectionOrder {
  ExternalIdAsc = 'externalId_ASC',
  ExternalIdDesc = 'externalId_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SectionRichDescription = {
  __typename?: 'SectionRichDescription';
  json: Scalars['JSON'];
  links: SectionRichDescriptionLinks;
};

export type SectionRichDescriptionAssets = {
  __typename?: 'SectionRichDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SectionRichDescriptionEntries = {
  __typename?: 'SectionRichDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SectionRichDescriptionLinks = {
  __typename?: 'SectionRichDescriptionLinks';
  assets: SectionRichDescriptionAssets;
  entries: SectionRichDescriptionEntries;
};

export type SendReminderEmailInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type SendReminderEmailPayload = {
  __typename?: 'SendReminderEmailPayload';
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

/** Adds the content type skill [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/skill) */
export type Skill = Entry & {
  __typename?: 'Skill';
  contentfulMetadata: ContentfulMetadata;
  elementId?: Maybe<Scalars['String']>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<SkillLinkingCollections>;
  sys: Sys;
};


/** Adds the content type skill [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/skill) */
export type SkillElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type skill [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/skill) */
export type SkillElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type skill [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/skill) */
export type SkillLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SkillCollection = {
  __typename?: 'SkillCollection';
  items: Array<Maybe<Skill>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SkillFilter = {
  AND?: InputMaybe<Array<InputMaybe<SkillFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SkillFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SkillLinkingCollections = {
  __typename?: 'SkillLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type SkillLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SkillLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SkillOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Creates a next up to connect episodes in a collection. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/story) */
export type Story = Entry & {
  __typename?: 'Story';
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<StoryLinkingCollections>;
  storyId?: Maybe<Scalars['String']>;
  storyText?: Maybe<StoryStoryText>;
  sys: Sys;
};


/** Creates a next up to connect episodes in a collection. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/story) */
export type StoryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Creates a next up to connect episodes in a collection. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/story) */
export type StoryStoryIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a next up to connect episodes in a collection. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/story) */
export type StoryStoryTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type StoryCollection = {
  __typename?: 'StoryCollection';
  items: Array<Maybe<Story>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type StoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<StoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StoryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  storyId?: InputMaybe<Scalars['String']>;
  storyId_contains?: InputMaybe<Scalars['String']>;
  storyId_exists?: InputMaybe<Scalars['Boolean']>;
  storyId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storyId_not?: InputMaybe<Scalars['String']>;
  storyId_not_contains?: InputMaybe<Scalars['String']>;
  storyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storyText_contains?: InputMaybe<Scalars['String']>;
  storyText_exists?: InputMaybe<Scalars['Boolean']>;
  storyText_not_contains?: InputMaybe<Scalars['String']>;
  sys?: InputMaybe<SysFilter>;
};

export type StoryLinkingCollections = {
  __typename?: 'StoryLinkingCollections';
  bundleCollection?: Maybe<BundleCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type StoryLinkingCollectionsBundleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type StoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum StoryOrder {
  StoryIdAsc = 'storyId_ASC',
  StoryIdDesc = 'storyId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type StoryStoryText = {
  __typename?: 'StoryStoryText';
  json: Scalars['JSON'];
  links: StoryStoryTextLinks;
};

export type StoryStoryTextAssets = {
  __typename?: 'StoryStoryTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type StoryStoryTextEntries = {
  __typename?: 'StoryStoryTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type StoryStoryTextLinks = {
  __typename?: 'StoryStoryTextLinks';
  assets: StoryStoryTextAssets;
  entries: StoryStoryTextEntries;
};

export type StringFilter = {
  distinctFrom?: InputMaybe<Scalars['String']>;
  distinctFromInsensitive?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  endsWithInsensitive?: InputMaybe<Scalars['String']>;
  equalTo?: InputMaybe<Scalars['String']>;
  equalToInsensitive?: InputMaybe<Scalars['String']>;
  greaterThan?: InputMaybe<Scalars['String']>;
  greaterThanInsensitive?: InputMaybe<Scalars['String']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  inInsensitive?: InputMaybe<Array<Scalars['String']>>;
  includes?: InputMaybe<Scalars['String']>;
  includesInsensitive?: InputMaybe<Scalars['String']>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['String']>;
  lessThanInsensitive?: InputMaybe<Scalars['String']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  like?: InputMaybe<Scalars['String']>;
  likeInsensitive?: InputMaybe<Scalars['String']>;
  notDistinctFrom?: InputMaybe<Scalars['String']>;
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']>;
  notEndsWith?: InputMaybe<Scalars['String']>;
  notEndsWithInsensitive?: InputMaybe<Scalars['String']>;
  notEqualTo?: InputMaybe<Scalars['String']>;
  notEqualToInsensitive?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  notInInsensitive?: InputMaybe<Array<Scalars['String']>>;
  notIncludes?: InputMaybe<Scalars['String']>;
  notIncludesInsensitive?: InputMaybe<Scalars['String']>;
  notLike?: InputMaybe<Scalars['String']>;
  notLikeInsensitive?: InputMaybe<Scalars['String']>;
  notStartsWith?: InputMaybe<Scalars['String']>;
  notStartsWithInsensitive?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
  startsWithInsensitive?: InputMaybe<Scalars['String']>;
};

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedVersion?: Maybe<Scalars['Int']>;
  spaceId: Scalars['String'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** These are generic, fixed statements used in the frontend. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/systemText) */
export type SystemText = Entry & {
  __typename?: 'SystemText';
  contentfulMetadata: ContentfulMetadata;
  elementId?: Maybe<Scalars['String']>;
  elementSystemtext?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<SystemTextLinkingCollections>;
  sys: Sys;
};


/** These are generic, fixed statements used in the frontend. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/systemText) */
export type SystemTextElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** These are generic, fixed statements used in the frontend. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/systemText) */
export type SystemTextElementSystemtextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** These are generic, fixed statements used in the frontend. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/systemText) */
export type SystemTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SystemTextCollection = {
  __typename?: 'SystemTextCollection';
  items: Array<Maybe<SystemText>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SystemTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<SystemTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SystemTextFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementSystemtext?: InputMaybe<Scalars['String']>;
  elementSystemtext_contains?: InputMaybe<Scalars['String']>;
  elementSystemtext_exists?: InputMaybe<Scalars['Boolean']>;
  elementSystemtext_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementSystemtext_not?: InputMaybe<Scalars['String']>;
  elementSystemtext_not_contains?: InputMaybe<Scalars['String']>;
  elementSystemtext_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SystemTextLinkingCollections = {
  __typename?: 'SystemTextLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type SystemTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SystemTextOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementSystemtextAsc = 'elementSystemtext_ASC',
  ElementSystemtextDesc = 'elementSystemtext_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a template for building assessments [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateAssessment) */
export type TemplateAssessment = Entry & {
  __typename?: 'TemplateAssessment';
  contentfulMetadata: ContentfulMetadata;
  elementId?: Maybe<Scalars['String']>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateAssessmentLinkingCollections>;
  maxNrQuestions?: Maybe<Scalars['Int']>;
  passingGrade?: Maybe<Scalars['Float']>;
  questionsCollection?: Maybe<TemplateAssessmentQuestionsCollection>;
  sys: Sys;
};


/** Adds a template for building assessments [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateAssessment) */
export type TemplateAssessmentElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for building assessments [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateAssessment) */
export type TemplateAssessmentElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for building assessments [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateAssessment) */
export type TemplateAssessmentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Adds a template for building assessments [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateAssessment) */
export type TemplateAssessmentMaxNrQuestionsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for building assessments [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateAssessment) */
export type TemplateAssessmentPassingGradeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for building assessments [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateAssessment) */
export type TemplateAssessmentQuestionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type TemplateAssessmentCollection = {
  __typename?: 'TemplateAssessmentCollection';
  items: Array<Maybe<TemplateAssessment>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateAssessmentFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateAssessmentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateAssessmentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxNrQuestions?: InputMaybe<Scalars['Int']>;
  maxNrQuestions_exists?: InputMaybe<Scalars['Boolean']>;
  maxNrQuestions_gt?: InputMaybe<Scalars['Int']>;
  maxNrQuestions_gte?: InputMaybe<Scalars['Int']>;
  maxNrQuestions_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxNrQuestions_lt?: InputMaybe<Scalars['Int']>;
  maxNrQuestions_lte?: InputMaybe<Scalars['Int']>;
  maxNrQuestions_not?: InputMaybe<Scalars['Int']>;
  maxNrQuestions_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  passingGrade?: InputMaybe<Scalars['Float']>;
  passingGrade_exists?: InputMaybe<Scalars['Boolean']>;
  passingGrade_gt?: InputMaybe<Scalars['Float']>;
  passingGrade_gte?: InputMaybe<Scalars['Float']>;
  passingGrade_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  passingGrade_lt?: InputMaybe<Scalars['Float']>;
  passingGrade_lte?: InputMaybe<Scalars['Float']>;
  passingGrade_not?: InputMaybe<Scalars['Float']>;
  passingGrade_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  questionsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateAssessmentLinkingCollections = {
  __typename?: 'TemplateAssessmentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateAssessmentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateAssessmentLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateAssessmentOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  MaxNrQuestionsAsc = 'maxNrQuestions_ASC',
  MaxNrQuestionsDesc = 'maxNrQuestions_DESC',
  PassingGradeAsc = 'passingGrade_ASC',
  PassingGradeDesc = 'passingGrade_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type TemplateAssessmentQuestionsCollection = {
  __typename?: 'TemplateAssessmentQuestionsCollection';
  items: Array<Maybe<TemplateAssessmentQuestionsItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateAssessmentQuestionsItem = TemplateMpcMultipleCorrect | TemplateMpcOneCorrect;

/** Adds a template for a break with text and/or image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateBreakM) */
export type TemplateBreakM = Entry & {
  __typename?: 'TemplateBreakM';
  contentfulMetadata: ContentfulMetadata;
  elementId?: Maybe<Scalars['String']>;
  elementImage?: Maybe<Asset>;
  elementName?: Maybe<Scalars['String']>;
  elementText?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateBreakMLinkingCollections>;
  sys: Sys;
};


/** Adds a template for a break with text and/or image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateBreakM) */
export type TemplateBreakMElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a break with text and/or image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateBreakM) */
export type TemplateBreakMElementImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for a break with text and/or image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateBreakM) */
export type TemplateBreakMElementNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a break with text and/or image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateBreakM) */
export type TemplateBreakMElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a break with text and/or image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateBreakM) */
export type TemplateBreakMLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateBreakMCollection = {
  __typename?: 'TemplateBreakMCollection';
  items: Array<Maybe<TemplateBreakM>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateBreakMFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateBreakMFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateBreakMFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementImage_exists?: InputMaybe<Scalars['Boolean']>;
  elementName?: InputMaybe<Scalars['String']>;
  elementName_contains?: InputMaybe<Scalars['String']>;
  elementName_exists?: InputMaybe<Scalars['Boolean']>;
  elementName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementName_not?: InputMaybe<Scalars['String']>;
  elementName_not_contains?: InputMaybe<Scalars['String']>;
  elementName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText?: InputMaybe<Scalars['String']>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_not?: InputMaybe<Scalars['String']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateBreakMLinkingCollections = {
  __typename?: 'TemplateBreakMLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateBreakMLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateBreakMLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateBreakMOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementNameAsc = 'elementName_ASC',
  ElementNameDesc = 'elementName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a template for a series of sliding images [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateCarousel) */
export type TemplateCarousel = Entry & {
  __typename?: 'TemplateCarousel';
  contentfulMetadata: ContentfulMetadata;
  elementChild?: Maybe<Scalars['JSON']>;
  elementId?: Maybe<Scalars['String']>;
  elementText?: Maybe<TemplateCarouselElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateCarouselLinkingCollections>;
  sys: Sys;
};


/** Adds a template for a series of sliding images [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateCarousel) */
export type TemplateCarouselElementChildArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a series of sliding images [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateCarousel) */
export type TemplateCarouselElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a series of sliding images [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateCarousel) */
export type TemplateCarouselElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a series of sliding images [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateCarousel) */
export type TemplateCarouselElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a series of sliding images [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateCarousel) */
export type TemplateCarouselLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateCarouselCollection = {
  __typename?: 'TemplateCarouselCollection';
  items: Array<Maybe<TemplateCarousel>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateCarouselElementText = {
  __typename?: 'TemplateCarouselElementText';
  json: Scalars['JSON'];
  links: TemplateCarouselElementTextLinks;
};

export type TemplateCarouselElementTextAssets = {
  __typename?: 'TemplateCarouselElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateCarouselElementTextEntries = {
  __typename?: 'TemplateCarouselElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateCarouselElementTextLinks = {
  __typename?: 'TemplateCarouselElementTextLinks';
  assets: TemplateCarouselElementTextAssets;
  entries: TemplateCarouselElementTextEntries;
};

export type TemplateCarouselFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateCarouselFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateCarouselFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementChild_exists?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateCarouselLinkingCollections = {
  __typename?: 'TemplateCarouselLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateCarouselLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateCarouselLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateCarouselOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a cover to an episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateCoberq) */
export type TemplateCoberq = Entry & {
  __typename?: 'TemplateCoberq';
  contentfulMetadata: ContentfulMetadata;
  elementId?: Maybe<Scalars['String']>;
  elementImage?: Maybe<Asset>;
  linkedFrom?: Maybe<TemplateCoberqLinkingCollections>;
  sys: Sys;
};


/** Adds a cover to an episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateCoberq) */
export type TemplateCoberqElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a cover to an episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateCoberq) */
export type TemplateCoberqElementImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a cover to an episode [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateCoberq) */
export type TemplateCoberqLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateCoberqCollection = {
  __typename?: 'TemplateCoberqCollection';
  items: Array<Maybe<TemplateCoberq>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateCoberqFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateCoberqFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateCoberqFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementImage_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateCoberqLinkingCollections = {
  __typename?: 'TemplateCoberqLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateCoberqLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateCoberqLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateCoberqOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a template for 1 to 3 facts [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFactsFigures) */
export type TemplateFactsFigures = Entry & {
  __typename?: 'TemplateFactsFigures';
  contentfulMetadata: ContentfulMetadata;
  elementFactCollection?: Maybe<TemplateFactsFiguresElementFactCollection>;
  elementId?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateFactsFiguresLinkingCollections>;
  sys: Sys;
};


/** Adds a template for 1 to 3 facts [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFactsFigures) */
export type TemplateFactsFiguresElementFactCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Adds a template for 1 to 3 facts [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFactsFigures) */
export type TemplateFactsFiguresElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for 1 to 3 facts [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFactsFigures) */
export type TemplateFactsFiguresLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateFactsFiguresCollection = {
  __typename?: 'TemplateFactsFiguresCollection';
  items: Array<Maybe<TemplateFactsFigures>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateFactsFiguresElementFactCollection = {
  __typename?: 'TemplateFactsFiguresElementFactCollection';
  items: Array<Maybe<Fact>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateFactsFiguresFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateFactsFiguresFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateFactsFiguresFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementFactCollection_exists?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateFactsFiguresLinkingCollections = {
  __typename?: 'TemplateFactsFiguresLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateFactsFiguresLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateFactsFiguresLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateFactsFiguresOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds the content type file share [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFileShare) */
export type TemplateFileShare = Entry & {
  __typename?: 'TemplateFileShare';
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<TemplateFileShareDescription>;
  documentDescription?: Maybe<Scalars['String']>;
  documentLink?: Maybe<Scalars['String']>;
  documentSurtitle?: Maybe<Scalars['String']>;
  documentTitle?: Maybe<Scalars['String']>;
  elementId?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateFileShareLinkingCollections>;
  password?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** Adds the content type file share [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFileShare) */
export type TemplateFileShareDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type file share [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFileShare) */
export type TemplateFileShareDocumentDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type file share [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFileShare) */
export type TemplateFileShareDocumentLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type file share [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFileShare) */
export type TemplateFileShareDocumentSurtitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type file share [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFileShare) */
export type TemplateFileShareDocumentTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type file share [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFileShare) */
export type TemplateFileShareElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type file share [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFileShare) */
export type TemplateFileShareLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Adds the content type file share [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFileShare) */
export type TemplateFileSharePasswordArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type file share [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateFileShare) */
export type TemplateFileShareTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type TemplateFileShareCollection = {
  __typename?: 'TemplateFileShareCollection';
  items: Array<Maybe<TemplateFileShare>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateFileShareDescription = {
  __typename?: 'TemplateFileShareDescription';
  json: Scalars['JSON'];
  links: TemplateFileShareDescriptionLinks;
};

export type TemplateFileShareDescriptionAssets = {
  __typename?: 'TemplateFileShareDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateFileShareDescriptionEntries = {
  __typename?: 'TemplateFileShareDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateFileShareDescriptionLinks = {
  __typename?: 'TemplateFileShareDescriptionLinks';
  assets: TemplateFileShareDescriptionAssets;
  entries: TemplateFileShareDescriptionEntries;
};

export type TemplateFileShareFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateFileShareFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateFileShareFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  documentDescription?: InputMaybe<Scalars['String']>;
  documentDescription_contains?: InputMaybe<Scalars['String']>;
  documentDescription_exists?: InputMaybe<Scalars['Boolean']>;
  documentDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  documentDescription_not?: InputMaybe<Scalars['String']>;
  documentDescription_not_contains?: InputMaybe<Scalars['String']>;
  documentDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  documentLink?: InputMaybe<Scalars['String']>;
  documentLink_contains?: InputMaybe<Scalars['String']>;
  documentLink_exists?: InputMaybe<Scalars['Boolean']>;
  documentLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  documentLink_not?: InputMaybe<Scalars['String']>;
  documentLink_not_contains?: InputMaybe<Scalars['String']>;
  documentLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  documentSurtitle?: InputMaybe<Scalars['String']>;
  documentSurtitle_contains?: InputMaybe<Scalars['String']>;
  documentSurtitle_exists?: InputMaybe<Scalars['Boolean']>;
  documentSurtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  documentSurtitle_not?: InputMaybe<Scalars['String']>;
  documentSurtitle_not_contains?: InputMaybe<Scalars['String']>;
  documentSurtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  documentTitle?: InputMaybe<Scalars['String']>;
  documentTitle_contains?: InputMaybe<Scalars['String']>;
  documentTitle_exists?: InputMaybe<Scalars['Boolean']>;
  documentTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  documentTitle_not?: InputMaybe<Scalars['String']>;
  documentTitle_not_contains?: InputMaybe<Scalars['String']>;
  documentTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  password?: InputMaybe<Scalars['String']>;
  password_contains?: InputMaybe<Scalars['String']>;
  password_exists?: InputMaybe<Scalars['Boolean']>;
  password_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  password_not?: InputMaybe<Scalars['String']>;
  password_not_contains?: InputMaybe<Scalars['String']>;
  password_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateFileShareLinkingCollections = {
  __typename?: 'TemplateFileShareLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateFileShareLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateFileShareLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateFileShareOrder {
  DocumentLinkAsc = 'documentLink_ASC',
  DocumentLinkDesc = 'documentLink_DESC',
  DocumentSurtitleAsc = 'documentSurtitle_ASC',
  DocumentSurtitleDesc = 'documentSurtitle_DESC',
  DocumentTitleAsc = 'documentTitle_ASC',
  DocumentTitleDesc = 'documentTitle_DESC',
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Adds a template for expandable text items [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHarmonica) */
export type TemplateHarmonica = Entry & {
  __typename?: 'TemplateHarmonica';
  contentfulMetadata: ContentfulMetadata;
  elementChild?: Maybe<Scalars['JSON']>;
  elementId?: Maybe<Scalars['String']>;
  elementImage?: Maybe<Asset>;
  elementText?: Maybe<TemplateHarmonicaElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateHarmonicaLinkingCollections>;
  sys: Sys;
};


/** Adds a template for expandable text items [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHarmonica) */
export type TemplateHarmonicaElementChildArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for expandable text items [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHarmonica) */
export type TemplateHarmonicaElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for expandable text items [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHarmonica) */
export type TemplateHarmonicaElementImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for expandable text items [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHarmonica) */
export type TemplateHarmonicaElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for expandable text items [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHarmonica) */
export type TemplateHarmonicaElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for expandable text items [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHarmonica) */
export type TemplateHarmonicaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateHarmonicaCollection = {
  __typename?: 'TemplateHarmonicaCollection';
  items: Array<Maybe<TemplateHarmonica>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateHarmonicaElementText = {
  __typename?: 'TemplateHarmonicaElementText';
  json: Scalars['JSON'];
  links: TemplateHarmonicaElementTextLinks;
};

export type TemplateHarmonicaElementTextAssets = {
  __typename?: 'TemplateHarmonicaElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateHarmonicaElementTextEntries = {
  __typename?: 'TemplateHarmonicaElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateHarmonicaElementTextLinks = {
  __typename?: 'TemplateHarmonicaElementTextLinks';
  assets: TemplateHarmonicaElementTextAssets;
  entries: TemplateHarmonicaElementTextEntries;
};

export type TemplateHarmonicaFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateHarmonicaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateHarmonicaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementChild_exists?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementImage_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateHarmonicaLinkingCollections = {
  __typename?: 'TemplateHarmonicaLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateHarmonicaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateHarmonicaLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateHarmonicaOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Addsa a template with image and hotspot popups [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHotspot) */
export type TemplateHotspot = Entry & {
  __typename?: 'TemplateHotspot';
  contentfulMetadata: ContentfulMetadata;
  elementChild?: Maybe<Scalars['JSON']>;
  elementId?: Maybe<Scalars['String']>;
  elementText?: Maybe<TemplateHotspotElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateHotspotLinkingCollections>;
  sys: Sys;
};


/** Addsa a template with image and hotspot popups [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHotspot) */
export type TemplateHotspotElementChildArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Addsa a template with image and hotspot popups [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHotspot) */
export type TemplateHotspotElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Addsa a template with image and hotspot popups [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHotspot) */
export type TemplateHotspotElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Addsa a template with image and hotspot popups [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHotspot) */
export type TemplateHotspotElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Addsa a template with image and hotspot popups [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateHotspot) */
export type TemplateHotspotLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateHotspotCollection = {
  __typename?: 'TemplateHotspotCollection';
  items: Array<Maybe<TemplateHotspot>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateHotspotElementText = {
  __typename?: 'TemplateHotspotElementText';
  json: Scalars['JSON'];
  links: TemplateHotspotElementTextLinks;
};

export type TemplateHotspotElementTextAssets = {
  __typename?: 'TemplateHotspotElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateHotspotElementTextEntries = {
  __typename?: 'TemplateHotspotElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateHotspotElementTextLinks = {
  __typename?: 'TemplateHotspotElementTextLinks';
  assets: TemplateHotspotElementTextAssets;
  entries: TemplateHotspotElementTextEntries;
};

export type TemplateHotspotFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateHotspotFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateHotspotFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementChild_exists?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateHotspotLinkingCollections = {
  __typename?: 'TemplateHotspotLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateHotspotLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateHotspotLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateHotspotOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a template for an MPC matching quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcCards) */
export type TemplateMpcCards = Entry & {
  __typename?: 'TemplateMpcCards';
  contentfulMetadata: ContentfulMetadata;
  elementChild?: Maybe<Scalars['JSON']>;
  elementId?: Maybe<Scalars['String']>;
  elementImage?: Maybe<Asset>;
  elementQuestionText?: Maybe<Scalars['String']>;
  elementText?: Maybe<TemplateMpcCardsElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateMpcCardsLinkingCollections>;
  sys: Sys;
};


/** Adds a template for an MPC matching quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcCards) */
export type TemplateMpcCardsElementChildArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for an MPC matching quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcCards) */
export type TemplateMpcCardsElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for an MPC matching quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcCards) */
export type TemplateMpcCardsElementImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for an MPC matching quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcCards) */
export type TemplateMpcCardsElementQuestionTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for an MPC matching quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcCards) */
export type TemplateMpcCardsElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for an MPC matching quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcCards) */
export type TemplateMpcCardsElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for an MPC matching quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcCards) */
export type TemplateMpcCardsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateMpcCardsCollection = {
  __typename?: 'TemplateMpcCardsCollection';
  items: Array<Maybe<TemplateMpcCards>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateMpcCardsElementText = {
  __typename?: 'TemplateMpcCardsElementText';
  json: Scalars['JSON'];
  links: TemplateMpcCardsElementTextLinks;
};

export type TemplateMpcCardsElementTextAssets = {
  __typename?: 'TemplateMpcCardsElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateMpcCardsElementTextEntries = {
  __typename?: 'TemplateMpcCardsElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateMpcCardsElementTextLinks = {
  __typename?: 'TemplateMpcCardsElementTextLinks';
  assets: TemplateMpcCardsElementTextAssets;
  entries: TemplateMpcCardsElementTextEntries;
};

export type TemplateMpcCardsFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateMpcCardsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateMpcCardsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementChild_exists?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementImage_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionText?: InputMaybe<Scalars['String']>;
  elementQuestionText_contains?: InputMaybe<Scalars['String']>;
  elementQuestionText_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionText_not?: InputMaybe<Scalars['String']>;
  elementQuestionText_not_contains?: InputMaybe<Scalars['String']>;
  elementQuestionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateMpcCardsLinkingCollections = {
  __typename?: 'TemplateMpcCardsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateMpcCardsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateMpcCardsLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateMpcCardsOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementQuestionTextAsc = 'elementQuestionText_ASC',
  ElementQuestionTextDesc = 'elementQuestionText_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a template for a checkbox question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcMultipleCorrect) */
export type TemplateMpcMultipleCorrect = Entry & {
  __typename?: 'TemplateMpcMultipleCorrect';
  contentfulMetadata: ContentfulMetadata;
  elementChild?: Maybe<Scalars['JSON']>;
  elementId?: Maybe<Scalars['String']>;
  elementImage?: Maybe<Asset>;
  elementQuestionFeedback?: Maybe<Scalars['String']>;
  elementQuestionText?: Maybe<Scalars['String']>;
  elementText?: Maybe<TemplateMpcMultipleCorrectElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateMpcMultipleCorrectLinkingCollections>;
  sys: Sys;
};


/** Adds a template for a checkbox question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcMultipleCorrect) */
export type TemplateMpcMultipleCorrectElementChildArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a checkbox question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcMultipleCorrect) */
export type TemplateMpcMultipleCorrectElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a checkbox question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcMultipleCorrect) */
export type TemplateMpcMultipleCorrectElementImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for a checkbox question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcMultipleCorrect) */
export type TemplateMpcMultipleCorrectElementQuestionFeedbackArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a checkbox question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcMultipleCorrect) */
export type TemplateMpcMultipleCorrectElementQuestionTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a checkbox question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcMultipleCorrect) */
export type TemplateMpcMultipleCorrectElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a checkbox question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcMultipleCorrect) */
export type TemplateMpcMultipleCorrectElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a checkbox question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcMultipleCorrect) */
export type TemplateMpcMultipleCorrectLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateMpcMultipleCorrectCollection = {
  __typename?: 'TemplateMpcMultipleCorrectCollection';
  items: Array<Maybe<TemplateMpcMultipleCorrect>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateMpcMultipleCorrectElementText = {
  __typename?: 'TemplateMpcMultipleCorrectElementText';
  json: Scalars['JSON'];
  links: TemplateMpcMultipleCorrectElementTextLinks;
};

export type TemplateMpcMultipleCorrectElementTextAssets = {
  __typename?: 'TemplateMpcMultipleCorrectElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateMpcMultipleCorrectElementTextEntries = {
  __typename?: 'TemplateMpcMultipleCorrectElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateMpcMultipleCorrectElementTextLinks = {
  __typename?: 'TemplateMpcMultipleCorrectElementTextLinks';
  assets: TemplateMpcMultipleCorrectElementTextAssets;
  entries: TemplateMpcMultipleCorrectElementTextEntries;
};

export type TemplateMpcMultipleCorrectFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateMpcMultipleCorrectFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateMpcMultipleCorrectFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementChild_exists?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementImage_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionFeedback?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_contains?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionFeedback_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionFeedback_not?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_not_contains?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionText?: InputMaybe<Scalars['String']>;
  elementQuestionText_contains?: InputMaybe<Scalars['String']>;
  elementQuestionText_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionText_not?: InputMaybe<Scalars['String']>;
  elementQuestionText_not_contains?: InputMaybe<Scalars['String']>;
  elementQuestionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateMpcMultipleCorrectLinkingCollections = {
  __typename?: 'TemplateMpcMultipleCorrectLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
  templateAssessmentCollection?: Maybe<TemplateAssessmentCollection>;
};


export type TemplateMpcMultipleCorrectLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateMpcMultipleCorrectLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateMpcMultipleCorrectLinkingCollectionsTemplateAssessmentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateMpcMultipleCorrectOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementQuestionTextAsc = 'elementQuestionText_ASC',
  ElementQuestionTextDesc = 'elementQuestionText_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a template for a multiple choice question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcOneCorrect) */
export type TemplateMpcOneCorrect = Entry & {
  __typename?: 'TemplateMpcOneCorrect';
  contentfulMetadata: ContentfulMetadata;
  elementChild?: Maybe<Scalars['JSON']>;
  elementId?: Maybe<Scalars['String']>;
  elementImage?: Maybe<Asset>;
  elementQuestionFeedback?: Maybe<Scalars['String']>;
  elementQuestionText?: Maybe<Scalars['String']>;
  elementText?: Maybe<TemplateMpcOneCorrectElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateMpcOneCorrectLinkingCollections>;
  sys: Sys;
};


/** Adds a template for a multiple choice question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcOneCorrect) */
export type TemplateMpcOneCorrectElementChildArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a multiple choice question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcOneCorrect) */
export type TemplateMpcOneCorrectElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a multiple choice question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcOneCorrect) */
export type TemplateMpcOneCorrectElementImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for a multiple choice question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcOneCorrect) */
export type TemplateMpcOneCorrectElementQuestionFeedbackArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a multiple choice question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcOneCorrect) */
export type TemplateMpcOneCorrectElementQuestionTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a multiple choice question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcOneCorrect) */
export type TemplateMpcOneCorrectElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a multiple choice question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcOneCorrect) */
export type TemplateMpcOneCorrectElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a multiple choice question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateMpcOneCorrect) */
export type TemplateMpcOneCorrectLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateMpcOneCorrectCollection = {
  __typename?: 'TemplateMpcOneCorrectCollection';
  items: Array<Maybe<TemplateMpcOneCorrect>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateMpcOneCorrectElementText = {
  __typename?: 'TemplateMpcOneCorrectElementText';
  json: Scalars['JSON'];
  links: TemplateMpcOneCorrectElementTextLinks;
};

export type TemplateMpcOneCorrectElementTextAssets = {
  __typename?: 'TemplateMpcOneCorrectElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateMpcOneCorrectElementTextEntries = {
  __typename?: 'TemplateMpcOneCorrectElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateMpcOneCorrectElementTextLinks = {
  __typename?: 'TemplateMpcOneCorrectElementTextLinks';
  assets: TemplateMpcOneCorrectElementTextAssets;
  entries: TemplateMpcOneCorrectElementTextEntries;
};

export type TemplateMpcOneCorrectFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateMpcOneCorrectFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateMpcOneCorrectFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementChild_exists?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementImage_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionFeedback?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_contains?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionFeedback_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionFeedback_not?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_not_contains?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionText?: InputMaybe<Scalars['String']>;
  elementQuestionText_contains?: InputMaybe<Scalars['String']>;
  elementQuestionText_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionText_not?: InputMaybe<Scalars['String']>;
  elementQuestionText_not_contains?: InputMaybe<Scalars['String']>;
  elementQuestionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateMpcOneCorrectLinkingCollections = {
  __typename?: 'TemplateMpcOneCorrectLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
  templateAssessmentCollection?: Maybe<TemplateAssessmentCollection>;
};


export type TemplateMpcOneCorrectLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateMpcOneCorrectLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateMpcOneCorrectLinkingCollectionsTemplateAssessmentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateMpcOneCorrectOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementQuestionTextAsc = 'elementQuestionText_ASC',
  ElementQuestionTextDesc = 'elementQuestionText_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds the content type open question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateOpenQuestion) */
export type TemplateOpenQuestion = Entry & {
  __typename?: 'TemplateOpenQuestion';
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<TemplateOpenQuestionDescription>;
  elementChild?: Maybe<Scalars['JSON']>;
  elementId?: Maybe<Scalars['String']>;
  exampleAnswer?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<TemplateOpenQuestionLinkingCollections>;
  question?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** Adds the content type open question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateOpenQuestion) */
export type TemplateOpenQuestionDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type open question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateOpenQuestion) */
export type TemplateOpenQuestionElementChildArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type open question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateOpenQuestion) */
export type TemplateOpenQuestionElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type open question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateOpenQuestion) */
export type TemplateOpenQuestionExampleAnswerArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type open question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateOpenQuestion) */
export type TemplateOpenQuestionImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds the content type open question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateOpenQuestion) */
export type TemplateOpenQuestionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Adds the content type open question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateOpenQuestion) */
export type TemplateOpenQuestionQuestionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds the content type open question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateOpenQuestion) */
export type TemplateOpenQuestionTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type TemplateOpenQuestionCollection = {
  __typename?: 'TemplateOpenQuestionCollection';
  items: Array<Maybe<TemplateOpenQuestion>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateOpenQuestionDescription = {
  __typename?: 'TemplateOpenQuestionDescription';
  json: Scalars['JSON'];
  links: TemplateOpenQuestionDescriptionLinks;
};

export type TemplateOpenQuestionDescriptionAssets = {
  __typename?: 'TemplateOpenQuestionDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateOpenQuestionDescriptionEntries = {
  __typename?: 'TemplateOpenQuestionDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateOpenQuestionDescriptionLinks = {
  __typename?: 'TemplateOpenQuestionDescriptionLinks';
  assets: TemplateOpenQuestionDescriptionAssets;
  entries: TemplateOpenQuestionDescriptionEntries;
};

export type TemplateOpenQuestionFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateOpenQuestionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateOpenQuestionFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  elementChild_exists?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  exampleAnswer?: InputMaybe<Scalars['String']>;
  exampleAnswer_contains?: InputMaybe<Scalars['String']>;
  exampleAnswer_exists?: InputMaybe<Scalars['Boolean']>;
  exampleAnswer_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  exampleAnswer_not?: InputMaybe<Scalars['String']>;
  exampleAnswer_not_contains?: InputMaybe<Scalars['String']>;
  exampleAnswer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  question?: InputMaybe<Scalars['String']>;
  question_contains?: InputMaybe<Scalars['String']>;
  question_exists?: InputMaybe<Scalars['Boolean']>;
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  question_not?: InputMaybe<Scalars['String']>;
  question_not_contains?: InputMaybe<Scalars['String']>;
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateOpenQuestionLinkingCollections = {
  __typename?: 'TemplateOpenQuestionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateOpenQuestionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateOpenQuestionLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateOpenQuestionOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Adds a template for a poll with statistical feedback [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templatePoll) */
export type TemplatePoll = Entry & {
  __typename?: 'TemplatePoll';
  contentfulMetadata: ContentfulMetadata;
  elementChild?: Maybe<Scalars['JSON']>;
  elementId?: Maybe<Scalars['String']>;
  elementImage?: Maybe<Asset>;
  elementQuestionFeedback?: Maybe<Scalars['String']>;
  elementQuestionText?: Maybe<Scalars['String']>;
  elementText?: Maybe<TemplatePollElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplatePollLinkingCollections>;
  sys: Sys;
};


/** Adds a template for a poll with statistical feedback [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templatePoll) */
export type TemplatePollElementChildArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a poll with statistical feedback [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templatePoll) */
export type TemplatePollElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a poll with statistical feedback [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templatePoll) */
export type TemplatePollElementImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for a poll with statistical feedback [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templatePoll) */
export type TemplatePollElementQuestionFeedbackArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a poll with statistical feedback [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templatePoll) */
export type TemplatePollElementQuestionTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a poll with statistical feedback [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templatePoll) */
export type TemplatePollElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a poll with statistical feedback [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templatePoll) */
export type TemplatePollElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a poll with statistical feedback [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templatePoll) */
export type TemplatePollLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplatePollCollection = {
  __typename?: 'TemplatePollCollection';
  items: Array<Maybe<TemplatePoll>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplatePollElementText = {
  __typename?: 'TemplatePollElementText';
  json: Scalars['JSON'];
  links: TemplatePollElementTextLinks;
};

export type TemplatePollElementTextAssets = {
  __typename?: 'TemplatePollElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplatePollElementTextEntries = {
  __typename?: 'TemplatePollElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplatePollElementTextLinks = {
  __typename?: 'TemplatePollElementTextLinks';
  assets: TemplatePollElementTextAssets;
  entries: TemplatePollElementTextEntries;
};

export type TemplatePollFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplatePollFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplatePollFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementChild_exists?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementImage_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionFeedback?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_contains?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionFeedback_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionFeedback_not?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_not_contains?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionText?: InputMaybe<Scalars['String']>;
  elementQuestionText_contains?: InputMaybe<Scalars['String']>;
  elementQuestionText_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionText_not?: InputMaybe<Scalars['String']>;
  elementQuestionText_not_contains?: InputMaybe<Scalars['String']>;
  elementQuestionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplatePollLinkingCollections = {
  __typename?: 'TemplatePollLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplatePollLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplatePollLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplatePollOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementQuestionTextAsc = 'elementQuestionText_ASC',
  ElementQuestionTextDesc = 'elementQuestionText_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a template for a series of cross fading images [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateScrollingAnalysis) */
export type TemplateScrollingAnalysis = Entry & {
  __typename?: 'TemplateScrollingAnalysis';
  contentfulMetadata: ContentfulMetadata;
  elementChild?: Maybe<Scalars['JSON']>;
  elementId?: Maybe<Scalars['String']>;
  elementText?: Maybe<TemplateScrollingAnalysisElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateScrollingAnalysisLinkingCollections>;
  sys: Sys;
};


/** Adds a template for a series of cross fading images [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateScrollingAnalysis) */
export type TemplateScrollingAnalysisElementChildArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a series of cross fading images [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateScrollingAnalysis) */
export type TemplateScrollingAnalysisElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a series of cross fading images [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateScrollingAnalysis) */
export type TemplateScrollingAnalysisElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a series of cross fading images [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateScrollingAnalysis) */
export type TemplateScrollingAnalysisElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a series of cross fading images [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateScrollingAnalysis) */
export type TemplateScrollingAnalysisLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateScrollingAnalysisCollection = {
  __typename?: 'TemplateScrollingAnalysisCollection';
  items: Array<Maybe<TemplateScrollingAnalysis>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateScrollingAnalysisElementText = {
  __typename?: 'TemplateScrollingAnalysisElementText';
  json: Scalars['JSON'];
  links: TemplateScrollingAnalysisElementTextLinks;
};

export type TemplateScrollingAnalysisElementTextAssets = {
  __typename?: 'TemplateScrollingAnalysisElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateScrollingAnalysisElementTextEntries = {
  __typename?: 'TemplateScrollingAnalysisElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateScrollingAnalysisElementTextLinks = {
  __typename?: 'TemplateScrollingAnalysisElementTextLinks';
  assets: TemplateScrollingAnalysisElementTextAssets;
  entries: TemplateScrollingAnalysisElementTextEntries;
};

export type TemplateScrollingAnalysisFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateScrollingAnalysisFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateScrollingAnalysisFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementChild_exists?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateScrollingAnalysisLinkingCollections = {
  __typename?: 'TemplateScrollingAnalysisLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateScrollingAnalysisLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateScrollingAnalysisLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateScrollingAnalysisOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a template for a numerical slider question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateSlider) */
export type TemplateSlider = Entry & {
  __typename?: 'TemplateSlider';
  contentfulMetadata: ContentfulMetadata;
  elementId?: Maybe<Scalars['String']>;
  elementImage?: Maybe<Asset>;
  elementQuestionFeedback?: Maybe<Scalars['String']>;
  elementQuestionText?: Maybe<Scalars['String']>;
  elementRangeEnd?: Maybe<Scalars['Int']>;
  elementRangeIncrement?: Maybe<Scalars['Int']>;
  elementRangeStart?: Maybe<Scalars['Int']>;
  elementText?: Maybe<TemplateSliderElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateSliderLinkingCollections>;
  sys: Sys;
};


/** Adds a template for a numerical slider question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateSlider) */
export type TemplateSliderElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a numerical slider question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateSlider) */
export type TemplateSliderElementImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for a numerical slider question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateSlider) */
export type TemplateSliderElementQuestionFeedbackArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a numerical slider question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateSlider) */
export type TemplateSliderElementQuestionTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a numerical slider question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateSlider) */
export type TemplateSliderElementRangeEndArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a numerical slider question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateSlider) */
export type TemplateSliderElementRangeIncrementArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a numerical slider question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateSlider) */
export type TemplateSliderElementRangeStartArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a numerical slider question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateSlider) */
export type TemplateSliderElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a numerical slider question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateSlider) */
export type TemplateSliderElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a numerical slider question [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateSlider) */
export type TemplateSliderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateSliderCollection = {
  __typename?: 'TemplateSliderCollection';
  items: Array<Maybe<TemplateSlider>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateSliderElementText = {
  __typename?: 'TemplateSliderElementText';
  json: Scalars['JSON'];
  links: TemplateSliderElementTextLinks;
};

export type TemplateSliderElementTextAssets = {
  __typename?: 'TemplateSliderElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateSliderElementTextEntries = {
  __typename?: 'TemplateSliderElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateSliderElementTextLinks = {
  __typename?: 'TemplateSliderElementTextLinks';
  assets: TemplateSliderElementTextAssets;
  entries: TemplateSliderElementTextEntries;
};

export type TemplateSliderFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateSliderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateSliderFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementImage_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionFeedback?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_contains?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionFeedback_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionFeedback_not?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_not_contains?: InputMaybe<Scalars['String']>;
  elementQuestionFeedback_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionText?: InputMaybe<Scalars['String']>;
  elementQuestionText_contains?: InputMaybe<Scalars['String']>;
  elementQuestionText_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionText_not?: InputMaybe<Scalars['String']>;
  elementQuestionText_not_contains?: InputMaybe<Scalars['String']>;
  elementQuestionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementRangeEnd?: InputMaybe<Scalars['Int']>;
  elementRangeEnd_exists?: InputMaybe<Scalars['Boolean']>;
  elementRangeEnd_gt?: InputMaybe<Scalars['Int']>;
  elementRangeEnd_gte?: InputMaybe<Scalars['Int']>;
  elementRangeEnd_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  elementRangeEnd_lt?: InputMaybe<Scalars['Int']>;
  elementRangeEnd_lte?: InputMaybe<Scalars['Int']>;
  elementRangeEnd_not?: InputMaybe<Scalars['Int']>;
  elementRangeEnd_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  elementRangeIncrement?: InputMaybe<Scalars['Int']>;
  elementRangeIncrement_exists?: InputMaybe<Scalars['Boolean']>;
  elementRangeIncrement_gt?: InputMaybe<Scalars['Int']>;
  elementRangeIncrement_gte?: InputMaybe<Scalars['Int']>;
  elementRangeIncrement_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  elementRangeIncrement_lt?: InputMaybe<Scalars['Int']>;
  elementRangeIncrement_lte?: InputMaybe<Scalars['Int']>;
  elementRangeIncrement_not?: InputMaybe<Scalars['Int']>;
  elementRangeIncrement_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  elementRangeStart?: InputMaybe<Scalars['Int']>;
  elementRangeStart_exists?: InputMaybe<Scalars['Boolean']>;
  elementRangeStart_gt?: InputMaybe<Scalars['Int']>;
  elementRangeStart_gte?: InputMaybe<Scalars['Int']>;
  elementRangeStart_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  elementRangeStart_lt?: InputMaybe<Scalars['Int']>;
  elementRangeStart_lte?: InputMaybe<Scalars['Int']>;
  elementRangeStart_not?: InputMaybe<Scalars['Int']>;
  elementRangeStart_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateSliderLinkingCollections = {
  __typename?: 'TemplateSliderLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateSliderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateSliderLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateSliderOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementQuestionTextAsc = 'elementQuestionText_ASC',
  ElementQuestionTextDesc = 'elementQuestionText_DESC',
  ElementRangeEndAsc = 'elementRangeEnd_ASC',
  ElementRangeEndDesc = 'elementRangeEnd_DESC',
  ElementRangeIncrementAsc = 'elementRangeIncrement_ASC',
  ElementRangeIncrementDesc = 'elementRangeIncrement_DESC',
  ElementRangeStartAsc = 'elementRangeStart_ASC',
  ElementRangeStartDesc = 'elementRangeStart_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a template for text and image (with or without section start) [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextImage) */
export type TemplateTextImage = Entry & {
  __typename?: 'TemplateTextImage';
  alignTextLeft?: Maybe<Scalars['Boolean']>;
  contentfulMetadata: ContentfulMetadata;
  downloadFile?: Maybe<Asset>;
  downloadTitle?: Maybe<Scalars['String']>;
  elementFullimage?: Maybe<Scalars['Boolean']>;
  elementId?: Maybe<Scalars['String']>;
  elementImage?: Maybe<Asset>;
  elementSectionStart?: Maybe<Scalars['Boolean']>;
  elementSurtitle?: Maybe<Scalars['String']>;
  elementText?: Maybe<TemplateTextImageElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateTextImageLinkingCollections>;
  sys: Sys;
};


/** Adds a template for text and image (with or without section start) [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextImage) */
export type TemplateTextImageAlignTextLeftArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text and image (with or without section start) [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextImage) */
export type TemplateTextImageDownloadFileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for text and image (with or without section start) [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextImage) */
export type TemplateTextImageDownloadTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text and image (with or without section start) [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextImage) */
export type TemplateTextImageElementFullimageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text and image (with or without section start) [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextImage) */
export type TemplateTextImageElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text and image (with or without section start) [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextImage) */
export type TemplateTextImageElementImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for text and image (with or without section start) [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextImage) */
export type TemplateTextImageElementSectionStartArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text and image (with or without section start) [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextImage) */
export type TemplateTextImageElementSurtitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text and image (with or without section start) [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextImage) */
export type TemplateTextImageElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text and image (with or without section start) [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextImage) */
export type TemplateTextImageElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text and image (with or without section start) [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextImage) */
export type TemplateTextImageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateTextImageCollection = {
  __typename?: 'TemplateTextImageCollection';
  items: Array<Maybe<TemplateTextImage>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateTextImageElementText = {
  __typename?: 'TemplateTextImageElementText';
  json: Scalars['JSON'];
  links: TemplateTextImageElementTextLinks;
};

export type TemplateTextImageElementTextAssets = {
  __typename?: 'TemplateTextImageElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateTextImageElementTextEntries = {
  __typename?: 'TemplateTextImageElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateTextImageElementTextLinks = {
  __typename?: 'TemplateTextImageElementTextLinks';
  assets: TemplateTextImageElementTextAssets;
  entries: TemplateTextImageElementTextEntries;
};

export type TemplateTextImageFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateTextImageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateTextImageFilter>>>;
  alignTextLeft?: InputMaybe<Scalars['Boolean']>;
  alignTextLeft_exists?: InputMaybe<Scalars['Boolean']>;
  alignTextLeft_not?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  downloadFile_exists?: InputMaybe<Scalars['Boolean']>;
  downloadTitle?: InputMaybe<Scalars['String']>;
  downloadTitle_contains?: InputMaybe<Scalars['String']>;
  downloadTitle_exists?: InputMaybe<Scalars['Boolean']>;
  downloadTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  downloadTitle_not?: InputMaybe<Scalars['String']>;
  downloadTitle_not_contains?: InputMaybe<Scalars['String']>;
  downloadTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementFullimage?: InputMaybe<Scalars['Boolean']>;
  elementFullimage_exists?: InputMaybe<Scalars['Boolean']>;
  elementFullimage_not?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementImage_exists?: InputMaybe<Scalars['Boolean']>;
  elementSectionStart?: InputMaybe<Scalars['Boolean']>;
  elementSectionStart_exists?: InputMaybe<Scalars['Boolean']>;
  elementSectionStart_not?: InputMaybe<Scalars['Boolean']>;
  elementSurtitle?: InputMaybe<Scalars['String']>;
  elementSurtitle_contains?: InputMaybe<Scalars['String']>;
  elementSurtitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementSurtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementSurtitle_not?: InputMaybe<Scalars['String']>;
  elementSurtitle_not_contains?: InputMaybe<Scalars['String']>;
  elementSurtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateTextImageLinkingCollections = {
  __typename?: 'TemplateTextImageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateTextImageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateTextImageLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateTextImageOrder {
  AlignTextLeftAsc = 'alignTextLeft_ASC',
  AlignTextLeftDesc = 'alignTextLeft_DESC',
  DownloadTitleAsc = 'downloadTitle_ASC',
  DownloadTitleDesc = 'downloadTitle_DESC',
  ElementFullimageAsc = 'elementFullimage_ASC',
  ElementFullimageDesc = 'elementFullimage_DESC',
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementSectionStartAsc = 'elementSectionStart_ASC',
  ElementSectionStartDesc = 'elementSectionStart_DESC',
  ElementSurtitleAsc = 'elementSurtitle_ASC',
  ElementSurtitleDesc = 'elementSurtitle_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a template for text with a video link and image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextVideoImage) */
export type TemplateTextVideoImage = Entry & {
  __typename?: 'TemplateTextVideoImage';
  contentfulMetadata: ContentfulMetadata;
  elementId?: Maybe<Scalars['String']>;
  elementImage?: Maybe<Asset>;
  elementSectionStart?: Maybe<Scalars['Boolean']>;
  elementSurtitle?: Maybe<Scalars['String']>;
  elementText?: Maybe<TemplateTextVideoImageElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  elementVideoSource?: Maybe<Scalars['String']>;
  elementVideoStill?: Maybe<Asset>;
  elementVideoTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateTextVideoImageLinkingCollections>;
  sys: Sys;
};


/** Adds a template for text with a video link and image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextVideoImage) */
export type TemplateTextVideoImageElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text with a video link and image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextVideoImage) */
export type TemplateTextVideoImageElementImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for text with a video link and image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextVideoImage) */
export type TemplateTextVideoImageElementSectionStartArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text with a video link and image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextVideoImage) */
export type TemplateTextVideoImageElementSurtitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text with a video link and image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextVideoImage) */
export type TemplateTextVideoImageElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text with a video link and image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextVideoImage) */
export type TemplateTextVideoImageElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text with a video link and image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextVideoImage) */
export type TemplateTextVideoImageElementVideoSourceArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text with a video link and image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextVideoImage) */
export type TemplateTextVideoImageElementVideoStillArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for text with a video link and image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextVideoImage) */
export type TemplateTextVideoImageElementVideoTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for text with a video link and image [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTextVideoImage) */
export type TemplateTextVideoImageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateTextVideoImageCollection = {
  __typename?: 'TemplateTextVideoImageCollection';
  items: Array<Maybe<TemplateTextVideoImage>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateTextVideoImageElementText = {
  __typename?: 'TemplateTextVideoImageElementText';
  json: Scalars['JSON'];
  links: TemplateTextVideoImageElementTextLinks;
};

export type TemplateTextVideoImageElementTextAssets = {
  __typename?: 'TemplateTextVideoImageElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateTextVideoImageElementTextEntries = {
  __typename?: 'TemplateTextVideoImageElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateTextVideoImageElementTextLinks = {
  __typename?: 'TemplateTextVideoImageElementTextLinks';
  assets: TemplateTextVideoImageElementTextAssets;
  entries: TemplateTextVideoImageElementTextEntries;
};

export type TemplateTextVideoImageFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateTextVideoImageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateTextVideoImageFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementImage_exists?: InputMaybe<Scalars['Boolean']>;
  elementSectionStart?: InputMaybe<Scalars['Boolean']>;
  elementSectionStart_exists?: InputMaybe<Scalars['Boolean']>;
  elementSectionStart_not?: InputMaybe<Scalars['Boolean']>;
  elementSurtitle?: InputMaybe<Scalars['String']>;
  elementSurtitle_contains?: InputMaybe<Scalars['String']>;
  elementSurtitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementSurtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementSurtitle_not?: InputMaybe<Scalars['String']>;
  elementSurtitle_not_contains?: InputMaybe<Scalars['String']>;
  elementSurtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementVideoSource?: InputMaybe<Scalars['String']>;
  elementVideoSource_contains?: InputMaybe<Scalars['String']>;
  elementVideoSource_exists?: InputMaybe<Scalars['Boolean']>;
  elementVideoSource_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementVideoSource_not?: InputMaybe<Scalars['String']>;
  elementVideoSource_not_contains?: InputMaybe<Scalars['String']>;
  elementVideoSource_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementVideoStill_exists?: InputMaybe<Scalars['Boolean']>;
  elementVideoTitle?: InputMaybe<Scalars['String']>;
  elementVideoTitle_contains?: InputMaybe<Scalars['String']>;
  elementVideoTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementVideoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementVideoTitle_not?: InputMaybe<Scalars['String']>;
  elementVideoTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementVideoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateTextVideoImageLinkingCollections = {
  __typename?: 'TemplateTextVideoImageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateTextVideoImageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateTextVideoImageLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateTextVideoImageOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementSectionStartAsc = 'elementSectionStart_ASC',
  ElementSectionStartDesc = 'elementSectionStart_DESC',
  ElementSurtitleAsc = 'elementSurtitle_ASC',
  ElementSurtitleDesc = 'elementSurtitle_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  ElementVideoSourceAsc = 'elementVideoSource_ASC',
  ElementVideoSourceDesc = 'elementVideoSource_DESC',
  ElementVideoTitleAsc = 'elementVideoTitle_ASC',
  ElementVideoTitleDesc = 'elementVideoTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a template for a true/false statements quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTrueFalseCards) */
export type TemplateTrueFalseCards = Entry & {
  __typename?: 'TemplateTrueFalseCards';
  contentfulMetadata: ContentfulMetadata;
  elementChild?: Maybe<Scalars['JSON']>;
  elementId?: Maybe<Scalars['String']>;
  elementImage?: Maybe<Asset>;
  elementQuestionText?: Maybe<Scalars['String']>;
  elementText?: Maybe<TemplateTrueFalseCardsElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateTrueFalseCardsLinkingCollections>;
  sys: Sys;
};


/** Adds a template for a true/false statements quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTrueFalseCards) */
export type TemplateTrueFalseCardsElementChildArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a true/false statements quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTrueFalseCards) */
export type TemplateTrueFalseCardsElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a true/false statements quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTrueFalseCards) */
export type TemplateTrueFalseCardsElementImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Adds a template for a true/false statements quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTrueFalseCards) */
export type TemplateTrueFalseCardsElementQuestionTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a true/false statements quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTrueFalseCards) */
export type TemplateTrueFalseCardsElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a true/false statements quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTrueFalseCards) */
export type TemplateTrueFalseCardsElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a true/false statements quiz [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateTrueFalseCards) */
export type TemplateTrueFalseCardsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateTrueFalseCardsCollection = {
  __typename?: 'TemplateTrueFalseCardsCollection';
  items: Array<Maybe<TemplateTrueFalseCards>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateTrueFalseCardsElementText = {
  __typename?: 'TemplateTrueFalseCardsElementText';
  json: Scalars['JSON'];
  links: TemplateTrueFalseCardsElementTextLinks;
};

export type TemplateTrueFalseCardsElementTextAssets = {
  __typename?: 'TemplateTrueFalseCardsElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateTrueFalseCardsElementTextEntries = {
  __typename?: 'TemplateTrueFalseCardsElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateTrueFalseCardsElementTextLinks = {
  __typename?: 'TemplateTrueFalseCardsElementTextLinks';
  assets: TemplateTrueFalseCardsElementTextAssets;
  entries: TemplateTrueFalseCardsElementTextEntries;
};

export type TemplateTrueFalseCardsFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateTrueFalseCardsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateTrueFalseCardsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementChild_exists?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementImage_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionText?: InputMaybe<Scalars['String']>;
  elementQuestionText_contains?: InputMaybe<Scalars['String']>;
  elementQuestionText_exists?: InputMaybe<Scalars['Boolean']>;
  elementQuestionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementQuestionText_not?: InputMaybe<Scalars['String']>;
  elementQuestionText_not_contains?: InputMaybe<Scalars['String']>;
  elementQuestionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateTrueFalseCardsLinkingCollections = {
  __typename?: 'TemplateTrueFalseCardsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateTrueFalseCardsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateTrueFalseCardsLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateTrueFalseCardsOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementQuestionTextAsc = 'elementQuestionText_ASC',
  ElementQuestionTextDesc = 'elementQuestionText_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Adds a template for a large video [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateVideo) */
export type TemplateVideo = Entry & {
  __typename?: 'TemplateVideo';
  contentfulMetadata: ContentfulMetadata;
  elementId?: Maybe<Scalars['String']>;
  elementText?: Maybe<TemplateVideoElementText>;
  elementTitle?: Maybe<Scalars['String']>;
  elementVideoSource?: Maybe<Scalars['String']>;
  elementVideoTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TemplateVideoLinkingCollections>;
  sys: Sys;
};


/** Adds a template for a large video [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateVideo) */
export type TemplateVideoElementIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a large video [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateVideo) */
export type TemplateVideoElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a large video [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateVideo) */
export type TemplateVideoElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a large video [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateVideo) */
export type TemplateVideoElementVideoSourceArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a large video [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateVideo) */
export type TemplateVideoElementVideoTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Adds a template for a large video [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/templateVideo) */
export type TemplateVideoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TemplateVideoCollection = {
  __typename?: 'TemplateVideoCollection';
  items: Array<Maybe<TemplateVideo>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TemplateVideoElementText = {
  __typename?: 'TemplateVideoElementText';
  json: Scalars['JSON'];
  links: TemplateVideoElementTextLinks;
};

export type TemplateVideoElementTextAssets = {
  __typename?: 'TemplateVideoElementTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TemplateVideoElementTextEntries = {
  __typename?: 'TemplateVideoElementTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TemplateVideoElementTextLinks = {
  __typename?: 'TemplateVideoElementTextLinks';
  assets: TemplateVideoElementTextAssets;
  entries: TemplateVideoElementTextEntries;
};

export type TemplateVideoFilter = {
  AND?: InputMaybe<Array<InputMaybe<TemplateVideoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateVideoFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle?: InputMaybe<Scalars['String']>;
  elementTitle_contains?: InputMaybe<Scalars['String']>;
  elementTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementTitle_not?: InputMaybe<Scalars['String']>;
  elementTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementVideoSource?: InputMaybe<Scalars['String']>;
  elementVideoSource_contains?: InputMaybe<Scalars['String']>;
  elementVideoSource_exists?: InputMaybe<Scalars['Boolean']>;
  elementVideoSource_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementVideoSource_not?: InputMaybe<Scalars['String']>;
  elementVideoSource_not_contains?: InputMaybe<Scalars['String']>;
  elementVideoSource_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementVideoTitle?: InputMaybe<Scalars['String']>;
  elementVideoTitle_contains?: InputMaybe<Scalars['String']>;
  elementVideoTitle_exists?: InputMaybe<Scalars['Boolean']>;
  elementVideoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementVideoTitle_not?: InputMaybe<Scalars['String']>;
  elementVideoTitle_not_contains?: InputMaybe<Scalars['String']>;
  elementVideoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TemplateVideoLinkingCollections = {
  __typename?: 'TemplateVideoLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
};


export type TemplateVideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TemplateVideoLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TemplateVideoOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  ElementTitleAsc = 'elementTitle_ASC',
  ElementTitleDesc = 'elementTitle_DESC',
  ElementVideoSourceAsc = 'elementVideoSource_ASC',
  ElementVideoSourceDesc = 'elementVideoSource_DESC',
  ElementVideoTitleAsc = 'elementVideoTitle_ASC',
  ElementVideoTitleDesc = 'elementVideoTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Tenant = {
  __typename?: 'Tenant';
  groupCount?: Maybe<Scalars['Int']>;
  tenantId?: Maybe<Scalars['String']>;
  tenantInternalId?: Maybe<Scalars['String']>;
};

export type TenantCondition = {
  groupCount?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['String']>;
  tenantInternalId?: InputMaybe<Scalars['String']>;
};

export type TenantFilter = {
  and?: InputMaybe<Array<TenantFilter>>;
  groupCount?: InputMaybe<IntFilter>;
  not?: InputMaybe<TenantFilter>;
  or?: InputMaybe<Array<TenantFilter>>;
  tenantId?: InputMaybe<StringFilter>;
  tenantInternalId?: InputMaybe<StringFilter>;
};

export type TenantsConnection = {
  __typename?: 'TenantsConnection';
  edges: Array<TenantsEdge>;
  nodes: Array<Maybe<Tenant>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TenantsEdge = {
  __typename?: 'TenantsEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Tenant>;
};

export type TenantsGroup = {
  __typename?: 'TenantsGroup';
  course?: Maybe<CourseType>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  group?: Maybe<Group>;
  groupId: Scalars['String'];
  tenantId?: Maybe<Scalars['String']>;
  tenantInternalId?: Maybe<Scalars['String']>;
};

export type TenantsGroupCondition = {
  course?: InputMaybe<CourseType>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  groupId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  tenantInternalId?: InputMaybe<Scalars['String']>;
};

export type TenantsGroupFilter = {
  and?: InputMaybe<Array<TenantsGroupFilter>>;
  course?: InputMaybe<CourseTypeFilter>;
  createdAt?: InputMaybe<AwsDateTimeFilter>;
  groupId?: InputMaybe<StringFilter>;
  not?: InputMaybe<TenantsGroupFilter>;
  or?: InputMaybe<Array<TenantsGroupFilter>>;
  tenantId?: InputMaybe<StringFilter>;
  tenantInternalId?: InputMaybe<StringFilter>;
};

export type TenantsGroupInput = {
  course?: InputMaybe<CourseType>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  groupId: Scalars['String'];
  tenantId?: InputMaybe<Scalars['String']>;
  tenantInternalId?: InputMaybe<Scalars['String']>;
};

export type TenantsGroupsConnection = {
  __typename?: 'TenantsGroupsConnection';
  edges: Array<TenantsGroupsEdge>;
  nodes: Array<Maybe<TenantsGroup>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TenantsGroupsEdge = {
  __typename?: 'TenantsGroupsEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<TenantsGroup>;
};

export enum TenantsGroupsOrderBy {
  CourseAsc = 'COURSE_ASC',
  CourseDesc = 'COURSE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GroupByGroupIdCreatedAtAsc = 'GROUP_BY_GROUP_ID__CREATED_AT_ASC',
  GroupByGroupIdCreatedAtDesc = 'GROUP_BY_GROUP_ID__CREATED_AT_DESC',
  GroupByGroupIdDescriptionAsc = 'GROUP_BY_GROUP_ID__DESCRIPTION_ASC',
  GroupByGroupIdDescriptionDesc = 'GROUP_BY_GROUP_ID__DESCRIPTION_DESC',
  GroupByGroupIdNameAsc = 'GROUP_BY_GROUP_ID__NAME_ASC',
  GroupByGroupIdNameDesc = 'GROUP_BY_GROUP_ID__NAME_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  Natural = 'NATURAL',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TenantInternalIdAsc = 'TENANT_INTERNAL_ID_ASC',
  TenantInternalIdDesc = 'TENANT_INTERNAL_ID_DESC'
}

export enum TenantsOrderBy {
  GroupCountAsc = 'GROUP_COUNT_ASC',
  GroupCountDesc = 'GROUP_COUNT_DESC',
  Natural = 'NATURAL',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TenantInternalIdAsc = 'TENANT_INTERNAL_ID_ASC',
  TenantInternalIdDesc = 'TENANT_INTERNAL_ID_DESC'
}

/** Creates a testing multiple choice question with one correct answer. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/testingMpcOneCorrect) */
export type TestingMpcOneCorrect = Entry & {
  __typename?: 'TestingMpcOneCorrect';
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<TestingMpcOneCorrectLinkingCollections>;
  sys: Sys;
  testingChild?: Maybe<Scalars['JSON']>;
  testingQuestion?: Maybe<Scalars['String']>;
};


/** Creates a testing multiple choice question with one correct answer. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/testingMpcOneCorrect) */
export type TestingMpcOneCorrectLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Creates a testing multiple choice question with one correct answer. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/testingMpcOneCorrect) */
export type TestingMpcOneCorrectTestingChildArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a testing multiple choice question with one correct answer. [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/testingMpcOneCorrect) */
export type TestingMpcOneCorrectTestingQuestionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type TestingMpcOneCorrectCollection = {
  __typename?: 'TestingMpcOneCorrectCollection';
  items: Array<Maybe<TestingMpcOneCorrect>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TestingMpcOneCorrectFilter = {
  AND?: InputMaybe<Array<InputMaybe<TestingMpcOneCorrectFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TestingMpcOneCorrectFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  testingChild_exists?: InputMaybe<Scalars['Boolean']>;
  testingQuestion?: InputMaybe<Scalars['String']>;
  testingQuestion_contains?: InputMaybe<Scalars['String']>;
  testingQuestion_exists?: InputMaybe<Scalars['Boolean']>;
  testingQuestion_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  testingQuestion_not?: InputMaybe<Scalars['String']>;
  testingQuestion_not_contains?: InputMaybe<Scalars['String']>;
  testingQuestion_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TestingMpcOneCorrectLinkingCollections = {
  __typename?: 'TestingMpcOneCorrectLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type TestingMpcOneCorrectLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TestingMpcOneCorrectOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TestingQuestionAsc = 'testingQuestion_ASC',
  TestingQuestionDesc = 'testingQuestion_DESC'
}

/** Creates a tag [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/topicTag) */
export type TopicTag = Entry & {
  __typename?: 'TopicTag';
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<TopicTagLinkingCollections>;
  sys: Sys;
  tagId?: Maybe<Scalars['String']>;
  tagName?: Maybe<Scalars['String']>;
  tagReference?: Maybe<TopicTag>;
  tagType?: Maybe<Scalars['String']>;
};


/** Creates a tag [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/topicTag) */
export type TopicTagLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Creates a tag [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/topicTag) */
export type TopicTagTagIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a tag [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/topicTag) */
export type TopicTagTagNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Creates a tag [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/topicTag) */
export type TopicTagTagReferenceArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Creates a tag [See type definition](https://app.contentful.com/spaces/urvkzvnatoz5/content_types/topicTag) */
export type TopicTagTagTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type TopicTagCollection = {
  __typename?: 'TopicTagCollection';
  items: Array<Maybe<TopicTag>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TopicTagFilter = {
  AND?: InputMaybe<Array<InputMaybe<TopicTagFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TopicTagFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  tagId?: InputMaybe<Scalars['String']>;
  tagId_contains?: InputMaybe<Scalars['String']>;
  tagId_exists?: InputMaybe<Scalars['Boolean']>;
  tagId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagId_not?: InputMaybe<Scalars['String']>;
  tagId_not_contains?: InputMaybe<Scalars['String']>;
  tagId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagName?: InputMaybe<Scalars['String']>;
  tagName_contains?: InputMaybe<Scalars['String']>;
  tagName_exists?: InputMaybe<Scalars['Boolean']>;
  tagName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagName_not?: InputMaybe<Scalars['String']>;
  tagName_not_contains?: InputMaybe<Scalars['String']>;
  tagName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagReference?: InputMaybe<CfTopicTagNestedFilter>;
  tagReference_exists?: InputMaybe<Scalars['Boolean']>;
  tagType?: InputMaybe<Scalars['String']>;
  tagType_contains?: InputMaybe<Scalars['String']>;
  tagType_exists?: InputMaybe<Scalars['Boolean']>;
  tagType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagType_not?: InputMaybe<Scalars['String']>;
  tagType_not_contains?: InputMaybe<Scalars['String']>;
  tagType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TopicTagLinkingCollections = {
  __typename?: 'TopicTagLinkingCollections';
  academyCollection?: Maybe<AcademyCollection>;
  entryCollection?: Maybe<EntryCollection>;
  interventionCollection?: Maybe<InterventionCollection>;
  topicTagCollection?: Maybe<TopicTagCollection>;
};


export type TopicTagLinkingCollectionsAcademyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TopicTagLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TopicTagLinkingCollectionsInterventionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TopicTagLinkingCollectionsTopicTagCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TopicTagOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TagIdAsc = 'tagId_ASC',
  TagIdDesc = 'tagId_DESC',
  TagNameAsc = 'tagName_ASC',
  TagNameDesc = 'tagName_DESC',
  TagTypeAsc = 'tagType_ASC',
  TagTypeDesc = 'tagType_DESC'
}

export type UpdateAttributeByCognitoNameInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  cognitoName: Scalars['String'];
  patch: AttributePatch;
};

export type UpdateAttributeByKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: AttributePatch;
};

export type UpdateAttributeByNodeIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['ID'];
  patch: AttributePatch;
};

export type UpdateAttributeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  patch: AttributePatch;
};

export type UpdateAttributePayload = {
  __typename?: 'UpdateAttributePayload';
  attribute?: Maybe<Attribute>;
  attributeEdge?: Maybe<AttributesEdge>;
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};


export type UpdateAttributePayloadAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<AttributesOrderBy>>;
};

export type UpdateGroupByNodeIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['ID'];
  patch: GroupPatch;
};

export type UpdateGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  patch: GroupPatch;
};

export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  groupEdge?: Maybe<GroupsEdge>;
  query?: Maybe<Query>;
};


export type UpdateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

export type UpdateUserByNodeIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['ID'];
  patch: UserPatch;
};

export type UpdateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  patch: UserPatch;
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
  userEdge?: Maybe<UsersEdge>;
};


export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type User = Node & {
  __typename?: 'User';
  attributes?: Maybe<Scalars['AWSJSON']>;
  createdAt?: Maybe<Scalars['AWSDateTime']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  groupsUsers: GroupsUsersConnection;
  id: Scalars['ID'];
  nodeId: Scalars['ID'];
};


export type UserGroupsUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<GroupsUserCondition>;
  filter?: InputMaybe<GroupsUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsUsersOrderBy>>;
};

export type UserCondition = {
  attributes?: InputMaybe<Scalars['AWSJSON']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UserFilter = {
  and?: InputMaybe<Array<UserFilter>>;
  attributes?: InputMaybe<AwsjsonFilter>;
  createdAt?: InputMaybe<AwsDateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  familyName?: InputMaybe<StringFilter>;
  givenName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  not?: InputMaybe<UserFilter>;
  or?: InputMaybe<Array<UserFilter>>;
};

export type UserInput = {
  attributes?: InputMaybe<Scalars['AWSJSON']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UserPatch = {
  attributes?: InputMaybe<Scalars['AWSJSON']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UsersConnection = {
  __typename?: 'UsersConnection';
  edges: Array<UsersEdge>;
  nodes: Array<Maybe<User>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UsersEdge = {
  __typename?: 'UsersEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<User>;
};

export enum UsersOrderBy {
  AttributesAsc = 'ATTRIBUTES_ASC',
  AttributesDesc = 'ATTRIBUTES_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FamilyNameAsc = 'FAMILY_NAME_ASC',
  FamilyNameDesc = 'FAMILY_NAME_DESC',
  GivenNameAsc = 'GIVEN_NAME_ASC',
  GivenNameDesc = 'GIVEN_NAME_DESC',
  GroupsUsersByUserIdCountAsc = 'GROUPS_USERS_BY_USER_ID__COUNT_ASC',
  GroupsUsersByUserIdCountDesc = 'GROUPS_USERS_BY_USER_ID__COUNT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type CfContentOwnerNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfContentOwnerNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfContentOwnerNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contentownerImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentownerJobtitle?: InputMaybe<Scalars['String']>;
  contentownerJobtitle_contains?: InputMaybe<Scalars['String']>;
  contentownerJobtitle_exists?: InputMaybe<Scalars['Boolean']>;
  contentownerJobtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentownerJobtitle_not?: InputMaybe<Scalars['String']>;
  contentownerJobtitle_not_contains?: InputMaybe<Scalars['String']>;
  contentownerJobtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentownerName?: InputMaybe<Scalars['String']>;
  contentownerName_contains?: InputMaybe<Scalars['String']>;
  contentownerName_exists?: InputMaybe<Scalars['Boolean']>;
  contentownerName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentownerName_not?: InputMaybe<Scalars['String']>;
  contentownerName_not_contains?: InputMaybe<Scalars['String']>;
  contentownerName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentownerUrl?: InputMaybe<Scalars['String']>;
  contentownerUrl_contains?: InputMaybe<Scalars['String']>;
  contentownerUrl_exists?: InputMaybe<Scalars['Boolean']>;
  contentownerUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentownerUrl_not?: InputMaybe<Scalars['String']>;
  contentownerUrl_not_contains?: InputMaybe<Scalars['String']>;
  contentownerUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Scalars['String']>;
  email_contains?: InputMaybe<Scalars['String']>;
  email_exists?: InputMaybe<Scalars['Boolean']>;
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email_not?: InputMaybe<Scalars['String']>;
  email_not_contains?: InputMaybe<Scalars['String']>;
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  telephone?: InputMaybe<Scalars['String']>;
  telephone_contains?: InputMaybe<Scalars['String']>;
  telephone_exists?: InputMaybe<Scalars['Boolean']>;
  telephone_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  telephone_not?: InputMaybe<Scalars['String']>;
  telephone_not_contains?: InputMaybe<Scalars['String']>;
  telephone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfElementTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfElementTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfElementTextNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  downloadFile_exists?: InputMaybe<Scalars['Boolean']>;
  downloadTitle?: InputMaybe<Scalars['String']>;
  downloadTitle_contains?: InputMaybe<Scalars['String']>;
  downloadTitle_exists?: InputMaybe<Scalars['Boolean']>;
  downloadTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  downloadTitle_not?: InputMaybe<Scalars['String']>;
  downloadTitle_not_contains?: InputMaybe<Scalars['String']>;
  downloadTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementText_contains?: InputMaybe<Scalars['String']>;
  elementText_exists?: InputMaybe<Scalars['Boolean']>;
  elementText_not_contains?: InputMaybe<Scalars['String']>;
  externalEmbedLink_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfExternalLinkEmbedNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfExternalLinkEmbedNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfExternalLinkEmbedNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  coverImage?: InputMaybe<Scalars['Boolean']>;
  coverImage_exists?: InputMaybe<Scalars['Boolean']>;
  coverImage_not?: InputMaybe<Scalars['Boolean']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementId_contains?: InputMaybe<Scalars['String']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  elementId_not?: InputMaybe<Scalars['String']>;
  elementId_not_contains?: InputMaybe<Scalars['String']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  embedDuration?: InputMaybe<Scalars['Int']>;
  embedDuration_exists?: InputMaybe<Scalars['Boolean']>;
  embedDuration_gt?: InputMaybe<Scalars['Int']>;
  embedDuration_gte?: InputMaybe<Scalars['Int']>;
  embedDuration_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  embedDuration_lt?: InputMaybe<Scalars['Int']>;
  embedDuration_lte?: InputMaybe<Scalars['Int']>;
  embedDuration_not?: InputMaybe<Scalars['Int']>;
  embedDuration_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  embedImage_exists?: InputMaybe<Scalars['Boolean']>;
  embedTitle?: InputMaybe<Scalars['String']>;
  embedTitle_contains?: InputMaybe<Scalars['String']>;
  embedTitle_exists?: InputMaybe<Scalars['Boolean']>;
  embedTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  embedTitle_not?: InputMaybe<Scalars['String']>;
  embedTitle_not_contains?: InputMaybe<Scalars['String']>;
  embedTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  embedType?: InputMaybe<Scalars['String']>;
  embedType_contains?: InputMaybe<Scalars['String']>;
  embedType_exists?: InputMaybe<Scalars['Boolean']>;
  embedType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  embedType_not?: InputMaybe<Scalars['String']>;
  embedType_not_contains?: InputMaybe<Scalars['String']>;
  embedType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  embedUrl?: InputMaybe<Scalars['String']>;
  embedUrl_contains?: InputMaybe<Scalars['String']>;
  embedUrl_exists?: InputMaybe<Scalars['Boolean']>;
  embedUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  embedUrl_not?: InputMaybe<Scalars['String']>;
  embedUrl_not_contains?: InputMaybe<Scalars['String']>;
  embedUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  registerCompletion?: InputMaybe<Scalars['Boolean']>;
  registerCompletion_exists?: InputMaybe<Scalars['Boolean']>;
  registerCompletion_not?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfInterventionNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfInterventionNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfInterventionNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  coverImage?: InputMaybe<Scalars['Boolean']>;
  coverImage_exists?: InputMaybe<Scalars['Boolean']>;
  coverImage_not?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalId_contains?: InputMaybe<Scalars['String']>;
  externalId_exists?: InputMaybe<Scalars['Boolean']>;
  externalId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalId_not?: InputMaybe<Scalars['String']>;
  externalId_not_contains?: InputMaybe<Scalars['String']>;
  externalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionContentowner_exists?: InputMaybe<Scalars['Boolean']>;
  interventionDuration?: InputMaybe<Scalars['Int']>;
  interventionDuration_exists?: InputMaybe<Scalars['Boolean']>;
  interventionDuration_gt?: InputMaybe<Scalars['Int']>;
  interventionDuration_gte?: InputMaybe<Scalars['Int']>;
  interventionDuration_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  interventionDuration_lt?: InputMaybe<Scalars['Int']>;
  interventionDuration_lte?: InputMaybe<Scalars['Int']>;
  interventionDuration_not?: InputMaybe<Scalars['Int']>;
  interventionDuration_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  interventionId?: InputMaybe<Scalars['String']>;
  interventionId_contains?: InputMaybe<Scalars['String']>;
  interventionId_exists?: InputMaybe<Scalars['Boolean']>;
  interventionId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionId_not?: InputMaybe<Scalars['String']>;
  interventionId_not_contains?: InputMaybe<Scalars['String']>;
  interventionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionImage_exists?: InputMaybe<Scalars['Boolean']>;
  interventionLevel?: InputMaybe<Scalars['String']>;
  interventionLevel_contains?: InputMaybe<Scalars['String']>;
  interventionLevel_exists?: InputMaybe<Scalars['Boolean']>;
  interventionLevel_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionLevel_not?: InputMaybe<Scalars['String']>;
  interventionLevel_not_contains?: InputMaybe<Scalars['String']>;
  interventionLevel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionStatusEnddate?: InputMaybe<Scalars['DateTime']>;
  interventionStatusEnddate_exists?: InputMaybe<Scalars['Boolean']>;
  interventionStatusEnddate_gt?: InputMaybe<Scalars['DateTime']>;
  interventionStatusEnddate_gte?: InputMaybe<Scalars['DateTime']>;
  interventionStatusEnddate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  interventionStatusEnddate_lt?: InputMaybe<Scalars['DateTime']>;
  interventionStatusEnddate_lte?: InputMaybe<Scalars['DateTime']>;
  interventionStatusEnddate_not?: InputMaybe<Scalars['DateTime']>;
  interventionStatusEnddate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  interventionStatusLabel?: InputMaybe<Scalars['String']>;
  interventionStatusLabel_contains?: InputMaybe<Scalars['String']>;
  interventionStatusLabel_exists?: InputMaybe<Scalars['Boolean']>;
  interventionStatusLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionStatusLabel_not?: InputMaybe<Scalars['String']>;
  interventionStatusLabel_not_contains?: InputMaybe<Scalars['String']>;
  interventionStatusLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionSurtitle?: InputMaybe<Scalars['String']>;
  interventionSurtitle_contains?: InputMaybe<Scalars['String']>;
  interventionSurtitle_exists?: InputMaybe<Scalars['Boolean']>;
  interventionSurtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionSurtitle_not?: InputMaybe<Scalars['String']>;
  interventionSurtitle_not_contains?: InputMaybe<Scalars['String']>;
  interventionSurtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionTemplatesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  interventionText?: InputMaybe<Scalars['String']>;
  interventionText_contains?: InputMaybe<Scalars['String']>;
  interventionText_exists?: InputMaybe<Scalars['Boolean']>;
  interventionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionText_not?: InputMaybe<Scalars['String']>;
  interventionText_not_contains?: InputMaybe<Scalars['String']>;
  interventionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionTitle?: InputMaybe<Scalars['String']>;
  interventionTitle_contains?: InputMaybe<Scalars['String']>;
  interventionTitle_exists?: InputMaybe<Scalars['Boolean']>;
  interventionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionTitle_not?: InputMaybe<Scalars['String']>;
  interventionTitle_not_contains?: InputMaybe<Scalars['String']>;
  interventionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionTopicsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  interventionType?: InputMaybe<Scalars['String']>;
  interventionType_contains?: InputMaybe<Scalars['String']>;
  interventionType_exists?: InputMaybe<Scalars['Boolean']>;
  interventionType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionType_not?: InputMaybe<Scalars['String']>;
  interventionType_not_contains?: InputMaybe<Scalars['String']>;
  interventionType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skillTagsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  tenantCollection_exists?: InputMaybe<Scalars['Boolean']>;
};

export type CfTopicTagNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTopicTagNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTopicTagNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  tagId?: InputMaybe<Scalars['String']>;
  tagId_contains?: InputMaybe<Scalars['String']>;
  tagId_exists?: InputMaybe<Scalars['Boolean']>;
  tagId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagId_not?: InputMaybe<Scalars['String']>;
  tagId_not_contains?: InputMaybe<Scalars['String']>;
  tagId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagName?: InputMaybe<Scalars['String']>;
  tagName_contains?: InputMaybe<Scalars['String']>;
  tagName_exists?: InputMaybe<Scalars['Boolean']>;
  tagName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagName_not?: InputMaybe<Scalars['String']>;
  tagName_not_contains?: InputMaybe<Scalars['String']>;
  tagName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagReference_exists?: InputMaybe<Scalars['Boolean']>;
  tagType?: InputMaybe<Scalars['String']>;
  tagType_contains?: InputMaybe<Scalars['String']>;
  tagType_exists?: InputMaybe<Scalars['Boolean']>;
  tagType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagType_not?: InputMaybe<Scalars['String']>;
  tagType_not_contains?: InputMaybe<Scalars['String']>;
  tagType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GetAttributesQueryVariables = Exact<{
  filter?: InputMaybe<AttributeFilter>;
}>;


export type GetAttributesQuery = { __typename?: 'Query', attributes?: { __typename?: 'AttributesConnection', totalCount: number, nodes: Array<{ __typename?: 'Attribute', id: string, cognitoName?: string | null, key: string, name?: string | null, description?: string | null, enabled: boolean, requiredImport: boolean } | null> } | null };

export type CreateAttributeMutationVariables = Exact<{
  input: CreateAttributeInput;
}>;


export type CreateAttributeMutation = { __typename?: 'Mutation', createAttribute?: { __typename?: 'CreateAttributePayload', attribute?: { __typename?: 'Attribute', id: string } | null } | null };

export type UpdateAttributeMutationVariables = Exact<{
  input: UpdateAttributeInput;
}>;


export type UpdateAttributeMutation = { __typename?: 'Mutation', updateAttribute?: { __typename?: 'UpdateAttributePayload', attribute?: { __typename?: 'Attribute', id: string } | null } | null };

export type GetCatalogueItemsQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  order?: InputMaybe<Array<InputMaybe<LearningConceptOrder>> | InputMaybe<LearningConceptOrder>>;
}>;


export type GetCatalogueItemsQuery = { __typename?: 'Query', learningConceptCollection?: { __typename?: 'LearningConceptCollection', total: number, items: Array<{ __typename?: 'LearningConcept', id?: string | null, type?: string | null, title?: string | null, description?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetCatalogueItemsFilteredQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  where: LearningConceptFilter;
  order?: InputMaybe<Array<InputMaybe<LearningConceptOrder>> | InputMaybe<LearningConceptOrder>>;
}>;


export type GetCatalogueItemsFilteredQuery = { __typename?: 'Query', learningConceptCollection?: { __typename?: 'LearningConceptCollection', total: number, items: Array<{ __typename?: 'LearningConcept', id?: string | null, type?: string | null, title?: string | null, description?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetCatalogueItemQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCatalogueItemQuery = { __typename?: 'Query', learningConcept?: { __typename?: 'LearningConcept', id?: string | null, type?: string | null, title?: string | null, description?: string | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetCatalogueItemsGroupCountsQueryVariables = Exact<{
  filter: CatalogueItemFilter;
}>;


export type GetCatalogueItemsGroupCountsQuery = { __typename?: 'Query', catalogueItems?: { __typename?: 'CatalogueItemsConnection', nodes: Array<{ __typename?: 'CatalogueItem', catalogueItemId?: string | null, groupCount?: number | null } | null> } | null };

export type GetGroupsInCatalogueItemQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  condition: CatalogueItemsGroupCondition;
}>;


export type GetGroupsInCatalogueItemQuery = { __typename?: 'Query', catalogueItemsGroups?: { __typename?: 'CatalogueItemsGroupsConnection', totalCount: number, nodes: Array<{ __typename?: 'CatalogueItemsGroup', course?: CourseType | null, group?: { __typename?: 'Group', name: string, description?: string | null, groupsUsers: { __typename?: 'GroupsUsersConnection', totalCount: number }, catalogueItemsGroups: { __typename?: 'CatalogueItemsGroupsConnection', totalCount: number }, tenantsGroups: { __typename?: 'TenantsGroupsConnection', totalCount: number } } | null } | null> } | null };

export type GetCatalogueItemsForGroupQueryVariables = Exact<{
  condition: CatalogueItemsGroupCondition;
}>;


export type GetCatalogueItemsForGroupQuery = { __typename?: 'Query', catalogueItemsGroups?: { __typename?: 'CatalogueItemsGroupsConnection', totalCount: number, nodes: Array<{ __typename?: 'CatalogueItemsGroup', catalogueItemId?: string | null } | null> } | null };

export type GetCatalogueItemsForGroupFilteredQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  condition: CatalogueItemsGroupCondition;
}>;


export type GetCatalogueItemsForGroupFilteredQuery = { __typename?: 'Query', catalogueItemsGroups?: { __typename?: 'CatalogueItemsGroupsConnection', totalCount: number, nodes: Array<{ __typename?: 'CatalogueItemsGroup', course?: CourseType | null, catalogueItemId?: string | null } | null> } | null };

export type AddGroupToCatalogueItemMutationVariables = Exact<{
  input: CreateCatalogueItemsGroupInput;
}>;


export type AddGroupToCatalogueItemMutation = { __typename?: 'Mutation', createCatalogueItemsGroup?: { __typename?: 'CreateCatalogueItemsGroupPayload', catalogueItemsGroup?: { __typename?: 'CatalogueItemsGroup', catalogueItemId?: string | null, groupId: string, course?: CourseType | null } | null } | null };

export type RemoveGroupFromCatalogueItemMutationVariables = Exact<{
  input: RemoveGroupFromCatalogueItemInput;
}>;


export type RemoveGroupFromCatalogueItemMutation = { __typename?: 'Mutation', removeGroupFromCatalogueItem?: { __typename?: 'RemoveGroupFromCatalogueItemPayload', catalogueItemsGroup?: { __typename?: 'CatalogueItemsGroup', catalogueItemId?: string | null, groupId: string } | null } | null };

export type GetStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatsQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number } | null, groups?: { __typename?: 'GroupsConnection', totalCount: number } | null };

export type GetGroupsQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  order?: InputMaybe<Array<GroupsOrderBy> | GroupsOrderBy>;
}>;


export type GetGroupsQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsConnection', totalCount: number, nodes: Array<{ __typename?: 'Group', name: string, description?: string | null, groupsUsers: { __typename?: 'GroupsUsersConnection', totalCount: number }, catalogueItemsGroups: { __typename?: 'CatalogueItemsGroupsConnection', totalCount: number }, tenantsGroups: { __typename?: 'TenantsGroupsConnection', totalCount: number } } | null> } | null };

export type GetAllGroupsImportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGroupsImportQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsConnection', totalCount: number, nodes: Array<{ __typename?: 'Group', name: string } | null> } | null };

export type GetGroupsFilteredQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  order?: InputMaybe<Array<GroupsOrderBy> | GroupsOrderBy>;
  filter: GroupFilter;
}>;


export type GetGroupsFilteredQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsConnection', totalCount: number, nodes: Array<{ __typename?: 'Group', name: string, description?: string | null, groupsUsers: { __typename?: 'GroupsUsersConnection', totalCount: number }, catalogueItemsGroups: { __typename?: 'CatalogueItemsGroupsConnection', totalCount: number }, tenantsGroups: { __typename?: 'TenantsGroupsConnection', totalCount: number } } | null> } | null };

export type GetGroupsForUserQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  condition: GroupsUserCondition;
}>;


export type GetGroupsForUserQuery = { __typename?: 'Query', groupsUsers?: { __typename?: 'GroupsUsersConnection', totalCount: number, nodes: Array<{ __typename?: 'GroupsUser', group?: { __typename?: 'Group', name: string, description?: string | null, groupsUsers: { __typename?: 'GroupsUsersConnection', totalCount: number }, catalogueItemsGroups: { __typename?: 'CatalogueItemsGroupsConnection', totalCount: number }, tenantsGroups: { __typename?: 'TenantsGroupsConnection', totalCount: number } } | null } | null> } | null };

export type GetUsersGroupsQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetUsersGroupsQuery = { __typename?: 'Query', groupsUsers?: { __typename?: 'GroupsUsersConnection', totalCount: number, nodes: Array<{ __typename?: 'GroupsUser', user?: { __typename?: 'User', id: string } | null, group?: { __typename?: 'Group', name: string } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup?: { __typename?: 'CreateGroupPayload', group?: { __typename?: 'Group', name: string, description?: string | null } | null } | null };

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup?: { __typename?: 'UpdateGroupPayload', group?: { __typename?: 'Group', name: string, description?: string | null } | null } | null };

export type DeleteGroupMutationVariables = Exact<{
  input: DeleteGroupInput;
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', deleteGroup?: { __typename?: 'DeleteGroupPayload', group?: { __typename?: 'Group', name: string, description?: string | null } | null } | null };

export type AddUserToGroupMutationVariables = Exact<{
  input: CreateGroupsUserInput;
}>;


export type AddUserToGroupMutation = { __typename?: 'Mutation', createGroupsUser?: { __typename?: 'CreateGroupsUserPayload', groupsUser?: { __typename?: 'GroupsUser', groupId: string, userId: string } | null } | null };

export type RemoveUserFromGroupMutationVariables = Exact<{
  input: RemoveUserFromGroupInput;
}>;


export type RemoveUserFromGroupMutation = { __typename?: 'Mutation', removeUserFromGroup?: { __typename?: 'RemoveUserFromGroupPayload', groupsUser?: { __typename?: 'GroupsUser', groupId: string, userId: string } | null } | null };

export type GetTenantsQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  order?: InputMaybe<Array<InputMaybe<AcademyOrder>> | InputMaybe<AcademyOrder>>;
}>;


export type GetTenantsQuery = { __typename?: 'Query', academyCollection?: { __typename?: 'AcademyCollection', total: number, items: Array<{ __typename?: 'Academy', academyId?: string | null, academyTitle?: string | null, isPrimary?: boolean | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetTenantsFilteredQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  where: AcademyFilter;
  order?: InputMaybe<Array<InputMaybe<AcademyOrder>> | InputMaybe<AcademyOrder>>;
}>;


export type GetTenantsFilteredQuery = { __typename?: 'Query', academyCollection?: { __typename?: 'AcademyCollection', total: number, items: Array<{ __typename?: 'Academy', academyId?: string | null, academyTitle?: string | null, isPrimary?: boolean | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetTenantQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTenantQuery = { __typename?: 'Query', academy?: { __typename?: 'Academy', academyId?: string | null, academyTitle?: string | null, isPrimary?: boolean | null, sys: { __typename?: 'Sys', id: string } } | null };

export type GetTenantsGroupCountsQueryVariables = Exact<{
  filter: TenantFilter;
}>;


export type GetTenantsGroupCountsQuery = { __typename?: 'Query', tenants?: { __typename?: 'TenantsConnection', nodes: Array<{ __typename?: 'Tenant', tenantId?: string | null, tenantInternalId?: string | null, groupCount?: number | null } | null> } | null };

export type GetGroupsInTenantQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  condition: TenantsGroupCondition;
}>;


export type GetGroupsInTenantQuery = { __typename?: 'Query', tenantsGroups?: { __typename?: 'TenantsGroupsConnection', totalCount: number, nodes: Array<{ __typename?: 'TenantsGroup', course?: CourseType | null, group?: { __typename?: 'Group', name: string, description?: string | null, groupsUsers: { __typename?: 'GroupsUsersConnection', totalCount: number }, tenantsGroups: { __typename?: 'TenantsGroupsConnection', totalCount: number }, catalogueItemsGroups: { __typename?: 'CatalogueItemsGroupsConnection', totalCount: number } } | null } | null> } | null };

export type GetTenantsForGroupQueryVariables = Exact<{
  condition: TenantsGroupCondition;
}>;


export type GetTenantsForGroupQuery = { __typename?: 'Query', tenantsGroups?: { __typename?: 'TenantsGroupsConnection', totalCount: number, nodes: Array<{ __typename?: 'TenantsGroup', tenantId?: string | null, tenantInternalId?: string | null } | null> } | null };

export type GetTenantsForGroupFilteredQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  condition: TenantsGroupCondition;
}>;


export type GetTenantsForGroupFilteredQuery = { __typename?: 'Query', tenantsGroups?: { __typename?: 'TenantsGroupsConnection', totalCount: number, nodes: Array<{ __typename?: 'TenantsGroup', course?: CourseType | null, tenantId?: string | null, tenantInternalId?: string | null } | null> } | null };

export type AddGroupToTenantMutationVariables = Exact<{
  input: CreateTenantsGroupInput;
}>;


export type AddGroupToTenantMutation = { __typename?: 'Mutation', createTenantsGroup?: { __typename?: 'CreateTenantsGroupPayload', tenantsGroup?: { __typename?: 'TenantsGroup', tenantId?: string | null, tenantInternalId?: string | null, groupId: string, course?: CourseType | null } | null } | null };

export type RemoveGroupFromTenantMutationVariables = Exact<{
  input: RemoveGroupFromTenantInput;
}>;


export type RemoveGroupFromTenantMutation = { __typename?: 'Mutation', removeGroupFromTenant?: { __typename?: 'RemoveGroupFromTenantPayload', tenantsGroup?: { __typename?: 'TenantsGroup', tenantInternalId?: string | null, groupId: string } | null } | null };

export type BaseUserFieldsFragment = { __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null, email?: string | null };

export type GroupsUsersFragment = { __typename?: 'User', groupsUsers: { __typename?: 'GroupsUsersConnection', nodes: Array<{ __typename?: 'GroupsUser', groupId: string } | null> } };

export type GroupsUsersFullFragment = { __typename?: 'User', groupsUsers: { __typename?: 'GroupsUsersConnection', nodes: Array<{ __typename?: 'GroupsUser', group?: { __typename?: 'Group', name: string } | null } | null> } };

export type UserAttributesFragment = { __typename?: 'User', attributes?: string | null };

export type GetUsersQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  order?: InputMaybe<Array<UsersOrderBy> | UsersOrderBy>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null, email?: string | null, attributes?: string | null, groupsUsers: { __typename?: 'GroupsUsersConnection', nodes: Array<{ __typename?: 'GroupsUser', groupId: string } | null> } } | null> } | null };

export type GetAllUsersImportQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetAllUsersImportQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null, email?: string | null, attributes?: string | null, groupsUsers: { __typename?: 'GroupsUsersConnection', nodes: Array<{ __typename?: 'GroupsUser', group?: { __typename?: 'Group', name: string } | null } | null> } } | null> } | null };

export type GetUsersFilteredQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  order?: InputMaybe<Array<UsersOrderBy> | UsersOrderBy>;
  filter?: InputMaybe<UserFilter>;
}>;


export type GetUsersFilteredQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null, email?: string | null, attributes?: string | null, groupsUsers: { __typename?: 'GroupsUsersConnection', nodes: Array<{ __typename?: 'GroupsUser', groupId: string } | null> } } | null> } | null };

export type GetUsersInGroupQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  condition: GroupsUserCondition;
}>;


export type GetUsersInGroupQuery = { __typename?: 'Query', groupsUsers?: { __typename?: 'GroupsUsersConnection', totalCount: number, nodes: Array<{ __typename?: 'GroupsUser', user?: { __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null, email?: string | null } | null } | null> } | null };

export type GetCatalogueItemsForUserQueryVariables = Exact<{
  perPage: Scalars['Int'];
  offset: Scalars['Int'];
  condition: GroupsUserCondition;
}>;


export type GetCatalogueItemsForUserQuery = { __typename?: 'Query', groupsUsers?: { __typename?: 'GroupsUsersConnection', totalCount: number, nodes: Array<{ __typename?: 'GroupsUser', group?: { __typename?: 'Group', name: string, catalogueItemsGroups: { __typename?: 'CatalogueItemsGroupsConnection', nodes: Array<{ __typename?: 'CatalogueItemsGroup', catalogueItemId?: string | null, course?: CourseType | null } | null> } } | null } | null> } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'CreateUserPayload', user?: { __typename?: 'User', id: string } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', id: string } | null } | null };

export type DeleteUserMutationVariables = Exact<{
  input: DeleteUserInput;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'DeleteUserPayload', user?: { __typename?: 'User', id: string } | null } | null };

export type SendReminderEmailMutationVariables = Exact<{
  input: SendReminderEmailInput;
}>;


export type SendReminderEmailMutation = { __typename?: 'Mutation', sendReminderEmail?: { __typename?: 'SendReminderEmailPayload', user?: { __typename?: 'User', id: string } | null } | null };

export const BaseUserFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseUserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<BaseUserFieldsFragment, unknown>;
export const GroupsUsersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupsUsers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupsUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}}]}}]}}]}}]} as unknown as DocumentNode<GroupsUsersFragment, unknown>;
export const GroupsUsersFullFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupsUsersFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupsUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GroupsUsersFullFragment, unknown>;
export const UserAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]} as unknown as DocumentNode<UserAttributesFragment, unknown>;
export const GetAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AttributeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cognitoName"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"requiredImport"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetAttributesQuery, GetAttributesQueryVariables>;
export const CreateAttributeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAttribute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAttributeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAttribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAttributeMutation, CreateAttributeMutationVariables>;
export const UpdateAttributeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAttribute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAttributeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAttribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAttributeMutation, UpdateAttributeMutationVariables>;
export const GetCatalogueItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCatalogueItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LearningConceptOrder"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learningConceptCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCatalogueItemsQuery, GetCatalogueItemsQueryVariables>;
export const GetCatalogueItemsFilteredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCatalogueItemsFiltered"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LearningConceptFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LearningConceptOrder"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learningConceptCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCatalogueItemsFilteredQuery, GetCatalogueItemsFilteredQueryVariables>;
export const GetCatalogueItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCatalogueItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learningConcept"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetCatalogueItemQuery, GetCatalogueItemQueryVariables>;
export const GetCatalogueItemsGroupCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCatalogueItemsGroupCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogueItemFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItemId"}},{"kind":"Field","name":{"kind":"Name","value":"groupCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetCatalogueItemsGroupCountsQuery, GetCatalogueItemsGroupCountsQueryVariables>;
export const GetGroupsInCatalogueItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGroupsInCatalogueItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogueItemsGroupCondition"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItemsGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"course"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"groupsUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueItemsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenantsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetGroupsInCatalogueItemQuery, GetGroupsInCatalogueItemQueryVariables>;
export const GetCatalogueItemsForGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCatalogueItemsForGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogueItemsGroupCondition"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItemsGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItemId"}}]}}]}}]}}]} as unknown as DocumentNode<GetCatalogueItemsForGroupQuery, GetCatalogueItemsForGroupQueryVariables>;
export const GetCatalogueItemsForGroupFilteredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCatalogueItemsForGroupFiltered"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogueItemsGroupCondition"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItemsGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"course"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueItemId"}}]}}]}}]}}]} as unknown as DocumentNode<GetCatalogueItemsForGroupFilteredQuery, GetCatalogueItemsForGroupFilteredQueryVariables>;
export const AddGroupToCatalogueItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddGroupToCatalogueItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCatalogueItemsGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCatalogueItemsGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItemsGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItemId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"course"}}]}}]}}]}}]} as unknown as DocumentNode<AddGroupToCatalogueItemMutation, AddGroupToCatalogueItemMutationVariables>;
export const RemoveGroupFromCatalogueItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveGroupFromCatalogueItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveGroupFromCatalogueItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeGroupFromCatalogueItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItemsGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItemId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveGroupFromCatalogueItemMutation, RemoveGroupFromCatalogueItemMutationVariables>;
export const GetStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetStatsQuery, GetStatsQueryVariables>;
export const GetGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"groupsUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueItemsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenantsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetAllGroupsImportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllGroupsImport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetAllGroupsImportQuery, GetAllGroupsImportQueryVariables>;
export const GetGroupsFilteredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGroupsFiltered"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"groupsUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueItemsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenantsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetGroupsFilteredQuery, GetGroupsFilteredQueryVariables>;
export const GetGroupsForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGroupsForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupsUserCondition"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupsUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"groupsUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueItemsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenantsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetGroupsForUserQuery, GetGroupsForUserQueryVariables>;
export const GetUsersGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupsUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetUsersGroupsQuery, GetUsersGroupsQueryVariables>;
export const CreateGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<CreateGroupMutation, CreateGroupMutationVariables>;
export const UpdateGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const DeleteGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const AddUserToGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddUserToGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGroupsUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGroupsUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupsUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<AddUserToGroupMutation, AddUserToGroupMutationVariables>;
export const RemoveUserFromGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserFromGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveUserFromGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserFromGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupsUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>;
export const GetTenantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcademyOrder"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"academyCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"academyId"}},{"kind":"Field","name":{"kind":"Name","value":"academyTitle"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTenantsQuery, GetTenantsQueryVariables>;
export const GetTenantsFilteredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantsFiltered"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcademyFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcademyOrder"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"academyCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"academyId"}},{"kind":"Field","name":{"kind":"Name","value":"academyTitle"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTenantsFilteredQuery, GetTenantsFilteredQueryVariables>;
export const GetTenantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"academy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"academyId"}},{"kind":"Field","name":{"kind":"Name","value":"academyTitle"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetTenantQuery, GetTenantQueryVariables>;
export const GetTenantsGroupCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantsGroupCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TenantFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"tenantInternalId"}},{"kind":"Field","name":{"kind":"Name","value":"groupCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetTenantsGroupCountsQuery, GetTenantsGroupCountsQueryVariables>;
export const GetGroupsInTenantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGroupsInTenant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TenantsGroupCondition"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantsGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"course"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"groupsUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenantsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueItemsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetGroupsInTenantQuery, GetGroupsInTenantQueryVariables>;
export const GetTenantsForGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantsForGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TenantsGroupCondition"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantsGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"tenantInternalId"}}]}}]}}]}}]} as unknown as DocumentNode<GetTenantsForGroupQuery, GetTenantsForGroupQueryVariables>;
export const GetTenantsForGroupFilteredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantsForGroupFiltered"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TenantsGroupCondition"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantsGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"course"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"tenantInternalId"}}]}}]}}]}}]} as unknown as DocumentNode<GetTenantsForGroupFilteredQuery, GetTenantsForGroupFilteredQueryVariables>;
export const AddGroupToTenantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddGroupToTenant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTenantsGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTenantsGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantsGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"tenantInternalId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"course"}}]}}]}}]}}]} as unknown as DocumentNode<AddGroupToTenantMutation, AddGroupToTenantMutationVariables>;
export const RemoveGroupFromTenantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveGroupFromTenant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveGroupFromTenantInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeGroupFromTenant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantsGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantInternalId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveGroupFromTenantMutation, RemoveGroupFromTenantMutationVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseUserFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAttributes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupsUsers"}}]}}]}}]}},...BaseUserFieldsFragmentDoc.definitions,...UserAttributesFragmentDoc.definitions,...GroupsUsersFragmentDoc.definitions]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const GetAllUsersImportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllUsersImport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseUserFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAttributes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupsUsersFull"}}]}}]}}]}},...BaseUserFieldsFragmentDoc.definitions,...UserAttributesFragmentDoc.definitions,...GroupsUsersFullFragmentDoc.definitions]} as unknown as DocumentNode<GetAllUsersImportQuery, GetAllUsersImportQueryVariables>;
export const GetUsersFilteredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersFiltered"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseUserFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAttributes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupsUsers"}}]}}]}}]}},...BaseUserFieldsFragmentDoc.definitions,...UserAttributesFragmentDoc.definitions,...GroupsUsersFragmentDoc.definitions]} as unknown as DocumentNode<GetUsersFilteredQuery, GetUsersFilteredQueryVariables>;
export const GetUsersInGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersInGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupsUserCondition"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupsUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseUserFields"}}]}}]}}]}}]}},...BaseUserFieldsFragmentDoc.definitions]} as unknown as DocumentNode<GetUsersInGroupQuery, GetUsersInGroupQueryVariables>;
export const GetCatalogueItemsForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCatalogueItemsForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupsUserCondition"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupsUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueItemsGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItemId"}},{"kind":"Field","name":{"kind":"Name","value":"course"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCatalogueItemsForUserQuery, GetCatalogueItemsForUserQueryVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const SendReminderEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendReminderEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendReminderEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendReminderEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SendReminderEmailMutation, SendReminderEmailMutationVariables>;